const COMPOSITIONS = new Set(['logo', 'text']);

if (!customElements.get('logo-customiser')) {
  // Scoped inside the guard: this asset is loaded by both new-logo-loader and
  // the customiser section, so anything at top level would redeclare.
  //
  // Retired. Kept only so re-saving a line written while it existed removes
  // it; nothing sets this any more.
  const CUSTOMISATION_COST_PROPERTY = 'Customisation costs included';

  customElements.define(
    'logo-customiser',
    class LogoCustomiser extends HTMLElement {
      connectedCallback() {
        this.routes = {
          cart: '/cart.js',
          change: '/cart/change.js',
        };

        const params = new URLSearchParams(window.location.search);
        const targetLineParam = params.get('line') || this.getAttribute('data-target-line') || '';
        this.targetLine = Number.parseInt(targetLineParam, 10);
        this.targetKey = params.get('key') || this.getAttribute('data-target-key') || null;
        this.targetKeys = this.parseTargetKeys(params.get('target_keys') || this.getAttribute('data-target-keys') || '');
        if (this.targetKey && !this.targetKeys.includes(this.targetKey)) {
          this.targetKeys.unshift(this.targetKey);
        }
        if (!this.targetKey && this.targetKeys.length) {
          this.targetKey = this.targetKeys[0];
        }
        this.modalId = params.get('modal_id') || this.getAttribute('data-modal-id') || '';
        this.customisationGroup = String(params.get('customisation_group') || this.getAttribute('data-customisation-group') || '')
          .trim()
          .toLowerCase();
        this.isModalMode =
          params.get('modal_mode') === '1' || String(this.getAttribute('data-modal-mode') || '').toLowerCase() === 'true';

        this.form = this.querySelector('[data-logo-form]');
        this.submitButton = this.querySelector('[data-logo-submit]');
        this.backToCartLink = this.querySelector('[data-logo-back-link]');
        this.statusElement = this.querySelector('[data-logo-status]');
        this.errorElement = this.querySelector('[data-logo-error]');

        this.titleElement = this.querySelector('[data-product-title]');
        this.metaElement = this.querySelector('[data-product-meta]');
        this.imageElement = this.querySelector('[data-product-image]');
        this.summarySelectionElement = this.querySelector('[data-summary-selection]');
        this.summaryChargeElement = this.querySelector('[data-summary-charge]');
        this.summarySetupElement = this.querySelector('[data-summary-setup]');
        this.asideElement = this.querySelector('.logo-customiser__aside');

        this.positionsContainer = this.querySelector('[data-logo-positions]');
        this.methodsContainer = this.querySelector('[data-logo-methods]');
        this.sizesContainer = this.querySelector('[data-logo-sizes]');
        this.optionsEmptyMessage = this.querySelector('[data-logo-options-empty]');
        this.stepElements = Array.from(this.querySelectorAll('[data-logo-step]'));
        this.stepperItems = Array.from(this.querySelectorAll('[data-stepper-step]'));
        this.stepBackButton = this.querySelector('[data-step-back]');
        this.stepNextButton = this.querySelector('[data-step-next]');
        this.actionsRow = this.querySelector('.logo-customiser__actions');
        this.logoFileInput = this.querySelector('[name="logo_artwork_file"]');
        this.setupPanelElement = this.querySelector('[data-logo-setup-panel]');
        this.textPanelElement = this.querySelector('[data-logo-text-panel]');
        this.textPreviewStage = this.querySelector('[data-logo-text-preview-stage]');
        this.uploadFieldElement = this.querySelector('[data-logo-upload-field]');
        this.textLineInputs = Array.from(this.querySelectorAll('[data-logo-text-line]'));
        this.textFontSelect = this.querySelector('[data-logo-text-font]');
        this.textColourSelects = Array.from(this.querySelectorAll('[data-logo-text-colour]'));
        this.textColourDots = Array.from(this.querySelectorAll('[data-logo-colour-dot]'));
        // Line one doubles as the legacy single-colour value, so the old
        // property keys keep meaning something for anything still reading them.
        this.textColourSelect = this.textColourSelects[0] || null;
        this.typeInputs = Array.from(this.querySelectorAll('input[name="logo_customisation_type"]'));
        this.setupRequiredWrap = this.querySelector('[data-logo-setup-wrap]');
        this.setupRequiredInput = this.querySelector('[name="logo_setup_required"]');
        this.setupNoteElement = this.querySelector('[data-logo-setup-note]');
        this.setupNoteTitleElement = this.querySelector('.logo-customiser__setup-note-title');
        this.setupHintElement = this.querySelector('[data-logo-setup-hint]');
        this.logoUploadLimitHintElement = this.querySelector('[data-logo-upload-limit-hint]');
        this.logoArtworkExistingElement = this.querySelector('[data-logo-artwork-existing]');
        this.logoArtworkPreviewElement = this.querySelector('[data-logo-artwork-preview]');
        this.logoArtworkPreviewListElement = this.querySelector('[data-logo-artwork-preview-list]');
        this.logoArtworkPreviewImageElement = this.querySelector('[data-logo-artwork-preview-image]');
        this.logoArtworkPreviewFallbackElement = this.querySelector('[data-logo-artwork-preview-fallback]');
        this.savedArtworkElements = Array.from(this.querySelectorAll('[data-logo-saved-artwork]'));
        this.assignmentWrapElement = this.querySelector('[data-logo-assignments-wrap]');
        this.assignmentGridElement = this.querySelector('[data-logo-assignments]');
        this.logoAssignmentWrapElement = this.querySelector('[data-logo-logo-assignments-wrap]');
        this.logoAssignmentListElement = this.querySelector('[data-logo-logo-assignments]');
        this.existingLogoArtworkUrl = '';
        this.existingLogoArtworkName = '';
        this.existingLogoArtworks = [];
        this.embroideryObjectUrl = '';
        this.embroideryFileSignature = '';
        this.artworkPreviewObjectUrl = '';
        this.artworkPreviewObjectUrls = [];
        this.assignmentPreviewObjectUrls = [];
        this.positionVisualObjectUrls = [];
        this.artworkPreviewFileSignature = '';
        this.productPreviewImageUrl = '';
        this.currentStep = 1;
        this.canJumpToSteps = false;
        this.isSubmitting = false;
        this.maxStep = this.getMaxStep();
        this.customisationOptions = [];
        this.customisationOptionsByPosition = new Map();
        this.missingPositionImageDebugSet = new Set();
        this.choiceRenderToken = Math.random().toString(36).slice(2, 9);
        this.targetItems = [];
        this.groupEligibleItems = [];
        this.groupTargetSelectionElement = null;
        this.groupTargetListScroll = null;
        this.groupTargetList = null;
        this.groupTargetSelectAllLink = null;
        this.groupTargetToggleButton = null;
        this.targetStackElement = null;
        this.isGroupListExpanded = false;
        this.preferredMethodKey = '';
        this.groupListScrollFadeTimeout = null;
        this.groupCompatibilityProfile = null;
        this.layoutResizeObserver = null;
        this.asideAlignTimeout = null;
        this.metafieldPricesIncludeVat = this.resolveMetafieldVatInclusion();
        this.metafieldVatRatePercent = this.resolveMetafieldVatRate();
        this.positionAssignments = {};
        this.legacySizeTier = '';
        this.assignmentPickerElement = null;
        this.assignmentPickerPanelElement = null;
        this.assignmentPickerTitleElement = null;
        this.assignmentPickerOptionsElement = null;
        this.assignmentPickerState = null;
        this.assignmentPreviewPositionLabel = '';

        if (!this.form) return;

        this.handleSubmitBound = this.handleSubmit.bind(this);
        this.handleInputChangeBound = this.handleInputChange.bind(this);
        this.handleStepBackBound = this.handleStepBack.bind(this);
        this.handleStepNextBound = this.handleStepNext.bind(this);
        this.handleStepperItemClickBound = this.handleStepperItemClick.bind(this);
        this.handleStepperItemKeydownBound = this.handleStepperItemKeydown.bind(this);
        this.handleGroupTargetChangeBound = this.handleGroupTargetChange.bind(this);
        this.handleGroupSelectAllClickBound = this.handleGroupSelectAllClick.bind(this);
        this.handleGroupToggleClickBound = this.handleGroupToggleClick.bind(this);
        this.handleGroupListScrollBound = this.handleGroupListScroll.bind(this);
        this.handleWindowResizeBound = this.updateAsideAlignment.bind(this);
        this.handleSavedArtworkClickBound = this.handleSavedArtworkClick.bind(this);
        this.handleArtworkPreviewRemoveClickBound = this.handleArtworkPreviewRemoveClick.bind(this);
        this.handleAssignmentChoiceClickBound = this.handleAssignmentChoiceClick.bind(this);
        this.handleAssignmentPickerKeydownBound = this.handleAssignmentPickerKeydown.bind(this);
        this.handleAssignmentTabsWheelBound = this.handleAssignmentTabsWheel.bind(this);
        this.handleVatToggleClickBound = this.handleVatToggleClick.bind(this);

        this.form.addEventListener('submit', this.handleSubmitBound);
        this.form.addEventListener('change', this.handleInputChangeBound);
        this.form.addEventListener('input', this.handleInputChangeBound);
        if (this.stepBackButton) this.stepBackButton.addEventListener('click', this.handleStepBackBound);
        if (this.stepNextButton) this.stepNextButton.addEventListener('click', this.handleStepNextBound);
        this.stepperItems.forEach((item) => {
          item.addEventListener('click', this.handleStepperItemClickBound);
          item.addEventListener('keydown', this.handleStepperItemKeydownBound);
        });
        this.addEventListener('input', (event) => {
          if (!String(event?.target?.name || '').startsWith('logo_text_')) return;
          this.repaintTextPreviews();
        });
        this.addEventListener('click', this.handleArtworkPreviewRemoveClickBound);
        this.addEventListener('click', this.handleAssignmentChoiceClickBound);
        this.addEventListener('wheel', this.handleAssignmentTabsWheelBound, { passive: false });
        if (this.savedArtworkElements.length) this.addEventListener('click', this.handleSavedArtworkClickBound);
        window.addEventListener('resize', this.handleWindowResizeBound);
        document.addEventListener('keydown', this.handleAssignmentPickerKeydownBound);
        document.addEventListener('click', this.handleVatToggleClickBound, true);
        if (typeof window.ResizeObserver === 'function') {
          this.layoutResizeObserver = new window.ResizeObserver(() => {
            this.updateAsideAlignment();
          });
          this.layoutResizeObserver.observe(this.form);
        }

        if (this.isModalMode && this.backToCartLink) {
          this.backToCartLink.hidden = true;
          this.backToCartLink.classList.add('hidden');
        }

        this.initTextPickers();
        this.updateCustomisationTypeUI();
        this.updateTypeVisibility();
        this.updateSelectionSummary();
        this.updateStepUI();
        this.updateAsideAlignment();
        this.asideAlignTimeout = window.setTimeout(() => {
          this.updateAsideAlignment();
        }, 180);
        this.loadLineItem();
      }

      disconnectedCallback() {
        if (!this.form) return;
        this.form.removeEventListener('submit', this.handleSubmitBound);
        this.form.removeEventListener('change', this.handleInputChangeBound);
        this.form.removeEventListener('input', this.handleInputChangeBound);
        if (this.stepBackButton) this.stepBackButton.removeEventListener('click', this.handleStepBackBound);
        if (this.stepNextButton) this.stepNextButton.removeEventListener('click', this.handleStepNextBound);
        this.stepperItems.forEach((item) => {
          item.removeEventListener('click', this.handleStepperItemClickBound);
          item.removeEventListener('keydown', this.handleStepperItemKeydownBound);
        });
        this.removeEventListener('click', this.handleArtworkPreviewRemoveClickBound);
        this.removeEventListener('click', this.handleAssignmentChoiceClickBound);
        this.removeEventListener('wheel', this.handleAssignmentTabsWheelBound);
        if (this.groupTargetSelectionElement) {
          this.groupTargetSelectionElement.removeEventListener('change', this.handleGroupTargetChangeBound);
        }
        if (this.groupTargetSelectAllLink) {
          this.groupTargetSelectAllLink.removeEventListener('click', this.handleGroupSelectAllClickBound);
        }
        if (this.groupTargetToggleButton) {
          this.groupTargetToggleButton.removeEventListener('click', this.handleGroupToggleClickBound);
        }
        if (this.groupTargetListScroll) {
          this.groupTargetListScroll.removeEventListener('scroll', this.handleGroupListScrollBound);
        }
        if (this.groupListScrollFadeTimeout) {
          window.clearTimeout(this.groupListScrollFadeTimeout);
          this.groupListScrollFadeTimeout = null;
        }
        if (this.savedArtworkElements.length) {
          this.removeEventListener('click', this.handleSavedArtworkClickBound);
        }
        window.removeEventListener('resize', this.handleWindowResizeBound);
        document.removeEventListener('keydown', this.handleAssignmentPickerKeydownBound);
        document.removeEventListener('click', this.handleVatToggleClickBound, true);
        if (this.layoutResizeObserver) {
          this.layoutResizeObserver.disconnect();
          this.layoutResizeObserver = null;
        }
        if (this.asideAlignTimeout) {
          window.clearTimeout(this.asideAlignTimeout);
          this.asideAlignTimeout = null;
        }
        this.closeAllLogoImageDropdowns();
        this.closeAssignmentPicker({ clearState: true });
        this.cleanupAssignmentPreviewObjectUrls();
        this.cleanupPositionVisualObjectUrls();
        this.cleanupEmbroideryPreview();
      }

      parseTargetKeys(rawValue) {
        const raw = String(rawValue || '').trim();
        if (!raw) return [];
        return Array.from(
          new Set(
            raw
              .split(',')
              .map((value) => String(value || '').trim())
              .filter(Boolean)
          )
        );
      }

      normalizeChoiceKey(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '-');
      }

      normalizeChoiceLabel(value) {
        return String(value || '').trim();
      }

      parseCentsValue(value) {
        const parsed = Number(String(value ?? '').replace(/[^0-9.-]/g, ''));
        return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed)) : null;
      }

      isOptionEnabled(value) {
        const normalized = String(value ?? '').trim().toLowerCase();
        return !(value === false || normalized === 'false' || normalized === '0' || normalized === 'no');
      }

      valueToArray(value) {
        if (Array.isArray(value)) return value;
        if (value == null) return [];
        return [value];
      }

      toChoiceList(rawValue) {
        const normalizedValues = [];
        const seen = new Set();

        const pushValue = (candidate) => {
          const normalized = this.normalizeChoiceLabel(candidate);
          if (!normalized) return;
          const dedupeKey = normalized.toLowerCase();
          if (seen.has(dedupeKey)) return;
          seen.add(dedupeKey);
          normalizedValues.push(normalized);
        };

        const consume = (value) => {
          if (value == null) return;

          if (Array.isArray(value)) {
            value.forEach((item) => consume(item));
            return;
          }

          if (typeof value === 'object') {
            if (Object.prototype.hasOwnProperty.call(value, 'value')) {
              consume(value.value);
              return;
            }
            if (Object.prototype.hasOwnProperty.call(value, 'label')) {
              pushValue(value.label);
              return;
            }
            if (Object.prototype.hasOwnProperty.call(value, 'name')) {
              pushValue(value.name);
              return;
            }
            if (Object.prototype.hasOwnProperty.call(value, 'key')) {
              pushValue(value.key);
              return;
            }
            return;
          }

          const text = String(value || '').trim();
          if (!text) return;

          const hasSeparator = /[|•,]/.test(text);
          if (!hasSeparator) {
            pushValue(text);
            return;
          }

          text
            .split(/[|•,]/)
            .map((part) => part.trim())
            .filter(Boolean)
            .forEach((part) => pushValue(part));
        };

        consume(rawValue);
        return normalizedValues;
      }

      parseFocalPoint(value) {
        const clamp = (input) => {
          const numeric = Number(input);
          if (!Number.isFinite(numeric)) return null;
          return Math.min(100, Math.max(0, numeric));
        };

        const normalizePair = (xRaw, yRaw) => {
          let x = Number(xRaw);
          let y = Number(yRaw);
          if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

          const valuesLookFractional = Math.abs(x) <= 1 && Math.abs(y) <= 1;
          if (valuesLookFractional) {
            x *= 100;
            y *= 100;
          }

          const xClamped = clamp(x);
          const yClamped = clamp(y);
          if (xClamped == null || yClamped == null) return null;

          return {
            x: Number(xClamped.toFixed(2)),
            y: Number(yClamped.toFixed(2)),
          };
        };

        const consume = (raw) => {
          if (raw == null) return null;

          if (Array.isArray(raw)) {
            for (let i = 0; i < raw.length; i += 1) {
              const candidate = consume(raw[i]);
              if (candidate) return candidate;
            }
            return null;
          }

          if (typeof raw === 'object') {
            const directX =
              raw.x ??
              raw.left ??
              raw.horizontal ??
              raw.h ??
              (raw.focalPoint && (raw.focalPoint.x ?? raw.focalPoint.left));
            const directY =
              raw.y ??
              raw.top ??
              raw.vertical ??
              raw.v ??
              (raw.focalPoint && (raw.focalPoint.y ?? raw.focalPoint.top));
            const directPair = normalizePair(directX, directY);
            if (directPair) return directPair;

            const nestedKeys = ['value', 'focal_point', 'focalPoint', 'presentation', 'image', 'preview_image'];
            for (let i = 0; i < nestedKeys.length; i += 1) {
              const nested = raw[nestedKeys[i]];
              const parsedNested = consume(nested);
              if (parsedNested) return parsedNested;
            }
            return null;
          }

          const text = String(raw || '').trim();
          if (!text) return null;
          if (/^gid:\/\/shopify\//i.test(text)) return null;
          if (/^(https?:)?\/\//i.test(text)) return null;

          if (text.startsWith('[') || text.startsWith('{')) {
            try {
              const parsed = JSON.parse(text);
              const parsedPoint = consume(parsed);
              if (parsedPoint) return parsedPoint;
            } catch (error) {
              // fall through to regex parsing
            }
          }

          const percentMatch = text.match(/(-?\d+(?:\.\d+)?)\s*%\s*[, ]+\s*(-?\d+(?:\.\d+)?)\s*%/);
          if (percentMatch) {
            return normalizePair(percentMatch[1], percentMatch[2]);
          }

          const numericMatch = text.match(/(-?\d+(?:\.\d+)?)\s*[, ]+\s*(-?\d+(?:\.\d+)?)/);
          if (numericMatch) {
            return normalizePair(numericMatch[1], numericMatch[2]);
          }

          return null;
        };

        return consume(value);
      }

      resolveRuntimeFocalPointList(rawValue) {
        const list = [];

        const pushIfValid = (candidate) => {
          const parsed = this.parseFocalPoint(candidate);
          if (!parsed) return false;
          list.push(parsed);
          return true;
        };

        const consume = (value) => {
          if (value == null) return;

          if (Array.isArray(value)) {
            value.forEach((item) => consume(item));
            return;
          }

          if (typeof value === 'string') {
            const text = value.trim();
            if (!text) return;

            if (text.startsWith('[') || text.startsWith('{')) {
              try {
                const parsed = JSON.parse(text);
                consume(parsed);
                return;
              } catch (error) {
                // continue with token split
              }
            }

            const parts = text
              .split(/[|•;\n]+/)
              .map((part) => part.trim())
              .filter(Boolean);

            if (parts.length > 1) {
              parts.forEach((part) => pushIfValid(part));
              return;
            }
          }

          pushIfValid(value);
        };

        consume(rawValue);
        return list;
      }

      resolveRuntimeImageUrl(rawValue) {
        const isLikelyUrl = (candidate) => {
          const text = String(candidate || '').trim();
          if (!text) return false;
          if (/^https?:\/\/shopify\/(?:MediaImage|GenericFile|Video|Model3d)\//i.test(text)) return false;
          if (/^shopify\/(?:MediaImage|GenericFile|Video|Model3d)\//i.test(text)) return false;
          if (/^(https?:)?\/\//i.test(text)) {
            try {
              const parsed = new URL(text.startsWith('//') ? `${window.location.protocol}${text}` : text, window.location.origin);
              const hostname = String(parsed.hostname || '').trim().toLowerCase();
              if (!hostname) return false;
              if (/^\d+$/.test(hostname)) return false;
              if (!hostname.includes('.') && hostname !== 'localhost') return false;
            } catch (error) {
              return false;
            }
            return true;
          }
          if (text.startsWith('/')) return true;
          return /cdn\.shopify\.com|\/s\/files\/|\/files\/|(\.png|\.jpe?g|\.webp|\.gif|\.svg)(\?|$)/i.test(text);
        };

        const extractCandidates = (value) => {
          const text = String(value || '').trim();
          if (!text) return [];

          const candidates = [];
          const seen = new Set();
          const pushCandidate = (candidate) => {
            const normalized = String(candidate || '').trim().replace(/^["']+|["']+$/g, '');
            if (!normalized || seen.has(normalized)) return;
            seen.add(normalized);
            candidates.push(normalized);
          };

          pushCandidate(text);
          text
            .split(/[|•,\n;]+/)
            .map((part) => part.trim())
            .filter(Boolean)
            .forEach((part) => pushCandidate(part));

          const regexMatches = text.match(
            /((?:https?:)?\/\/[^\s"'<>]+|\/[^\s"'<>]+\.(?:png|jpe?g|webp|gif|svg)(?:\?[^\s"'<>]*)?|[A-Za-z0-9._-]+\.(?:png|jpe?g|webp|gif|svg))/gi
          );
          if (regexMatches) {
            regexMatches.forEach((match) => pushCandidate(match));
          }

          return candidates;
        };

        const consume = (value) => {
          if (value == null) return '';

          if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i += 1) {
              const candidate = consume(value[i]);
              if (candidate) return candidate;
            }
            return '';
          }

          if (typeof value === 'object') {
            const directKeys = ['url', 'src', 'image_url', 'imageUrl', 'preview_image', 'previewImage', 'path'];
            for (let i = 0; i < directKeys.length; i += 1) {
              const directValue = value[directKeys[i]];
              if (typeof directValue === 'string') {
                const normalized = this.normalizeArtworkUrl(directValue);
                if (normalized && !normalized.startsWith('gid://') && isLikelyUrl(normalized)) return normalized;
              }
            }

            const nestedKeys = [
              'value',
              'image',
              'preview_image',
              'previewImage',
              'featured_image',
              'featuredImage',
              'reference',
              'file',
              'files',
              'data',
              'node',
              'nodes',
            ];
            for (let i = 0; i < nestedKeys.length; i += 1) {
              const nestedValue = value[nestedKeys[i]];
              const nestedResolved = consume(nestedValue);
              if (nestedResolved) return nestedResolved;
            }

            const objectKeys = Object.keys(value);
            for (let i = 0; i < objectKeys.length; i += 1) {
              const key = objectKeys[i];
              if (nestedKeys.includes(key) || directKeys.includes(key)) continue;
              const candidate = consume(value[key]);
              if (candidate) return candidate;
            }

            return '';
          }

          const candidates = extractCandidates(value);
          for (let i = 0; i < candidates.length; i += 1) {
            const normalized = this.normalizeArtworkUrl(candidates[i]);
            if (!normalized || normalized.startsWith('gid://') || !isLikelyUrl(normalized)) continue;
            return normalized;
          }
          return '';
        };

        return consume(rawValue);
      }

      resolveRuntimeImageUrlList(rawValue) {
        const list = [];
        const seen = new Set();
        const pushIfValid = (candidate) => {
          const resolved = this.resolveRuntimeImageUrl(candidate);
          if (!resolved || seen.has(resolved)) return false;
          seen.add(resolved);
          list.push(resolved);
          return true;
        };
        const consume = (value) => {
          if (value == null) return;

          if (Array.isArray(value)) {
            value.forEach((item) => consume(item));
            return;
          }

          if (typeof value === 'string') {
            value
              .split(/[|•,\n;]+/)
              .map((part) => part.trim())
              .filter(Boolean)
              .forEach((part) => {
                pushIfValid(part);
              });
            if (pushIfValid(value)) return;
          } else if (pushIfValid(value)) {
            return;
          }

          if (typeof value === 'object') {
            Object.keys(value).forEach((key) => consume(value[key]));
          }
        };

        consume(rawValue);
        return list;
      }

      readRuntimeOptionField(option, key) {
        if (!option || typeof option !== 'object') return null;
        if (Object.prototype.hasOwnProperty.call(option, key)) return option[key];
        if (Object.prototype.hasOwnProperty.call(option, `${key}_value`)) return option[`${key}_value`];

        const fields = option.fields;
        if (fields && typeof fields === 'object') {
          if (!Array.isArray(fields) && Object.prototype.hasOwnProperty.call(fields, key)) {
            return fields[key];
          }
          if (Array.isArray(fields)) {
            const matchedField = fields.find((field) => {
              const fieldKey = String(field?.key || field?.name || field?.handle || '').trim();
              return fieldKey === key;
            });
            if (matchedField) {
              if (Object.prototype.hasOwnProperty.call(matchedField, 'value')) return matchedField.value;
              if (Object.prototype.hasOwnProperty.call(matchedField, 'values')) return matchedField.values;
              return matchedField;
            }
          }
        }

        return null;
      }

      readRuntimeNestedOptions(option) {
        if (this.isRuntimeOptionRecord(option)) return null;

        const optionKeys = [
          'options',
          'customisation_options',
          'customisation_option',
          'customization_options',
          'customization_option',
        ];
        for (let i = 0; i < optionKeys.length; i += 1) {
          const nested = this.readRuntimeOptionField(option, optionKeys[i]);
          if (nested != null) return nested;
        }

        const findCandidate = (container) => {
          if (!container || typeof container !== 'object') return null;
          if (Array.isArray(container)) {
            for (let i = 0; i < container.length; i += 1) {
              const item = container[i];
              if (this.isRuntimeOptionRecord(item)) return container;
              if (item && typeof item === 'object') {
                const nested = findCandidate(item);
                if (nested != null) return nested;
              }
            }
            return null;
          }

          const keys = Object.keys(container);
          for (let i = 0; i < keys.length; i += 1) {
            const key = keys[i];
            const candidate = container[key];
            if (this.isRuntimeOptionRecord(candidate)) return candidate;
            if (Array.isArray(candidate)) {
              const containsOption = candidate.some((entry) => this.isRuntimeOptionRecord(entry));
              if (containsOption) return candidate;
            }
            if (candidate && typeof candidate === 'object') {
              const nested = findCandidate(candidate);
              if (nested != null) return nested;
            }
          }
          return null;
        };

        const fieldCandidate = findCandidate(option?.fields);
        if (fieldCandidate != null) return fieldCandidate;
        const directCandidate = findCandidate(option);
        if (directCandidate != null && directCandidate !== option) return directCandidate;
        return null;
      }

      isRuntimeOptionRecord(value) {
        if (!value || typeof value !== 'object') return false;
        const hasMethod =
          this.readRuntimeOptionField(value, 'method_key') != null ||
          this.readRuntimeOptionField(value, 'methodKey') != null ||
          this.readRuntimeOptionField(value, 'method') != null;
        const hasSize =
          this.readRuntimeOptionField(value, 'size_key') != null ||
          this.readRuntimeOptionField(value, 'sizeKey') != null ||
          this.readRuntimeOptionField(value, 'size') != null;
        const hasUnit =
          this.readRuntimeOptionField(value, 'unit_price_cents') != null ||
          this.readRuntimeOptionField(value, 'unitPriceCents') != null;
        const hasPosition =
          this.readRuntimeOptionField(value, 'position_label') != null ||
          this.readRuntimeOptionField(value, 'positionLabel') != null ||
          this.readRuntimeOptionField(value, 'position_title') != null ||
          this.readRuntimeOptionField(value, 'positionTitle') != null ||
          this.readRuntimeOptionField(value, 'position_ref') != null ||
          this.readRuntimeOptionField(value, 'positionRef') != null ||
          this.readRuntimeOptionField(value, 'position') != null;

        return hasMethod && hasSize && hasUnit && hasPosition;
      }

      getRuntimePositionMeta(refId) {
        const runtimeMap = window.NewLogoRuntime?.positionMetaById;
        if (!runtimeMap || typeof runtimeMap !== 'object') return null;

        const raw = String(refId || '').trim();
        if (!raw) return null;

        if (Object.prototype.hasOwnProperty.call(runtimeMap, raw)) return runtimeMap[raw];

        const shortId = raw.includes('/') ? raw.split('/').pop() : raw;
        if (shortId && Object.prototype.hasOwnProperty.call(runtimeMap, shortId)) {
          return runtimeMap[shortId];
        }
        const lowered = raw.toLowerCase();
        if (lowered && Object.prototype.hasOwnProperty.call(runtimeMap, lowered)) {
          return runtimeMap[lowered];
        }

        const mappedKey = Object.keys(runtimeMap).find((key) => {
          const normalizedKey = String(key || '').trim();
          if (!normalizedKey) return false;
          const normalizedKeyLower = normalizedKey.toLowerCase();
          if (normalizedKey === raw || normalizedKeyLower === lowered) return true;
          if (
            shortId &&
            (normalizedKey === shortId ||
              normalizedKeyLower === String(shortId).toLowerCase() ||
              normalizedKey.endsWith(`/${shortId}`))
          ) {
            return true;
          }
          return false;
        });
        return mappedKey ? runtimeMap[mappedKey] : null;
      }

      extractPositionDataFromRefs(rawRefs) {
        const labels = [];
        const images = [];
        const focalPoints = [];
        const seen = new Set();
        const visited = new WeakSet();

        const push = (labelCandidate, imageCandidate, focalCandidate) => {
          const normalizedLabel = this.normalizeChoiceLabel(labelCandidate);
          if (!normalizedLabel) return;
          const dedupeKey = normalizedLabel.toLowerCase();
          if (seen.has(dedupeKey)) return;
          seen.add(dedupeKey);
          labels.push(normalizedLabel);
          images.push(this.resolveRuntimeImageUrl(imageCandidate) || '');
          focalPoints.push(this.parseFocalPoint(focalCandidate));
        };

        const visit = (value) => {
          if (value == null) return;

          if (Array.isArray(value)) {
            value.forEach((item) => visit(item));
            return;
          }

          if (typeof value === 'string' || typeof value === 'number') {
            const runtimeMeta = this.getRuntimePositionMeta(value);
            if (runtimeMeta) {
              push(runtimeMeta.label, runtimeMeta.image, runtimeMeta.focalPoint ?? runtimeMeta.focal_point);
            }
            return;
          }

          if (typeof value === 'object') {
            if (visited.has(value)) return;
            visited.add(value);

            const labelCandidates = [
              this.readRuntimeOptionField(value, 'position_label'),
              this.readRuntimeOptionField(value, 'positionLabel'),
              this.readRuntimeOptionField(value, 'position_title'),
              this.readRuntimeOptionField(value, 'positionTitle'),
              this.readRuntimeOptionField(value, 'display_name'),
              this.readRuntimeOptionField(value, 'displayName'),
              this.readRuntimeOptionField(value, 'label'),
              this.readRuntimeOptionField(value, 'title'),
              this.readRuntimeOptionField(value, 'name'),
            ];
            const imageCandidate =
              this.readRuntimeOptionField(value, 'position_image') ??
              this.readRuntimeOptionField(value, 'positionImage') ??
              this.readRuntimeOptionField(value, 'image') ??
              this.readRuntimeOptionField(value, 'image_url') ??
              this.readRuntimeOptionField(value, 'imageUrl');
            const focalCandidate =
              this.readRuntimeOptionField(value, 'position_image_focal_point') ??
              this.readRuntimeOptionField(value, 'positionImageFocalPoint') ??
              this.readRuntimeOptionField(value, 'focal_point') ??
              this.readRuntimeOptionField(value, 'focalPoint') ??
              this.readRuntimeOptionField(value, 'image_focal_point') ??
              this.readRuntimeOptionField(value, 'imageFocalPoint');

            let pushed = false;
            labelCandidates.forEach((candidate) => {
              const candidateLabels = this.toChoiceList(candidate);
              candidateLabels.forEach((label) => {
                push(label, imageCandidate, focalCandidate);
                pushed = true;
              });
            });
            if (pushed) return;

            const runtimeMeta =
              this.getRuntimePositionMeta(value?.id) ||
              this.getRuntimePositionMeta(this.readRuntimeOptionField(value, 'id')) ||
              this.getRuntimePositionMeta(this.readRuntimeOptionField(value, 'gid')) ||
              this.getRuntimePositionMeta(this.readRuntimeOptionField(value, 'admin_graphql_api_id'));
            if (runtimeMeta) {
              push(runtimeMeta.label, runtimeMeta.image, runtimeMeta.focalPoint ?? runtimeMeta.focal_point);
              return;
            }

            const nestedKeys = ['value', 'values', 'reference', 'references', 'node', 'nodes', 'item', 'items'];
            nestedKeys.forEach((key) => {
              if (!Object.prototype.hasOwnProperty.call(value, key)) return;
              visit(value[key]);
            });

            const fields = value.fields;
            if (Array.isArray(fields)) {
              fields.forEach((field) => visit(field));
            } else if (fields && typeof fields === 'object') {
              visit(fields);
            }
          }
        };

        visit(rawRefs);
        return { labels, images, focalPoints };
      }

      expandRuntimeOption(option, index) {
        if (!option || typeof option !== 'object') return [];

        const positionRefValues =
          this.readRuntimeOptionField(option, 'position_ref') ??
          this.readRuntimeOptionField(option, 'positionRef') ??
          this.readRuntimeOptionField(option, 'position');
        const positionDataFromRefs = this.extractPositionDataFromRefs(positionRefValues);
        const directPositionValues = this.toChoiceList(
          this.readRuntimeOptionField(option, 'position_label') ??
            this.readRuntimeOptionField(option, 'positionLabel') ??
            this.readRuntimeOptionField(option, 'position_title') ??
            this.readRuntimeOptionField(option, 'positionTitle') ??
            this.readRuntimeOptionField(option, 'position')
        );
        const positionValues = directPositionValues.length ? directPositionValues : positionDataFromRefs.labels;
        const methodValues = this.toChoiceList(
          this.readRuntimeOptionField(option, 'method_key') ??
            this.readRuntimeOptionField(option, 'methodKey') ??
            this.readRuntimeOptionField(option, 'method')
        );
        const sizeValues = this.toChoiceList(
          this.readRuntimeOptionField(option, 'size_key') ??
            this.readRuntimeOptionField(option, 'sizeKey') ??
            this.readRuntimeOptionField(option, 'size')
        );

        const parsedUnit = this.parseCentsValue(
          this.readRuntimeOptionField(option, 'unit_price_cents') ?? this.readRuntimeOptionField(option, 'unitPriceCents')
        );
        const parsedSetup = this.parseCentsValue(
          this.readRuntimeOptionField(option, 'setup_fee_cents') ?? this.readRuntimeOptionField(option, 'setupFeeCents')
        );
        const positionImageValue = this.readRuntimeOptionField(option, 'position_image') ??
          this.readRuntimeOptionField(option, 'position_image_ref_urls') ??
          this.readRuntimeOptionField(option, 'positionImageRefUrls') ??
          this.readRuntimeOptionField(option, 'position_images') ??
          this.readRuntimeOptionField(option, 'position_image_raw') ??
          this.readRuntimeOptionField(option, 'positionImageRaw') ??
          this.readRuntimeOptionField(option, 'position_image_html') ??
          this.readRuntimeOptionField(option, 'positionImageHtml') ??
          this.readRuntimeOptionField(option, 'positionImage') ??
          this.readRuntimeOptionField(option, 'positionImages') ??
          this.readRuntimeOptionField(option, 'position_ref') ??
          this.readRuntimeOptionField(option, 'positionRef') ??
          this.readRuntimeOptionField(option, 'image') ??
          this.readRuntimeOptionField(option, 'position_artwork') ??
          this.readRuntimeOptionField(option, 'positionArtwork');
        const positionImageHtmlValue = this.readRuntimeOptionField(option, 'position_image_html') ??
          this.readRuntimeOptionField(option, 'positionImageHtml') ??
          '';
        const positionImageFocalPointValue =
          this.readRuntimeOptionField(option, 'position_image_focal_point') ??
          this.readRuntimeOptionField(option, 'positionImageFocalPoint') ??
          this.readRuntimeOptionField(option, 'position_focal_point') ??
          this.readRuntimeOptionField(option, 'positionFocalPoint') ??
          this.readRuntimeOptionField(option, 'focal_point') ??
          this.readRuntimeOptionField(option, 'focalPoint');
        const positionImageRefUrlList = this.resolveRuntimeImageUrlList(
          this.readRuntimeOptionField(option, 'position_image_ref_urls') ??
            this.readRuntimeOptionField(option, 'positionImageRefUrls') ??
            ''
        );
        const positionRefImageUrls = this.resolveRuntimeImageUrlList(positionDataFromRefs.images);
        const positionRefFocalPointList = this.resolveRuntimeFocalPointList(positionDataFromRefs.focalPoints);
        const positionImageUrls = this.resolveRuntimeImageUrlList(positionImageValue);
        const positionImageHtmlUrls = this.resolveRuntimeImageUrlList(positionImageHtmlValue);
        const positionImageFocalPointList = this.resolveRuntimeFocalPointList(positionImageFocalPointValue);
        const positionImageUrl = this.resolveRuntimeImageUrl(positionImageValue);
        const positionImageHtmlUrl = this.resolveRuntimeImageUrl(positionImageHtmlValue);
        const positionImageFocalPoint = this.parseFocalPoint(positionImageFocalPointValue);
        const enabled = this.isOptionEnabled(this.readRuntimeOptionField(option, 'enabled'));

        if (!enabled || !positionValues.length || !methodValues.length || !sizeValues.length || parsedUnit == null) {
          return [];
        }

        const expanded = [];
        positionValues.forEach((positionLabel, positionIndex) => {
          const mappedPositionImageUrl =
            positionRefImageUrls[positionIndex] ||
            positionImageRefUrlList[positionIndex] ||
            positionImageUrls[positionIndex] ||
            positionImageHtmlUrls[positionIndex] ||
            (positionRefImageUrls.length === 1 ? positionRefImageUrls[0] : '') ||
            (positionImageRefUrlList.length === 1 ? positionImageRefUrlList[0] : '') ||
            (positionImageUrls.length === 1 ? positionImageUrls[0] : '') ||
            (positionImageHtmlUrls.length === 1 ? positionImageHtmlUrls[0] : '') ||
            positionImageUrl ||
            positionImageHtmlUrl;
          const mappedPositionFocalPoint =
            positionRefFocalPointList[positionIndex] ||
            positionImageFocalPointList[positionIndex] ||
            (positionRefFocalPointList.length === 1 ? positionRefFocalPointList[0] : null) ||
            (positionImageFocalPointList.length === 1 ? positionImageFocalPointList[0] : null) ||
            positionImageFocalPoint ||
            null;
          methodValues.forEach((methodKey) => {
            sizeValues.forEach((sizeKey) => {
              expanded.push({
                position_label: positionLabel,
                method_key: methodKey,
                size_key: sizeKey,
                unit_price_cents: parsedUnit,
                setup_fee_cents: parsedSetup == null ? 0 : parsedSetup,
                position_image: mappedPositionImageUrl,
                position_image_ref_urls: positionImageRefUrlList,
                position_image_raw: positionImageValue,
                position_image_html: positionImageHtmlValue,
                position_image_focal_point: mappedPositionFocalPoint,
                enabled: true,
                _source_index: index,
              });
            });
          });
        });

        return expanded;
      }

      expandRuntimeOptions(sourceOptions) {
        return this.valueToArray(sourceOptions).reduce((acc, option, index) => {
          const profileOptions = this.readRuntimeNestedOptions(option);
          if (profileOptions != null) {
            const nestedExpanded = this.expandRuntimeOptions(profileOptions);
            if (nestedExpanded.length) acc.push(...nestedExpanded);
            return acc;
          }

          const expanded = this.expandRuntimeOption(option, index);
          if (expanded.length) {
            acc.push(...expanded);
          }
          return acc;
        }, []);
      }

      normalizeCustomisationOption(option, index) {
        const positionLabel = this.normalizeChoiceLabel(
          option?.position_label ??
            option?.positionLabel ??
            option?.position_title ??
            option?.positionTitle ??
            option?.position ??
            option?.display_name ??
            option?.displayName ??
            option?.label
        );
        const methodKey = this.normalizeChoiceKey(option?.method_key ?? option?.methodKey ?? option?.method);
        const sizeKey = this.normalizeChoiceKey(option?.size_key ?? option?.sizeKey ?? option?.size);
        const parsedUnit = this.parseCentsValue(option?.unit_price_cents ?? option?.unitPriceCents);
        if (!positionLabel || !methodKey || !sizeKey || parsedUnit == null) return null;

        const parsedSetup = this.parseCentsValue(option?.setup_fee_cents ?? option?.setupFeeCents);
        const positionImageRawValue =
          option?.position_image_raw ??
          option?.positionImageRaw ??
          option?.position_image_ref_urls ??
          option?.positionImageRefUrls ??
          option?.position_image ??
          option?.positionImage ??
          option?.image ??
          '';
        const positionImageHtmlValue = option?.position_image_html ?? option?.positionImageHtml ?? '';
        const positionImageRefUrls = this.resolveRuntimeImageUrlList(
          option?.position_image_ref_urls ?? option?.positionImageRefUrls ?? ''
        );
        const positionImageFocalPointRaw =
          option?.position_image_focal_point ??
          option?.positionImageFocalPoint ??
          option?.position_focal_point ??
          option?.positionFocalPoint ??
          option?.focal_point ??
          option?.focalPoint ??
          '';
        const positionImageFocalPoint = this.parseFocalPoint(positionImageFocalPointRaw);
        const positionImageUrl = this.resolveRuntimeImageUrl(
          option?.position_image ??
            option?.position_image_ref_urls ??
            option?.positionImageRefUrls ??
            option?.position_images ??
            option?.position_image_raw ??
            option?.positionImageRaw ??
            option?.position_image_html ??
            option?.positionImageHtml ??
            option?.positionImage ??
            option?.positionImages ??
            option?.image ??
            option?.position_artwork ??
            option?.positionArtwork
        );
        const enabled = this.isOptionEnabled(option?.enabled);

        return {
          id: `${positionLabel}__${methodKey}__${sizeKey}__${index}`,
          positionLabel,
          methodKey,
          sizeKey,
          unitPriceCents: parsedUnit,
          setupFeeCents: parsedSetup == null ? 0 : parsedSetup,
          positionImageUrl,
          positionImageRaw: positionImageRawValue,
          positionImageHtml: positionImageHtmlValue,
          positionImageRefUrls,
          positionImageFocalPoint,
          positionImageFocalPointRaw,
          enabled,
        };
      }

      getRuntimeOptionsForHandle(handle, productId = null) {
        const normalizedHandle = String(handle || '').trim();
        const normalizedProductId = String(productId || '').trim();

        const runtime = window.NewLogoRuntime || {};
        const byHandle = runtime.customisationOptionsByHandle || {};
        const byProductId = runtime.customisationOptionsByProductId || {};

        if (normalizedHandle) {
          if (Object.prototype.hasOwnProperty.call(byHandle, normalizedHandle)) {
            return byHandle[normalizedHandle];
          }
          const lowercaseHandle = normalizedHandle.toLowerCase();
          const fallbackKey = Object.keys(byHandle).find((key) => String(key || '').trim().toLowerCase() === lowercaseHandle);
          if (fallbackKey) return byHandle[fallbackKey];
        }

        if (normalizedProductId) {
          if (Object.prototype.hasOwnProperty.call(byProductId, normalizedProductId)) {
            return byProductId[normalizedProductId];
          }
          const idFallbackKey = Object.keys(byProductId).find(
            (key) => String(key || '').trim() === normalizedProductId
          );
          if (idFallbackKey) return byProductId[idFallbackKey];
        }

        const runtimeProduct = runtime.product || {};
        if (
          (normalizedHandle && String(runtimeProduct.handle || '').trim().toLowerCase() === normalizedHandle.toLowerCase()) ||
          (normalizedProductId && String(runtimeProduct.id || '').trim() === normalizedProductId)
        ) {
          return runtimeProduct.customisationOptions;
        }

        return [];
      }

      setCustomisationOptionsForHandle(handle, productId = null) {
        const sourceOptions = this.getRuntimeOptionsForHandle(handle, productId);
        const expandedOptions = this.expandRuntimeOptions(sourceOptions);
        const normalized = expandedOptions
          .map((option, index) => this.normalizeCustomisationOption(option, index))
          .filter((option) => option && option.enabled);

        this.customisationOptions = normalized;
        this.rebuildCustomisationIndex();

        this.renderPositionChoices(this.getSelectedPositions());
        this.refreshDynamicChoiceOptions();
        this.renderPositionAssignments();
        this.renderLogoAssignments();

        const hasOptions = normalized.length > 0;
        if (this.optionsEmptyMessage) {
          this.optionsEmptyMessage.hidden = hasOptions;
        }
      }

      rebuildCustomisationIndex() {
        const byPosition = new Map();
        this.customisationOptions.forEach((option) => {
          if (!byPosition.has(option.positionLabel)) {
            byPosition.set(option.positionLabel, []);
          }
          byPosition.get(option.positionLabel).push(option);
        });
        this.customisationOptionsByPosition = byPosition;
      }

      humanizeChoiceKey(value) {
        return String(value || '')
          .split('-')
          .filter(Boolean)
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(' ');
      }

      getSizeDimensionLabel(methodKey, sizeKey) {
        const normalizedMethod = this.normalizeChoiceKey(methodKey);
        const normalizedSize = this.normalizeChoiceKey(sizeKey);
        if (normalizedSize !== 'small' && normalizedSize !== 'large') return '';
        if (normalizedMethod === 'embroidery') {
          return normalizedSize === 'small' ? '(up to 14cm x 14cm)' : '(up to 30cm x 30cm)';
        }
        if (normalizedMethod === 'print') {
          return normalizedSize === 'small' ? '(up to 15cm x 15cm)' : '(up to 45cm x 45cm)';
        }
        return '';
      }

      /**
       * Whether the shopper is currently viewing tax-inclusive prices.
       *
       * `vat-price-toggle.js` keeps the choice in localStorage and never emits
       * an event, so read it directly and re-render on the toggle's click.
       */
      get vatDisplayIncludesTax() {
        let mode = '';
        try {
          mode = String(window.localStorage.getItem('gsww_vat_mode') || '').trim();
        } catch (error) {
          mode = '';
        }
        if (mode !== 'inc' && mode !== 'exc') {
          const toggle = document.querySelector('[data-vat-toggle]');
          mode = String(toggle?.dataset.vatDefaultMode || 'exc').trim();
        }
        return mode === 'inc';
      }

      /**
       * Every amount handed to formatCents is tax-exclusive — that is the basis
       * the line item properties and the cart transform work in. Converting
       * here, at the single formatting boundary, keeps every displayed price in
       * step with the Ex/Inc VAT toggle without touching what gets stored.
       */
      formatCents(cents) {
        const value = Number(cents);
        if (!Number.isFinite(value)) return '£0.00';

        let display = value;
        if (this.vatDisplayIncludesTax && this.metafieldVatRatePercent != null) {
          const multiplier = 1 + this.metafieldVatRatePercent / 100;
          if (Number.isFinite(multiplier) && multiplier > 0) display = value * multiplier;
        }

        return `£${(display / 100).toFixed(2)}`;
      }

      vatBasisLabel() {
        return this.vatDisplayIncludesTax ? 'inc VAT' : 'ex VAT';
      }

      /** Repaints every price after the shopper flips the Ex/Inc VAT toggle. */
      refreshPriceDisplays() {
        this.metafieldVatRatePercent = this.resolveMetafieldVatRate();
        this.renderPositionChoices(this.getSelectedPositions());
        this.renderPositionAssignments();
        this.renderLogoAssignments();
        this.updateSetupNoteTitle();
        this.updateSelectionSummary();
        this.refreshDynamicChoiceOptions({ preserveSelection: true });
      }

      /**
       * The storefront toggle writes localStorage inside its own click handler,
       * so repaint on the next tick once the new mode has landed.
       */
      handleVatToggleClick(event) {
        if (!event.target?.closest?.('[data-vat-toggle-switch]')) return;
        window.setTimeout(() => this.refreshPriceDisplays(), 0);
      }

      isAllowedLogoArtworkFile(file) {
        if (!file) return true;
        const name = String(file.name || '').trim().toLowerCase();
        const type = String(file.type || '').trim().toLowerCase();
        const allowedTypes = new Set(['application/pdf', 'image/jpeg', 'image/png', 'image/pjpeg']);
        const hasAllowedExtension = /\.(pdf|jpe?g|png)$/i.test(name);
        const hasAllowedType = !type || allowedTypes.has(type);
        return hasAllowedExtension && hasAllowedType;
      }

      getSelectedLogoFiles() {
        const files = Array.from(this.logoFileInput?.files || []).filter(Boolean);
        return files;
      }

      getLogoArtworkLimit(positions) {
        const selectedCount = Array.isArray(positions) ? positions.length : this.getSelectedPositions().length;
        return Math.min(3, Math.max(1, Number.parseInt(selectedCount, 10) || 0));
      }

      updateArtworkLimitHint(positions) {
        if (!this.logoUploadLimitHintElement) return;
        const limit = this.getLogoArtworkLimit(positions);
        this.logoUploadLimitHintElement.textContent = `Upload up to ${limit} file${limit === 1 ? '' : 's'}.`;
      }

      updateLogoFileInputAvailability(positions) {
        if (!this.logoFileInput) return;
        const limit = this.getLogoArtworkLimit(positions);
        const existingCountRaw = (Array.isArray(this.existingLogoArtworks) ? this.existingLogoArtworks : []).length;
        const existingCount =
          existingCountRaw || (this.normalizeArtworkUrl(this.existingLogoArtworkUrl) ? 1 : 0);
        const uploadCount = this.getSelectedLogoFiles().length;
        const totalCount = existingCount + uploadCount;
        const shouldDisable = totalCount >= limit;
        this.logoFileInput.disabled = shouldDisable;
        this.logoFileInput.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
      }

      setLogoFiles(files) {
        // Kick off hashing as soon as files are chosen; by submit time the
        // cache is warm and buildProperties can stay synchronous.
        Promise.resolve().then(() => this.cacheArtworkHashes());
        if (!this.logoFileInput) return;
        const safeFiles = Array.isArray(files) ? files.filter(Boolean) : [];
        if (!safeFiles.length) {
          this.logoFileInput.value = '';
          return;
        }
        if (typeof DataTransfer === 'undefined') {
          this.logoFileInput.value = '';
          return;
        }
        const transfer = new DataTransfer();
        safeFiles.forEach((file) => {
          try {
            transfer.items.add(file);
          } catch (error) {
            // ignore unsupported files
          }
        });
        this.logoFileInput.files = transfer.files;
      }

      setExistingLogoArtworks(artworks, options = {}) {
        const showError = options?.showError !== false;
        const limit = this.getLogoArtworkLimit(options?.positions);
        const normalized = [];
        const seen = new Set();
        (Array.isArray(artworks) ? artworks : []).forEach((artwork, index) => {
          const url = this.normalizeArtworkUrl(artwork?.url || '');
          if (!url) return;
          const key = url.toLowerCase();
          if (seen.has(key)) return;
          seen.add(key);
          normalized.push({
            url,
            name: String(artwork?.name || '').trim() || this.getArtworkDisplayName(url, `Logo ${index + 1}`),
          });
        });
        if (normalized.length > limit) {
          if (showError) {
            this.showError(`You can select up to ${limit} logo${limit === 1 ? '' : 's'} for the chosen position(s).`);
          }
          normalized.length = limit;
        }
        this.existingLogoArtworks = normalized;
        this.existingLogoArtworkUrl = normalized[0]?.url || '';
        this.existingLogoArtworkName = normalized[0]?.name || '';
      }

      enforceArtworkLimit(options = {}) {
        const showError = options?.showError !== false;
        const limit = this.getLogoArtworkLimit(options?.positions);
        let wasTrimmed = false;

        const existingEntries = Array.isArray(this.existingLogoArtworks) ? this.existingLogoArtworks : [];
        if (existingEntries.length > limit) {
          this.setExistingLogoArtworks(existingEntries.slice(0, limit), { showError: false, positions: options?.positions });
          wasTrimmed = true;
        }
        const normalizedExistingCount = (Array.isArray(this.existingLogoArtworks) ? this.existingLogoArtworks : []).length;
        const availableSlots = Math.max(0, limit - normalizedExistingCount);
        const selectedFiles = this.getSelectedLogoFiles();
        if (selectedFiles.length > availableSlots) {
          this.setLogoFiles(selectedFiles.slice(0, availableSlots));
          wasTrimmed = true;
        }

        if (wasTrimmed && showError) {
          this.showError(`You can use up to ${limit} logo${limit === 1 ? '' : 's'} for the selected position(s).`);
        }

        return { limit, wasTrimmed };
      }

      getSelectedLogoArtworks() {
        const limit = this.getLogoArtworkLimit();
        const existingArtworks = Array.isArray(this.existingLogoArtworks) ? this.existingLogoArtworks : [];
        const normalizedExisting = existingArtworks
          .map((artwork, index) => {
            const artworkUrl = this.normalizeArtworkUrl(artwork?.url || '');
            if (!artworkUrl) return null;
            const displayName = this.getArtworkDisplayName(artworkUrl, artwork?.name || '');
            const normalizedIdentity = `${artworkUrl}`.trim().toLowerCase();
            return {
              kind: 'url',
              url: artworkUrl,
              name: displayName || `Logo ${index + 1}`,
              identity: `url:${normalizedIdentity}`,
              fromCustomerMetafield: this.isCustomerMetafieldArtworkUrl(artworkUrl),
              sourceIndex: index,
            };
          })
          .filter(Boolean)
          .slice(0, limit);

        const availableFileSlots = Math.max(0, limit - normalizedExisting.length);
        const files = this.getSelectedLogoFiles().slice(0, availableFileSlots);
        const fileEntries = files.map((file, index) => ({
          kind: 'file',
          file,
          name: String(file?.name || '').trim() || `Artwork ${index + 1}`,
          identity: `file:${this.getFileSignature(file) || String(file?.name || '').trim().toLowerCase()}`,
          fromCustomerMetafield: false,
          sourceIndex: index,
        }));

        if (normalizedExisting.length || fileEntries.length) {
          return [...normalizedExisting, ...fileEntries];
        }

        const artworkUrl = this.normalizeArtworkUrl(this.existingLogoArtworkUrl);
        if (!artworkUrl) return [];
        const displayName = this.getArtworkDisplayName(artworkUrl, this.existingLogoArtworkName);
        return [
          {
            kind: 'url',
            url: artworkUrl,
            name: displayName,
            identity: `url:${`${artworkUrl}`.trim().toLowerCase()}`,
            fromCustomerMetafield: this.isCustomerMetafieldArtworkUrl(artworkUrl),
            sourceIndex: 0,
          },
        ];
      }

      getNonCustomerUniqueArtworkCount(artworks) {
        const identities = new Set();
        (Array.isArray(artworks) ? artworks : []).forEach((artwork) => {
          if (!artwork || artwork.fromCustomerMetafield) return;
          const identity = String(artwork.identity || '').trim().toLowerCase();
          if (!identity) return;
          identities.add(identity);
        });
        return identities.size;
      }

      resolveMetafieldVatInclusion() {
        const configured = window.NewLogoConfig?.prices?.metafieldIncludesVat;
        if (typeof configured === 'boolean') return configured;
        return true;
      }

      resolveMetafieldVatRate() {
        const toggle = document.querySelector('[data-vat-toggle]');
        if (!toggle) return null;
        const parsedRate = Number.parseFloat(String(toggle.dataset.vatRate || '').trim());
        if (!Number.isFinite(parsedRate) || parsedRate < 0) return null;
        return parsedRate;
      }

      normaliseMetafieldPriceCents(cents) {
        const value = Number(cents);
        if (!Number.isFinite(value) || value <= 0) return 0;

        if (!this.metafieldPricesIncludeVat) return Math.round(value);
        if (this.metafieldVatRatePercent == null) return Math.round(value);

        const multiplier = 1 + this.metafieldVatRatePercent / 100;
        if (!Number.isFinite(multiplier) || multiplier <= 0) return Math.round(value);

        return Math.round(value / multiplier);
      }

      /**
       * Tax-inclusive counterpart of normaliseMetafieldPriceCents.
       *
       * The cart transform function adds this to the garment's line price, and
       * storefront prices here include tax — so it needs the gross amount, not
       * the exclusive one stored for display.
       */
      grossMetafieldPriceCents(cents) {
        const value = Number(cents);
        if (!Number.isFinite(value) || value <= 0) return 0;

        if (this.metafieldPricesIncludeVat) return Math.round(value);
        if (this.metafieldVatRatePercent == null) return Math.round(value);

        const multiplier = 1 + this.metafieldVatRatePercent / 100;
        if (!Number.isFinite(multiplier) || multiplier <= 0) return Math.round(value);

        return Math.round(value * multiplier);
      }

      getUniquePositionLabels() {
        const labels = [];
        const seen = new Set();
        this.customisationOptions.forEach((option) => {
          if (seen.has(option.positionLabel)) return;
          seen.add(option.positionLabel);
          labels.push(option.positionLabel);
        });
        return labels;
      }

      getAvailableMethodsForPosition(positionLabel) {
        const methods = [];
        const seen = new Set();
        this.customisationOptions.forEach((option) => {
          if (option.positionLabel !== positionLabel) return;
          if (seen.has(option.methodKey)) return;
          seen.add(option.methodKey);
          methods.push(option.methodKey);
        });
        return methods;
      }

      /** Cheapest per-item price for one position across every method, ex VAT. */
      getPositionFromCents(positionLabel) {
        return this.customisationOptions.reduce((lowest, option) => {
          if (option.positionLabel !== positionLabel) return lowest;
          const cents = this.normaliseMetafieldPriceCents(option.unitPriceCents);
          if (cents <= 0) return lowest;
          return lowest === 0 ? cents : Math.min(lowest, cents);
        }, 0);
      }

      /**
       * Cheapest achievable per-item total for a set of positions, plus the
       * setup fee range, used to price the summary before method and size are
       * settled. Setup is reported as a range because it usually depends on the
       * method — printing often carries no setup fee where embroidery does, so
       * a single "from" figure would misrepresent one of the two.
       */
      getEstimateForPositions(positions) {
        const list = Array.isArray(positions) ? positions : [];
        const perItemCents = list.reduce((sum, positionLabel) => sum + this.getPositionFromCents(positionLabel), 0);

        let setupMinCents = null;
        let setupMaxCents = 0;
        list.forEach((positionLabel) => {
          this.customisationOptions.forEach((option) => {
            if (option.positionLabel !== positionLabel) return;
            const fee = Number(option.setupFeeCents) > 0 ? this.digitisationFeeUnitCents : 0;
            setupMaxCents = Math.max(setupMaxCents, fee);
            setupMinCents = setupMinCents == null ? fee : Math.min(setupMinCents, fee);
          });
        });

        return {
          perItemCents,
          setupMinCents: setupMinCents || 0,
          setupMaxCents,
          setupVaries: (setupMinCents || 0) !== setupMaxCents,
        };
      }

      /**
       * The setup fee is billed by a fixed-price digitisation product, not by
       * the metaobject, so quote the number that actually gets charged.
       *
       * `setup_fee_cents` on the option is still what decides *whether* a fee
       * applies (printing carries none, embroidery does) — only the amount
       * comes from here. Keeps the quote from drifting away from the invoice
       * when the metaobject and the product price disagree.
       *
       * Exclusive of VAT, matching every other amount in this file.
       */
      get digitisationFeeUnitCents() {
        const configured = Number(window.NewLogoConfig?.prices?.digitalisationCents);
        return Number.isFinite(configured) && configured > 0 ? Math.round(configured) : 1800;
      }

      /** Cheapest per-item price for one position and method, ex VAT. */
      getPositionMethodFromCents(positionLabel, methodKey) {
        const normalizedMethod = this.normalizeChoiceKey(methodKey);
        return this.customisationOptions.reduce((lowest, option) => {
          if (option.positionLabel !== positionLabel) return lowest;
          if (option.methodKey !== normalizedMethod) return lowest;
          const cents = this.normaliseMetafieldPriceCents(option.unitPriceCents);
          if (cents <= 0) return lowest;
          return lowest === 0 ? cents : Math.min(lowest, cents);
        }, 0);
      }

      getPositionAvailabilityRows(positionLabel) {
        const availableMethodList = this.getAvailableMethodsForPosition(positionLabel);
        const availableMethods = new Set(availableMethodList);
        const preferredMethods = ['print', 'embroidery'];
        const rows = [];

        const buildRow = (methodKey) => ({
          methodKey,
          label: this.humanizeChoiceKey(methodKey),
          fromCents: this.getPositionMethodFromCents(positionLabel, methodKey),
        });

        preferredMethods.forEach((methodKey) => {
          if (!availableMethods.has(methodKey)) return;
          rows.push(buildRow(methodKey));
        });

        availableMethodList.forEach((methodKey) => {
          if (preferredMethods.includes(methodKey)) return;
          rows.push(buildRow(methodKey));
        });

        return rows;
      }

      getMethodIconMarkup(methodKey) {
        const normalized = this.normalizeChoiceKey(methodKey);
        if (normalized === 'print') {
          return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 18 18" aria-hidden="true" focusable="false"><path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/><path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"/></svg>`;
        }

        if (normalized === 'embroidery') {
          return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true" focusable="false"><path stroke-linejoin="round" d="M1.48291 6.99988c0.00643-1.39437 0.15366-2.81505 0.41703-4.56238h6.97872c0.26337 1.74733 0.4106 3.16827 0.41703 4.56264m-7.81251-0.01468c0.00642 1.39437 0.15366 2.81504 0.41703 4.56234l6.97818 0.0003c0.26337-1.74734 0.4106-3.16801 0.41703-4.56238"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.38965 2.4375V0.625"/><path stroke-linecap="round" stroke-linejoin="round" d="m1.08691 2.4375 8.60656 0"/><path stroke-linecap="round" stroke-linejoin="round" d="m1.67284 4.62662 7.586 0.99368"/><path stroke-linecap="round" stroke-linejoin="round" d="M1.50703 7.80939 12.8991 9.32281"/><path stroke-linecap="round" stroke-linejoin="round" d="M1.08691 11.5625h8.60656"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.38965 13.375v-1.8125"/></svg>`;
        }

        return '';
      }

      getApplicationMethodIconMarkup(methodKey) {
        const normalized = this.normalizeChoiceKey(methodKey);
        if (normalized === 'print') {
          return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/><path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"/></svg>`;
        }

        if (normalized === 'embroidery') {
          return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true" focusable="false"><path stroke-linejoin="round" d="M1.48291 6.99988c0.00643-1.39437 0.15366-2.81505 0.41703-4.56238h6.97872c0.26337 1.74733 0.4106 3.16827 0.41703 4.56264m-7.81251-0.01468c0.00642 1.39437 0.15366 2.81504 0.41703 4.56234l6.97818 0.0003c0.26337-1.74734 0.4106-3.16801 0.41703-4.56238"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.38965 2.4375V0.625"/><path stroke-linecap="round" stroke-linejoin="round" d="m1.08691 2.4375 8.60656 0"/><path stroke-linecap="round" stroke-linejoin="round" d="m1.67284 4.62662 7.586 0.99368"/><path stroke-linecap="round" stroke-linejoin="round" d="M1.50703 7.80939 12.8991 9.32281"/><path stroke-linecap="round" stroke-linejoin="round" d="M1.08691 11.5625h8.60656"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.38965 13.375v-1.8125"/></svg>`;
        }

        return '';
      }

      getPositionImageUrl(positionLabel) {
        const options = this.customisationOptionsByPosition.get(positionLabel) || [];
        for (let i = 0; i < options.length; i += 1) {
          const candidate = this.resolveRuntimeImageUrl(options[i]?.positionImageUrl || '');
          if (candidate) return candidate;
        }
        return '';
      }

      getPositionImageFocalPoint(positionLabel) {
        const options = this.customisationOptionsByPosition.get(positionLabel) || [];
        for (let i = 0; i < options.length; i += 1) {
          const parsed =
            this.parseFocalPoint(options[i]?.positionImageFocalPoint) ||
            this.parseFocalPoint(options[i]?.positionImageFocalPointRaw);
          if (parsed) return parsed;
        }
        return null;
      }

      getAvailableMethodsForPositions(selectedPositions) {
        const allMethods = [];
        const seenMethods = new Set();
        this.customisationOptions.forEach((option) => {
          if (seenMethods.has(option.methodKey)) return;
          seenMethods.add(option.methodKey);
          allMethods.push(option.methodKey);
        });

        if (!selectedPositions.length) return allMethods;

        let allowedMethods = null;
        selectedPositions.forEach((positionLabel) => {
          const methodsForPosition = new Set(
            this.customisationOptions
              .filter((option) => option.positionLabel === positionLabel)
              .map((option) => option.methodKey)
          );
          if (allowedMethods === null) {
            allowedMethods = methodsForPosition;
            return;
          }
          allowedMethods = new Set(Array.from(allowedMethods).filter((methodKey) => methodsForPosition.has(methodKey)));
        });

        const finalSet = allowedMethods || new Set();
        return allMethods.filter((methodKey) => finalSet.has(methodKey));
      }

      getAvailableSizesForSelection(selectedPositions, methodKey) {
        const normalizedMethod = this.normalizeChoiceKey(methodKey);
        if (!normalizedMethod) return [];

        const allSizes = [];
        const seenSizes = new Set();
        this.customisationOptions.forEach((option) => {
          if (option.methodKey !== normalizedMethod || seenSizes.has(option.sizeKey)) return;
          seenSizes.add(option.sizeKey);
          allSizes.push(option.sizeKey);
        });

        if (!selectedPositions.length) return allSizes;

        let allowedSizes = null;
        selectedPositions.forEach((positionLabel) => {
          const sizesForPosition = new Set(
            this.customisationOptions
              .filter((option) => option.positionLabel === positionLabel && option.methodKey === normalizedMethod)
              .map((option) => option.sizeKey)
          );
          if (allowedSizes === null) {
            allowedSizes = sizesForPosition;
            return;
          }
          allowedSizes = new Set(Array.from(allowedSizes).filter((sizeKey) => sizesForPosition.has(sizeKey)));
        });

        const finalSet = allowedSizes || new Set();
        return allSizes.filter((sizeKey) => finalSet.has(sizeKey));
      }

      getOptionForPosition(positionLabel, methodKey, sizeKey) {
        const normalizedMethod = this.normalizeChoiceKey(methodKey);
        const normalizedSize = this.normalizeChoiceKey(sizeKey);
        return (
          this.customisationOptions.find(
            (option) =>
              option.positionLabel === positionLabel &&
              option.methodKey === normalizedMethod &&
              option.sizeKey === normalizedSize
          ) || null
        );
      }

      getPricingRows(positions, methodKey, sizeKey) {
        return (positions || [])
          .map((positionLabel) => this.getOptionForPosition(positionLabel, methodKey, sizeKey))
          .filter((option) => option);
      }

      getPerItemPriceCents(positions, methodKey, sizeKey) {
        const rows = this.getPricingRows(positions, methodKey, sizeKey);
        if (!rows.length || rows.length !== (positions || []).length) return null;
        return rows.reduce((sum, option) => sum + this.normaliseMetafieldPriceCents(option.unitPriceCents), 0);
      }

      getSelectionSetupFeeCents(positions, methodKey, sizeKey) {
        const rows = this.getPricingRows(positions, methodKey, sizeKey);
        if (!rows.length || rows.length !== (positions || []).length) return 0;
        return rows.reduce(
          (maxFee, option) => Math.max(maxFee, Number(option.setupFeeCents) > 0 ? this.digitisationFeeUnitCents : 0),
          0
        );
      }

      hasSetupFeeForMethod(positions, methodKey) {
        const availableSizes = this.getAvailableSizesForSelection(positions, methodKey);
        return availableSizes.some((sizeKey) => this.getSelectionSetupFeeCents(positions, methodKey, sizeKey) > 0);
      }

      renderPositionChoices(selectedPositions) {
        if (!this.positionsContainer) return;

        const selectedSet = new Set((selectedPositions || []).map((label) => String(label || '').trim()));
        const positions = this.getUniquePositionLabels();
        const assignments = this.getCurrentAssignments();
        const assignmentByPosition = new Map(assignments.map((assignment) => [assignment.positionLabel, assignment]));
        const logoChoices = this.getSelectedLogoChoices();
        const logoChoiceById = new Map(logoChoices.map((choice) => [String(choice.id || ''), choice]));
        this.cleanupPositionVisualObjectUrls();
        this.positionsContainer.innerHTML = '';

        positions.forEach((positionLabel, index) => {
          const inputId = `logo-position-${this.choiceRenderToken}-${index}`;
          const choice = document.createElement('div');
          choice.className = 'logo-customiser__choice';
          const input = document.createElement('input');
          input.id = inputId;
          input.className = 'logo-customiser__choice-input';
          input.type = 'checkbox';
          input.name = 'logo_positions';
          input.value = positionLabel;
          input.checked = selectedSet.has(positionLabel);

          const label = document.createElement('label');
          label.className = 'logo-customiser__choice-label logo-customiser__choice-label--position';
          label.setAttribute('for', inputId);

          const title = document.createElement('span');
          title.className = 'logo-customiser__position-title';
          title.textContent = positionLabel;

          const artworkWrap = document.createElement('span');
          artworkWrap.className = 'logo-customiser__position-artwork';
          const imageUrl = this.getPositionImageUrl(positionLabel);
          if (imageUrl) {
            const artworkFrame = document.createElement('span');
            artworkFrame.className = 'logo-customiser__position-artwork-frame';
            const artworkImage = document.createElement('img');
            artworkImage.className = 'logo-customiser__position-artwork-image';
            artworkImage.src = imageUrl;
            artworkImage.alt = positionLabel;
            artworkImage.loading = 'lazy';
            artworkImage.width = 220;
            artworkImage.height = 220;
            artworkFrame.appendChild(artworkImage);

            const assignment = assignmentByPosition.get(positionLabel) || null;
            const selectedChoice =
              (assignment?.logoId ? logoChoiceById.get(String(assignment.logoId || '')) : null) || logoChoices[0] || null;
            const logoPreview = this.getPositionLogoVisualPreview(selectedChoice);
            const focalPoint = this.getPositionImageFocalPoint(positionLabel) || { x: 50, y: 50 };
            const hasAssignmentSizing = Boolean(assignment?.sizeKey);

            // Typed lines are global, so this must be qualified by whether *this*
            // card is the one drawing them. Testing the lines alone stripped the
            // focal marker from every card as soon as any text was entered.
            const textLinesForCard = this.hasText() ? this.getTextLines() : [];
            const cardDrawsText = textLinesForCard.length > 0 && selectedSet.has(positionLabel);
            const cardDrawsLogo =
              this.hasArtwork() &&
              logoPreview.previewable &&
              logoPreview.url &&
              selectedSet.has(positionLabel) &&
              hasAssignmentSizing;

            if (cardDrawsText) {
              const textVisual = document.createElement('span');
              textVisual.className = 'logo-customiser__position-text-visual';
              textVisual.style.left = `${focalPoint.x}%`;
              textVisual.style.top = `${focalPoint.y}%`;
              textVisual.style.fontFamily = this.getTextFont().stack || 'inherit';
              const cardAssignment = assignmentByPosition.get(positionLabel) || null;
              textVisual.style.setProperty(
                '--logo-visual-scale',
                String(this.getPositionVisualScale(cardAssignment?.methodKey, cardAssignment?.sizeKey))
              );
              textLinesForCard.forEach((line, lineIndex) => {
                const row = document.createElement('span');
                row.textContent = line;
                row.style.color = this.getTextColour(lineIndex).hex || '#111111';
                textVisual.appendChild(row);
              });
              artworkFrame.appendChild(textVisual);
            } else if (cardDrawsLogo) {
              const visual = document.createElement('span');
              visual.className = 'logo-customiser__position-logo-visual';
              visual.style.left = `${focalPoint.x}%`;
              visual.style.top = `${focalPoint.y}%`;
              visual.style.setProperty(
                '--logo-visual-scale',
                String(this.getPositionVisualScale(assignment?.methodKey, assignment?.sizeKey))
              );

              const visualImage = document.createElement('img');
              visualImage.className = 'logo-customiser__position-logo-visual-image';
              visualImage.src = logoPreview.url;
              visualImage.alt = selectedChoice?.label || 'Logo preview';
              visualImage.loading = 'lazy';
              visual.appendChild(visualImage);
              artworkFrame.appendChild(visual);
            }

            // The focal dot is the fallback for a card drawing nothing at all,
            // so it has to account for both halves now.
            if (!cardDrawsText && !cardDrawsLogo && focalPoint) {
              const marker = document.createElement('span');
              marker.className = 'logo-customiser__position-focal-marker';
              marker.style.left = `${focalPoint.x}%`;
              marker.style.top = `${focalPoint.y}%`;
              marker.setAttribute('aria-hidden', 'true');
              marker.innerHTML =
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="12" r="9.25"/><path d="M12 8v8M8 12h8"/></svg>';
              artworkFrame.appendChild(marker);
            }

            artworkWrap.appendChild(artworkFrame);
          } else {
            if (!this.missingPositionImageDebugSet.has(positionLabel)) {
              this.missingPositionImageDebugSet.add(positionLabel);
              const optionSample = (this.customisationOptionsByPosition.get(positionLabel) || []).slice(0, 3).map((row) => ({
                id: row.id,
                positionLabel: row.positionLabel,
                methodKey: row.methodKey,
                sizeKey: row.sizeKey,
                positionImageUrl: row.positionImageUrl || '',
                position_image_raw: row.positionImageRaw || '',
                position_image_html: row.positionImageHtml || '',
                position_image_ref_urls: row.positionImageRefUrls || '',
                position_image_focal_point: row.positionImageFocalPointRaw || row.positionImageFocalPoint || '',
              }));
              console.warn('Logo customiser position image missing', {
                positionLabel,
                optionSample,
              });
            }
            const artworkFallback = document.createElement('span');
            artworkFallback.className = 'logo-customiser__position-artwork-fallback';
            artworkFallback.textContent = 'No image';
            artworkWrap.appendChild(artworkFallback);
          }

          const availabilityWrap = document.createElement('span');
          availabilityWrap.className = 'logo-customiser__position-methods';
          const availabilityRows = this.getPositionAvailabilityRows(positionLabel);
          availabilityRows.forEach((row) => {
            const methodLine = document.createElement('span');
            methodLine.className = `logo-customiser__position-method logo-customiser__position-method--${row.methodKey}`;
            const iconWrap = document.createElement('span');
            iconWrap.className = 'logo-customiser__position-method-icon';
            iconWrap.innerHTML = this.getMethodIconMarkup(row.methodKey);

            const text = document.createElement('span');
            text.className = 'logo-customiser__position-method-text';
            text.textContent = row.label;

            methodLine.appendChild(iconWrap);
            methodLine.appendChild(text);

            // Showing the entry price here means the shopper knows what a
            // position costs before committing to it, rather than after step 3.
            if (row.fromCents > 0) {
              const price = document.createElement('span');
              price.className = 'logo-customiser__position-method-price';
              price.textContent = `from ${this.formatCents(row.fromCents)}`;
              methodLine.appendChild(price);
            } else {
              text.textContent = `${row.label} available`;
            }

            availabilityWrap.appendChild(methodLine);
          });

          label.appendChild(artworkWrap);
          label.appendChild(title);
          if (availabilityRows.length) {
            label.appendChild(availabilityWrap);
          }

          choice.appendChild(input);
          choice.appendChild(label);
          this.positionsContainer.appendChild(choice);
        });
      }

      renderMethodChoices(methodKeys, selectedMethod) {
        if (!this.methodsContainer) return;

        const normalizedSelected = this.normalizeChoiceKey(selectedMethod);
        this.methodsContainer.innerHTML = '';

        methodKeys.forEach((methodKey, index) => {
          const inputId = `logo-method-${this.choiceRenderToken}-${index}`;
          const labelText = this.humanizeChoiceKey(methodKey);
          const choice = document.createElement('div');
          choice.className = 'logo-customiser__choice';
          const input = document.createElement('input');
          input.id = inputId;
          input.className = 'logo-customiser__choice-input';
          input.type = 'radio';
          input.name = 'logo_method';
          input.value = methodKey;
          input.checked = methodKey === normalizedSelected;

          const label = document.createElement('label');
          label.className = 'logo-customiser__choice-label';
          label.setAttribute('for', inputId);

          const iconMarkup = this.getApplicationMethodIconMarkup(methodKey);
          if (iconMarkup) {
            const icon = document.createElement('span');
            icon.className = 'logo-customiser__choice-icon';
            icon.innerHTML = iconMarkup;
            label.appendChild(icon);
          }

          const text = document.createElement('span');
          text.className = 'logo-customiser__choice-text';
          text.textContent = labelText;
          label.appendChild(text);

          choice.appendChild(input);
          choice.appendChild(label);
          this.methodsContainer.appendChild(choice);
        });
      }

      renderSizeChoices(sizeKeys, selectedSize, selectedPositions, methodKey) {
        if (!this.sizesContainer) return;

        const normalizedSelected = this.normalizeChoiceKey(selectedSize);
        this.sizesContainer.innerHTML = '';

        sizeKeys.forEach((sizeKey, index) => {
          const inputId = `logo-size-${this.choiceRenderToken}-${index}`;
          const baseLabel = this.humanizeChoiceKey(sizeKey);
          const perItemCents = this.getPerItemPriceCents(selectedPositions, methodKey, sizeKey);
          const labelText = Number.isFinite(perItemCents) ? `${baseLabel} - ${this.formatCents(perItemCents)}` : baseLabel;
          const choice = document.createElement('div');
          choice.className = 'logo-customiser__choice';
          const input = document.createElement('input');
          input.id = inputId;
          input.className = 'logo-customiser__choice-input';
          input.type = 'radio';
          input.name = 'logo_size_tier';
          input.value = sizeKey;
          input.checked = sizeKey === normalizedSelected;

          const label = document.createElement('label');
          label.className = 'logo-customiser__choice-label';
          label.setAttribute('for', inputId);

          const text = document.createElement('span');
          text.className = 'logo-customiser__choice-text logo-customiser__choice-text--size';

          const textMain = document.createElement('span');
          textMain.className = 'logo-customiser__choice-text-main';
          textMain.textContent = labelText;
          text.appendChild(textMain);

          const sizeDimensionLabel = this.getSizeDimensionLabel(methodKey, sizeKey);
          if (sizeDimensionLabel) {
            const textSub = document.createElement('span');
            textSub.className = 'logo-customiser__choice-text-sub';
            textSub.textContent = sizeDimensionLabel;
            text.appendChild(textSub);
          }

          label.appendChild(text);
          choice.appendChild(input);
          choice.appendChild(label);
          this.sizesContainer.appendChild(choice);
        });
      }

      refreshDynamicChoiceOptions(options = {}) {
        const preferredMethod = this.normalizeChoiceKey(
          options.preferredMethod || this.preferredMethodKey || this.getSelectedMethod()
        );
        const preferredSize = this.normalizeChoiceKey(options.preferredSize || this.getSelectedSizeTier());
        const selectedPositions = this.getSelectedPositions();
        const availableMethods = this.getAvailableMethodsForPositions(selectedPositions);
        const nextMethod = availableMethods.includes(preferredMethod) ? preferredMethod : availableMethods[0] || '';

        this.renderMethodChoices(availableMethods, nextMethod);

        const methodAfterRender = this.getSelectedMethod();
        const availableSizes = this.getAvailableSizesForSelection(selectedPositions, methodAfterRender);
        const nextSize = availableSizes.includes(preferredSize) ? preferredSize : availableSizes[0] || '';

        this.renderSizeChoices(availableSizes, nextSize, selectedPositions, methodAfterRender);
      }

      updateAsideAlignment() {
        if (!this.asideElement) return;
        if (!this.form || !this.isModalMode || !window.matchMedia('(min-width: 1024px)').matches) {
          this.asideElement.style.marginTop = '0px';
          return;
        }

        const activeCard = this.form.querySelector('.logo-customiser__card:not([hidden]):not(.hidden)');
        if (!activeCard) {
          this.asideElement.style.marginTop = '0px';
          return;
        }

        const formRect = this.form.getBoundingClientRect();
        const cardRect = activeCard.getBoundingClientRect();
        const offset = Math.max(0, Math.round(cardRect.top - formRect.top));
        this.asideElement.style.marginTop = `${offset}px`;
        this.updateGroupListScrollState();
      }

      normalizeGroup(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      resolveGroupForItem(item) {
        const properties = item?.properties || {};
        const fromProperties = this.normalizeGroup(properties._logo_customisation_group || properties['Logo Group'] || '');
        if (fromProperties) return fromProperties;

        const handle = String(item?.handle || '').trim();
        const mapped = this.normalizeGroup(window.NewLogoConfig?.products?.byHandle?.[handle] || '');
        if (mapped) return mapped;

        return '';
      }

      isCustomisableItem(item) {
        const properties = item?.properties || {};
        if (!item?.key) return false;
        if (properties._logo_charge_type != null || properties._logo_parent_key != null) return false;
        return true;
      }

      getGroupEligibleItems(cart, primaryItem) {
        const items = Array.isArray(cart?.items) ? cart.items : [];
        if (!primaryItem || !items.length) return [];

        const eligibleByKey = new Map();
        const normalizedGroup = this.normalizeGroup(this.customisationGroup || this.resolveGroupForItem(primaryItem));
        const primaryProductId = Number.parseInt(primaryItem?.product_id, 10) || 0;
        const primaryHandle = String(primaryItem?.handle || '').trim();

        const isSameProduct = (item) => {
          const itemProductId = Number.parseInt(item?.product_id, 10) || 0;
          const itemHandle = String(item?.handle || '').trim();
          if (primaryProductId > 0 && itemProductId > 0) {
            return itemProductId === primaryProductId;
          }
          return Boolean(primaryHandle) && itemHandle === primaryHandle;
        };

        if (normalizedGroup) {
          this.customisationGroup = normalizedGroup;
          items.forEach((item) => {
            if (!this.isCustomisableItem(item)) return;
            const itemGroup = this.resolveGroupForItem(item);
            if (itemGroup !== normalizedGroup && !isSameProduct(item)) return;
            eligibleByKey.set(item.key, item);
          });
        } else {
          items.forEach((item) => {
            if (!this.isCustomisableItem(item)) return;
            if (!isSameProduct(item)) return;
            eligibleByKey.set(item.key, item);
          });
        }

        this.targetKeys.forEach((targetKey) => {
          const match = items.find((item) => item.key === targetKey);
          if (!match || !this.isCustomisableItem(match)) return;
          eligibleByKey.set(match.key, match);
        });

        eligibleByKey.set(primaryItem.key, primaryItem);

        const ordered = Array.from(eligibleByKey.values()).sort((a, b) => {
          const aLine = items.findIndex((item) => item.key === a.key);
          const bLine = items.findIndex((item) => item.key === b.key);
          if (a.key === primaryItem.key) return -1;
          if (b.key === primaryItem.key) return 1;
          return aLine - bLine;
        });

        return ordered;
      }

      resolveCustomisationProfile(properties) {
        const source = properties || {};
        const addedValue = String(source._logo_added || source['Logo Added'] || '').trim().toLowerCase();
        const method = String(source._logo_method || source['Logo Method'] || '').trim().toLowerCase();
        const type = String(source._logo_type || source['Logo Type'] || '').trim().toLowerCase();
        const sizeTier = String(source._logo_size_tier || source['Logo Size'] || '').trim().toLowerCase();
        const positions = String(source._logo_positions || source['Logo Positions'] || '')
          .split(/[,|]/)
          .map((value) => String(value || '').trim().toLowerCase())
          .filter(Boolean)
          .sort();
        const hasCustomisation =
          addedValue === 'yes' ||
          addedValue === 'true' ||
          addedValue === '1' ||
          Boolean(method || type || sizeTier || positions.length);

        return {
          hasCustomisation,
          type,
          method,
          sizeTier,
          positions,
        };
      }

      getCurrentSelectionProfile() {
        const parentProfile = this.resolveCustomisationProfile(this.parentItem?.properties || {});
        const selectedAssignments = this.getCurrentAssignments();
        const selectedMethodValues = Array.from(
          new Set(selectedAssignments.map((assignment) => this.normalizeChoiceKey(assignment.methodKey)).filter(Boolean))
        );
        const selectedSizeValues = Array.from(
          new Set(selectedAssignments.map((assignment) => this.normalizeChoiceKey(assignment.sizeKey)).filter(Boolean))
        );
        const selectedMethod =
          selectedMethodValues.length > 1
            ? 'mixed'
            : selectedMethodValues[0] || parentProfile.method;
        const selectedSizeTier =
          selectedSizeValues.length > 1
            ? 'mixed'
            : selectedSizeValues[0] || parentProfile.sizeTier;
        const selectedPositions = this.getSelectedPositions()
          .map((value) => String(value || '').trim().toLowerCase())
          .filter(Boolean)
          .sort();
        const positions = selectedPositions.length ? selectedPositions : parentProfile.positions || [];

        return {
          type: 'logo',
          method: selectedMethod,
          sizeTier: selectedSizeTier,
          positions,
        };
      }

      isGroupItemSelectionCompatible(item) {
        if (!item || !item.key) return false;
        if (this.parentItem && item.key === this.parentItem.key) return true;

        const existingProfile = this.resolveCustomisationProfile(item.properties || {});
        if (!existingProfile.hasCustomisation) return true;

        const baselineProfile =
          this.groupCompatibilityProfile || this.resolveCustomisationProfile(this.parentItem?.properties || {});
        if (!baselineProfile.hasCustomisation) return true;

        if (baselineProfile.type && existingProfile.type && existingProfile.type !== baselineProfile.type) return false;
        if (baselineProfile.method && existingProfile.method && existingProfile.method !== baselineProfile.method) return false;
        if (baselineProfile.sizeTier && existingProfile.sizeTier && existingProfile.sizeTier !== baselineProfile.sizeTier) return false;
        if (baselineProfile.positions?.length && existingProfile.positions?.length) {
          const selectedPositionsKey = baselineProfile.positions.join('|');
          const existingPositionsKey = existingProfile.positions.join('|');
          if (selectedPositionsKey !== existingPositionsKey) return false;
        }
        return true;
      }

      ensureGroupSelectorUI() {
        if (!this.asideElement) return;

        if (!this.targetStackElement) {
          this.targetStackElement = document.createElement('div');
          this.targetStackElement.className = 'logo-customiser__target-stack';
          this.targetStackElement.hidden = true;

          const productSummary = this.asideElement.querySelector('.logo-customiser__product');
          if (productSummary) {
            productSummary.insertAdjacentElement('beforebegin', this.targetStackElement);
          } else {
            this.asideElement.appendChild(this.targetStackElement);
          }
        }

        if (this.groupTargetSelectionElement) return;

        const wrap = document.createElement('section');
        wrap.className = 'logo-customiser__group-targets';
        wrap.hidden = true;

        wrap.innerHTML = `
          <p class="logo-customiser__tip logo-customiser__tip--compact">Tick the items that should get this same customisation.</p>
          <div class="logo-customiser__group-controls">
            <button type="button" class="logo-customiser__group-select-all-link" data-logo-group-select-all-link hidden aria-hidden="true">Select all</button>
          </div>
          <div class="logo-customiser__group-list-scroll" data-logo-group-list-scroll>
            <div class="logo-customiser__group-list" data-logo-group-list></div>
          </div>
        `;

        const summaryLines = this.asideElement.querySelector('.logo-customiser__summary-lines');
        if (summaryLines) {
          summaryLines.insertAdjacentElement('beforebegin', wrap);
        } else {
          this.asideElement.appendChild(wrap);
        }

        this.groupTargetSelectionElement = wrap;
        this.groupTargetListScroll = wrap.querySelector('[data-logo-group-list-scroll]');
        this.groupTargetList = wrap.querySelector('[data-logo-group-list]');
        this.groupTargetSelectAllLink = wrap.querySelector('[data-logo-group-select-all-link]');
        this.groupTargetSelectionElement.addEventListener('change', this.handleGroupTargetChangeBound);
        this.groupTargetSelectAllLink?.addEventListener('click', this.handleGroupSelectAllClickBound);
        this.groupTargetListScroll?.addEventListener('scroll', this.handleGroupListScrollBound);
      }

      updateGroupListScrollState() {
        const scrollWrap = this.groupTargetListScroll;
        if (!scrollWrap) return;
        if (scrollWrap.hidden || !this.isGroupListExpanded) {
          scrollWrap.classList.remove('is-scrollable');
          scrollWrap.classList.remove('is-scrolled');
          scrollWrap.classList.remove('is-at-bottom');
          scrollWrap.classList.remove('is-scrolling');
          return;
        }

        const scrollable = scrollWrap.scrollHeight - scrollWrap.clientHeight > 6;
        const scrolled = scrollWrap.scrollTop > 4;
        const atBottom = scrollWrap.scrollTop + scrollWrap.clientHeight >= scrollWrap.scrollHeight - 4;

        scrollWrap.classList.toggle('is-scrollable', scrollable);
        scrollWrap.classList.toggle('is-scrolled', scrolled);
        scrollWrap.classList.toggle('is-at-bottom', atBottom);
      }

      handleGroupListScroll() {
        const scrollWrap = this.groupTargetListScroll;
        if (!scrollWrap) return;
        scrollWrap.classList.add('is-scrolling');
        this.updateGroupListScrollState();
        if (this.groupListScrollFadeTimeout) {
          window.clearTimeout(this.groupListScrollFadeTimeout);
        }
        this.groupListScrollFadeTimeout = window.setTimeout(() => {
          if (!this.groupTargetListScroll) return;
          this.groupTargetListScroll.classList.remove('is-scrolling');
          this.updateGroupListScrollState();
        }, 180);
      }

      updateGroupTargetControls() {
        if (!this.groupTargetSelectAllLink) return;

        const hasListItems = Array.isArray(this.groupEligibleItems)
          ? this.groupEligibleItems.some((item) => item.key !== this.parentItem?.key)
          : false;
        if (this.groupTargetToggleButton) {
          this.groupTargetToggleButton.hidden = !hasListItems;
          // "Choose products" / "Hide products" said what to do rather than what
          // you have. A count with a chevron reads faster and needs no verb.
          const targetCount = this.targetKeys?.length || 0;
          const totalCount = this.groupTargetList?.querySelectorAll('.logo-customiser__group-option').length || 0;
          this.groupTargetToggleButton.textContent =
            totalCount > 0 ? `${targetCount} of ${totalCount} items` : 'This item only';
          this.groupTargetToggleButton.setAttribute('aria-expanded', this.isGroupListExpanded ? 'true' : 'false');
          this.groupTargetToggleButton.classList.toggle('is-open', Boolean(this.isGroupListExpanded));
          this.groupTargetToggleButton.setAttribute('aria-expanded', this.isGroupListExpanded ? 'true' : 'false');
        }
        if (this.groupTargetSelectionElement) {
          this.groupTargetSelectionElement.hidden = !hasListItems || !this.isGroupListExpanded;
        }
        if (this.groupTargetListScroll) {
          this.groupTargetListScroll.hidden = !this.isGroupListExpanded;
        }
        this.groupTargetSelectAllLink.hidden = !hasListItems || !this.isGroupListExpanded;
        this.groupTargetSelectAllLink.setAttribute(
          'aria-hidden',
          !hasListItems || !this.isGroupListExpanded ? 'true' : 'false'
        );
        this.groupTargetSelectAllLink.style.display = !hasListItems || !this.isGroupListExpanded ? 'none' : '';
        if (this.groupTargetList) {
          this.groupTargetList.hidden = false;
        }
        this.updateGroupListScrollState();
        if (!hasListItems) return;

        const selectableInputs = Array.from(this.groupTargetList?.querySelectorAll('[data-logo-group-item-key]') || []).filter(
          (input) => !input.disabled
        );
        this.groupTargetSelectAllLink.disabled = selectableInputs.length === 0;
        this.groupTargetSelectAllLink.setAttribute('aria-disabled', selectableInputs.length === 0 ? 'true' : 'false');
        const allSelectableSelected =
          selectableInputs.length > 0 && selectableInputs.every((input) => Boolean(input.checked));
        // A bare "All"/"None" chip floating above the list read as a label, not
        // a control. Say what pressing it does.
        this.groupTargetSelectAllLink.textContent = allSelectableSelected ? 'Clear all' : 'Select all';
      }

      syncGroupOptionSelectedClasses() {
        if (!this.groupTargetList) return;
        this.groupTargetList.querySelectorAll('.logo-customiser__group-option').forEach((option) => {
          const input = option.querySelector('[data-logo-group-item-key]');
          option.classList.toggle('is-selected', Boolean(input?.checked));
        });
      }

      handleGroupToggleClick(event) {
        event.preventDefault();
        this.isGroupListExpanded = !this.isGroupListExpanded;
        this.updateGroupTargetControls();
        window.requestAnimationFrame(() => this.updateGroupListScrollState());
      }

      updateAsideHeading() {
        return;
      }

      syncTargetItemsFromSelection() {
        const selectedSet = new Set(this.targetKeys);
        const selectedItems = (this.groupEligibleItems || []).filter((item) => selectedSet.has(item.key));

        if (!selectedItems.length && this.parentItem) {
          selectedItems.push(this.parentItem);
        }

        this.targetItems = selectedItems;
        this.targetKeys = selectedItems.map((item) => item.key);
        this.targetKey = this.targetKeys[0] || this.parentItem?.key || this.targetKey;
        this.setAttribute('data-target-keys', this.targetKeys.join(','));
      }

      renderGroupTargetStack() {
        if (!this.targetStackElement) return;
        this.targetStackElement.hidden = true;
        this.targetStackElement.innerHTML = '';
      }

      renderGroupTargetSelector() {
        this.ensureGroupSelectorUI();
        if (!this.groupTargetSelectionElement || !this.groupTargetList || !this.parentItem) return;

        const listItems = (Array.isArray(this.groupEligibleItems) ? this.groupEligibleItems : [])
          .filter((item) => item && item.key)
          .sort((a, b) => {
            if (a.key === this.parentItem.key) return -1;
            if (b.key === this.parentItem.key) return 1;
            return 0;
          });
        if (listItems.length <= 1) {
          this.groupTargetSelectionElement.hidden = true;
          this.asideElement?.classList.remove('logo-customiser__aside--with-group-targets');
          if (this.groupTargetListScroll) {
            this.groupTargetListScroll.hidden = true;
          }
          this.groupTargetList.hidden = false;
          this.groupTargetList.innerHTML = '';
          if (this.groupTargetSelectAllLink) {
            this.groupTargetSelectAllLink.hidden = true;
          }
          this.isGroupListExpanded = false;
          return;
        }

        this.groupTargetSelectionElement.hidden = !this.isGroupListExpanded;
        this.asideElement?.classList.add('logo-customiser__aside--with-group-targets');
        this.groupTargetList.innerHTML = '';
        const selectableKeySet = new Set(
          listItems
            .filter((item) => item.key !== this.parentItem.key && this.isGroupItemSelectionCompatible(item))
            .map((item) => item.key)
        );
        const normalizedSelectedKeys = this.targetKeys.filter(
          (key) => key === this.parentItem.key || selectableKeySet.has(key)
        );
        if (!normalizedSelectedKeys.includes(this.parentItem.key)) {
          normalizedSelectedKeys.unshift(this.parentItem.key);
        }
        this.targetKeys = normalizedSelectedKeys;
        this.syncTargetItemsFromSelection();
        const selectedKeySet = new Set(this.targetKeys);

        listItems.forEach((item) => {
          const option = document.createElement('div');
          option.className = 'logo-customiser__group-option';
          const inputId = `logo-group-option-${Math.random().toString(36).slice(2, 8)}`;
          const isPrimary = this.parentItem && item.key === this.parentItem.key;
          const isSelectable = isPrimary ? true : this.isGroupItemSelectionCompatible(item);

          const input = document.createElement('input');
          input.id = inputId;
          input.type = 'checkbox';
          input.className = 'logo-customiser__group-option-checkbox';
          input.value = String(item.key || '');
          input.checked = isSelectable && selectedKeySet.has(item.key);
          input.setAttribute('data-logo-group-item-key', String(item.key || ''));
          if (isPrimary || !isSelectable) {
            input.disabled = true;
            if (isPrimary) {
              input.checked = true;
            } else if (!isSelectable) {
              input.checked = false;
            }
          }
          option.classList.toggle('is-selected', Boolean(input.checked));

          const label = document.createElement('label');
          label.className = 'logo-customiser__group-option-label';
          label.setAttribute('for', inputId);
          if (!isSelectable) {
            option.classList.add('is-disabled');
            label.classList.add('is-disabled');
          }

          const textWrap = document.createElement('div');
          textWrap.className = 'logo-customiser__group-option-text';

          const title = document.createElement('div');
          title.className = 'logo-customiser__group-option-title';
          title.textContent = item.product_title || 'Product';

          const meta = document.createElement('div');
          meta.className = 'logo-customiser__group-option-meta';
          const variantText =
            item.variant_title && item.variant_title !== 'Default Title' ? String(item.variant_title) : '';
          const qtyText = `Qty: ${Number.parseInt(item.quantity, 10) || 0}`;
          meta.textContent = variantText ? `${variantText} \u00b7 ${qtyText}` : qtyText;

          textWrap.appendChild(title);
          textWrap.appendChild(meta);

          if (!isSelectable) {
            const status = document.createElement('div');
            status.className = 'logo-customiser__group-option-status';
            status.textContent = 'Customised';
            status.title = 'This item already has a different customisation, so it cannot share this one.';
            textWrap.appendChild(status);
          } else if (isPrimary) {
            const status = document.createElement('div');
            status.className = 'logo-customiser__group-option-status';
            status.textContent = 'Current';
            status.title = 'The item you opened the customiser from.';
            textWrap.appendChild(status);
          }

          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = item.product_title || 'Product';
            image.width = 32;
            image.height = 32;
            image.loading = 'lazy';
            image.className = 'logo-customiser__group-option-image';
            label.appendChild(image);
          }

          label.appendChild(textWrap);
          option.appendChild(input);
          option.appendChild(label);
          this.groupTargetList.appendChild(option);
        });
        this.syncGroupOptionSelectedClasses();
        this.updateGroupTargetControls();
        window.requestAnimationFrame(() => this.updateGroupListScrollState());
      }

      syncGroupTargetsFromCart(cart, primaryItem) {
        this.groupEligibleItems = this.getGroupEligibleItems(cart, primaryItem);
        const primaryKey = primaryItem?.key || '';
        const savedSelection = new Set(this.targetKeys);
        const selectedKeys = this.groupEligibleItems
          .filter((item) => savedSelection.has(item.key))
          .map((item) => item.key)
          .filter(Boolean);

        if (primaryKey && !selectedKeys.includes(primaryKey)) {
          selectedKeys.unshift(primaryKey);
        }
        if (!selectedKeys.length && primaryKey) selectedKeys.push(primaryKey);

        this.targetKeys = selectedKeys;
        this.isGroupListExpanded = false;
        this.syncTargetItemsFromSelection();
        this.renderGroupTargetSelector();
        this.renderGroupTargetStack();
        this.updateAsideHeading();
      }

      handleGroupSelectAllClick(event) {
        event.preventDefault();
        if (!this.parentItem || !this.groupTargetList) return;

        const selectableInputs = Array.from(this.groupTargetList.querySelectorAll('[data-logo-group-item-key]')).filter(
          (input) => !input.disabled
        );
        if (!selectableInputs.length) return;

        const allSelectableSelected = selectableInputs.every((input) => Boolean(input.checked));
        const selectedKeys = [this.parentItem.key];

        selectableInputs.forEach((input) => {
          if (allSelectableSelected) {
            input.checked = false;
            return;
          }
          input.checked = true;
          const key = String(input.value || '').trim();
          if (key && !selectedKeys.includes(key)) selectedKeys.push(key);
        });

        this.targetKeys = selectedKeys;
        this.syncTargetItemsFromSelection();
        this.syncGroupOptionSelectedClasses();
        this.renderGroupTargetStack();
        this.updateAsideHeading();
        this.renderProductSummary(this.parentItem);
        this.updateSelectionSummary();
        this.updateGroupTargetControls();
      }

      handleGroupTargetChange(event) {
        const target = event?.target;
        if (!target || !target.matches('[data-logo-group-item-key]')) return;
        if (!this.parentItem) return;

        const selectedKeys = [this.parentItem.key];
        this.groupTargetList?.querySelectorAll('[data-logo-group-item-key]:checked').forEach((input) => {
          const key = String(input.value || '').trim();
          if (!key || selectedKeys.includes(key)) return;
          selectedKeys.push(key);
        });

        this.targetKeys = selectedKeys;
        this.syncTargetItemsFromSelection();
        this.syncGroupOptionSelectedClasses();
        this.renderGroupTargetStack();
        this.updateAsideHeading();
        this.renderProductSummary(this.parentItem);
        this.updateSelectionSummary();
        this.updateGroupTargetControls();
      }

      async loadLineItem() {
        this.setLoading(true);
        this.clearError();

        try {
          const cart = await this.fetchCart();
          const { items, primaryItem, primaryLine } = this.resolveTargetItems(cart);

          if (!primaryItem || !primaryLine) {
            this.showError('Could not find that cart line item. Please return to cart and try again.');
            return;
          }

          this.parentItem = primaryItem;
          this.parentLine = primaryLine;
          this.groupCompatibilityProfile = this.resolveCustomisationProfile(primaryItem.properties || {});
          const itemHandle = primaryItem.handle || primaryItem.product_handle || '';
          const itemProductId = primaryItem.product_id || primaryItem.id || '';
          this.setCustomisationOptionsForHandle(itemHandle, itemProductId);
          if (!this.customisationOptions.length) {
            const runtime = window.NewLogoRuntime || {};
            const handleKeys = Object.keys(runtime.customisationOptionsByHandle || {});
            const idKeys = Object.keys(runtime.customisationOptionsByProductId || {});
            const sourceByHandle =
              runtime.customisationOptionsByHandle &&
              Object.prototype.hasOwnProperty.call(runtime.customisationOptionsByHandle, itemHandle)
                ? runtime.customisationOptionsByHandle[itemHandle]
                : null;
            const itemProductIdString = String(itemProductId || '');
            const sourceById =
              runtime.customisationOptionsByProductId &&
              itemProductIdString &&
              Object.prototype.hasOwnProperty.call(runtime.customisationOptionsByProductId, itemProductIdString)
                ? runtime.customisationOptionsByProductId[itemProductIdString]
                : null;
            const sourceOptionPreview = sourceByHandle ?? sourceById ?? null;
            console.warn('Logo customiser options not found', {
              handle: itemHandle,
              productId: itemProductIdString,
              runtimeHandleKeys: handleKeys,
              runtimeProductIdKeys: idKeys,
              sourceOptionType: sourceOptionPreview == null ? 'nullish' : Array.isArray(sourceOptionPreview) ? 'array' : typeof sourceOptionPreview,
              sourceOptionPreview,
            });
            this.showError(
              'No customisation options are configured for this product. Check product metafield storefront access and profile options.'
            );
          }

          this.applyExistingProperties(primaryItem.properties || {}, cart.items || []);
          this.targetItems = items;
          this.syncGroupTargetsFromCart(cart, primaryItem);
          this.renderProductSummary(primaryItem);
          // Must run after applyExistingProperties so a restored text line comes
          // back with its panel open and its preview drawn.
          this.updateCustomisationTypeUI();
          this.updateTypeVisibility();
          this.updateSelectionSummary();
          this.updateStepUI();
        } catch (error) {
          console.error(error);
          this.showError('Unable to load your cart item right now. Please try again.');
        } finally {
          this.setLoading(false);
        }
      }

      resolveTargetItem(cart) {
        if (!cart || !Array.isArray(cart.items)) return { item: null, line: null };

        let item = null;

        if (this.targetKey) {
          item = cart.items.find((cartItem) => cartItem.key === this.targetKey) || null;
        }

        if (!item && Number.isInteger(this.targetLine) && this.targetLine > 0) {
          item = cart.items[this.targetLine - 1] || null;
        }

        if (!item) return { item: null, line: null };

        const line = cart.items.findIndex((cartItem) => cartItem.key === item.key) + 1;
        return { item, line: line > 0 ? line : null };
      }

      resolveTargetItems(cart) {
        if (!cart || !Array.isArray(cart.items)) {
          return { items: [], primaryItem: null, primaryLine: null };
        }

        const resolved = [];
        const resolvedKeySet = new Set();

        if (Array.isArray(this.targetKeys) && this.targetKeys.length) {
          this.targetKeys.forEach((targetKey) => {
            const item = cart.items.find((cartItem) => cartItem.key === targetKey) || null;
            if (!item || resolvedKeySet.has(item.key)) return;
            const line = cart.items.findIndex((cartItem) => cartItem.key === item.key) + 1;
            if (line <= 0) return;
            resolved.push(item);
            resolvedKeySet.add(item.key);
          });
        }

        if (!resolved.length) {
          const { item } = this.resolveTargetItem(cart);
          if (item && !resolvedKeySet.has(item.key)) {
            resolved.push(item);
            resolvedKeySet.add(item.key);
          }
        }

        const primaryItem = resolved[0] || null;
        const primaryLine = primaryItem ? cart.items.findIndex((cartItem) => cartItem.key === primaryItem.key) + 1 : null;

        return {
          items: resolved,
          primaryItem,
          primaryLine: primaryLine > 0 ? primaryLine : null,
        };
      }

      renderProductSummary(item) {
        if (this.titleElement) {
          this.titleElement.textContent = item.product_title || 'Selected product';
        }

        if (this.metaElement) {
          const hasListItems = Array.isArray(this.groupEligibleItems)
            ? this.groupEligibleItems.some((groupItem) => groupItem.key !== this.parentItem?.key)
            : false;
          this.metaElement.replaceChildren();
          this.metaElement.hidden = !hasListItems;
          if (hasListItems) {
            if (!this.groupTargetToggleButton) {
              this.groupTargetToggleButton = document.createElement('button');
              this.groupTargetToggleButton.type = 'button';
              this.groupTargetToggleButton.className = 'logo-customiser__group-toggle logo-customiser__group-toggle--product';
              this.groupTargetToggleButton.addEventListener('click', this.handleGroupToggleClickBound);
            }
            this.metaElement.appendChild(this.groupTargetToggleButton);
          }
        }

        if (this.imageElement) {
          if (item.image) {
            this.imageElement.src = item.image;
            this.imageElement.alt = item.product_title || 'Product';
            this.imageElement.hidden = false;
            this.productPreviewImageUrl = item.image;
          } else {
            this.imageElement.hidden = true;
            this.productPreviewImageUrl = '';
          }
        }

        this.renderGroupTargetStack();
        this.updateAsideHeading();
        this.updateGroupTargetControls();
      }

      getTargetQuantityTotal() {
        if (Array.isArray(this.targetItems) && this.targetItems.length) {
          return this.targetItems.reduce((sum, item) => sum + (Number.parseInt(item?.quantity, 10) || 0), 0);
        }
        return Number.parseInt(this.parentItem?.quantity, 10) || 0;
      }

      isExistingCustomisationPayload(properties) {
        if (!properties || typeof properties !== 'object') return false;
        const existingKeys = [
          '_logo_added',
          'Logo Added',
          '_logo_positions',
          'Logo Positions',
          '_logo_method',
          'Logo Method',
          '_logo_size_tier',
          'Logo Size',
          '_logo_type',
          'Logo Type',
          '_logo_artwork',
          '_logo_artwork_url',
          'Logo Artwork',
        ];
        return existingKeys.some((key) => {
          if (!Object.prototype.hasOwnProperty.call(properties, key)) return false;
          return String(properties[key] ?? '').trim() !== '';
        });
      }

      applyExistingProperties(properties, cartItems) {
        this.canJumpToSteps = this.isExistingCustomisationPayload(properties);

        if (!this.customisationGroup) {
          const existingGroup = String(properties._logo_customisation_group || properties['Logo Group'] || '')
            .trim()
            .toLowerCase();
          if (existingGroup) {
            this.customisationGroup = existingGroup.replace(/\s+/g, '-');
          }
        }

        // Restore text customisation. Without this, re-opening a text line came
        // back as a blank logo upload and silently lost the wording.
        const savedType = String(properties._logo_type || properties['Logo Type'] || '').trim().toLowerCase();
        if (savedType === 'text') {
          const typeInput = this.querySelector('input[name="logo_customisation_type"][value="text"]');
          if (typeInput) typeInput.checked = true;

          (this.textLineInputs || []).forEach((input, index) => {
            const key = `_logo_text_line_${index + 1}`;
            input.value = String(properties[key] || '').trim();
          });

          const savedFont = String(properties._logo_text_font || '').trim();
          if (savedFont && this.textFontSelect) {
            const match = Array.from(this.textFontSelect.options).find((option) => option.value === savedFont);
            if (match) this.textFontSelect.value = savedFont;
          }

          // Lines saved before colours were per-line carry one value for the
          // whole block, so it seeds every line.
          const legacyColour = String(properties._logo_text_colour || '').trim();
          (this.textColourSelects || []).forEach((select, index) => {
            const savedColour =
              String(properties[`_logo_text_colour_${index + 1}`] || '').trim() || legacyColour;
            if (!savedColour) return;
            const match = Array.from(select.options).find((option) => option.value === savedColour);
            if (match) select.value = savedColour;
          });
        } else if (savedType) {
          const typeInput = this.querySelector('input[name="logo_customisation_type"][value="logo"]');
          if (typeInput) typeInput.checked = true;
        }

        const positionsValue = String(properties._logo_positions || properties['Logo Positions'] || '');
        if (positionsValue) {
          const positions = positionsValue
            .split(/[,|]/)
            .map((value) => value.trim())
            .filter(Boolean);
          this.querySelectorAll('input[name="logo_positions"]').forEach((input) => {
            input.checked = positions.includes(input.value);
          });
        }

        const methodValue = String(properties._logo_method || properties['Logo Method'] || '').toLowerCase();
        if (methodValue) {
          const methodInput = this.querySelector(`input[name="logo_method"][value="${methodValue}"]`);
          if (methodInput) methodInput.checked = true;
          this.preferredMethodKey = this.normalizeChoiceKey(methodValue);
        }

        const sizeTierValue = String(properties._logo_size_tier || properties['Logo Size'] || '').toLowerCase();
        this.legacySizeTier = this.normalizeChoiceKey(sizeTierValue);
        const storedAssignments = this.parseStoredAssignments(
          properties._logo_assignments_json || properties['Logo Assignments'] || ''
        );
        if (storedAssignments.length) {
          const nextAssignments = {};
          storedAssignments.forEach((entry) => {
            const positionLabel = this.resolvePositionLabel(entry?.positionLabel || entry?.position_key || entry?.positionKey || '');
            if (!positionLabel) return;
            const parsedLogoSlot = Number.parseInt(
              entry?.logoSlot || entry?.logo_slot || entry?.logoIndex || entry?.logo_index || '',
              10
            );
            nextAssignments[positionLabel] = {
              positionLabel,
              logoId: String(entry?.logoId || entry?.logo_id || '').trim(),
              logoSlot: Number.isFinite(parsedLogoSlot) && parsedLogoSlot > 0 ? parsedLogoSlot : 0,
              methodKey: this.normalizeChoiceKey(entry?.methodKey || entry?.method_key || methodValue || ''),
              sizeKey: this.normalizeChoiceKey(entry?.sizeKey || entry?.size_key || ''),
            };
          });
          if (Object.keys(nextAssignments).length) {
            this.positionAssignments = nextAssignments;
          }
        }

        const notes = this.querySelector('[name="logo_notes"]');
        const setupRequired = this.querySelector('[name="logo_setup_required"]');
        const logoArtworkUrls = String(properties._logo_artwork_urls || '').trim();
        const logoArtworkFilenames = String(
          properties._logo_artwork_filenames || properties._logo_artwork_filename || properties['Logo Artwork Filename'] || ''
        ).trim();
        // Carried forward so re-saving a line keeps the same logo identity and
        // does not look like a second logo to the fee grouping.
        this.existingSetupHashes = String(properties._logo_setup_hashes || '')
          .split('|')
          .map((entry) => entry.trim())
          .filter(Boolean);
        const logoArtworkNameList = logoArtworkFilenames
          ? logoArtworkFilenames
              .split('|')
              .map((value) => String(value || '').trim())
              .filter(Boolean)
          : [];
        const artworkUrlCandidates = [];
        const artworkUrlSeen = new Set();
        const pushArtworkUrlCandidate = (candidate) => {
          const normalized = this.normalizeArtworkUrl(candidate);
          if (!normalized) return;
          const dedupeKey = normalized.toLowerCase();
          if (artworkUrlSeen.has(dedupeKey)) return;
          artworkUrlSeen.add(dedupeKey);
          artworkUrlCandidates.push(normalized);
        };
        if (logoArtworkUrls) {
          logoArtworkUrls
            .split('|')
            .map((value) => String(value || '').trim())
            .filter(Boolean)
            .forEach((value) => pushArtworkUrlCandidate(value));
        }
        [
          properties._logo_artwork_url,
          properties._logo_artwork,
          properties._logo_artwork_2,
          properties._logo_artwork_3,
          properties['Logo Artwork'],
        ].forEach((value) => pushArtworkUrlCandidate(value));
        const logoArtworkEntries = artworkUrlCandidates.map((url, index) => ({
          url,
          name: logoArtworkNameList[index] || this.getArtworkDisplayName(url, ''),
        }));
        const logoArtworkUrl = logoArtworkEntries[0]?.url || '';
        const logoArtworkName = logoArtworkEntries[0]?.name || '';
        const logoArtworkSource = String(
          properties._logo_artwork_source || properties['Logo Artwork Source'] || ''
        )
          .trim()
          .toLowerCase();

        if (notes) notes.value = properties._logo_notes || properties['Logo Notes'] || '';
        if (setupRequired) {
          const setupValue = String(properties._logo_setup_required || properties['Logo Setup Required'] || '').toLowerCase();
          let shouldCheckSetup = setupValue === 'yes' || setupValue === 'true' || setupValue === '1';

          if (!shouldCheckSetup && (logoArtworkSource === 'upload' || logoArtworkSource === 'url')) {
            shouldCheckSetup = true;
          }
          if (logoArtworkSource === 'customer_metafield') {
            shouldCheckSetup = false;
          }

          if (!shouldCheckSetup) {
            const groupSetupFeeCents = this.normaliseMetafieldPriceCents(properties._logo_setup_group_fee_cents || 0);
            shouldCheckSetup = groupSetupFeeCents > 0;
          }

          if (!shouldCheckSetup) {
            const token = String(properties._logo_customiser_token || '').trim();
            if (token && Array.isArray(cartItems)) {
              shouldCheckSetup = cartItems.some((item) => {
                const itemProperties = item?.properties || {};
                if (itemProperties._logo_charge_type != null || itemProperties._logo_parent_key != null) return false;
                const itemToken = String(itemProperties._logo_customiser_token || '').trim();
                if (!itemToken || itemToken !== token) return false;
                const itemSetupRequired = String(
                  itemProperties._logo_setup_required || itemProperties['Logo Setup Required'] || ''
                ).toLowerCase();
                if (itemSetupRequired === 'yes' || itemSetupRequired === 'true' || itemSetupRequired === '1') return true;
                const itemGroupSetupFeeCents = this.normaliseMetafieldPriceCents(itemProperties._logo_setup_group_fee_cents || 0);
                const itemSetupFeeCents = this.normaliseMetafieldPriceCents(itemProperties._logo_setup_fee_cents || 0);
                return itemGroupSetupFeeCents > 0 || itemSetupFeeCents > 0;
              });
            }
          }

          setupRequired.checked = shouldCheckSetup;
        }
        if (this.logoFileInput) this.logoFileInput.value = '';
        this.existingLogoArtworks = logoArtworkEntries;
        this.existingLogoArtworkUrl = logoArtworkUrl;
        this.existingLogoArtworkName = logoArtworkName;
        this.refreshDynamicChoiceOptions({
          preferredMethod: methodValue,
          preferredSize: sizeTierValue,
        });
        this.enforceArtworkLimit({ showError: false });
        this.syncSavedArtworkSelectionUI();
        this.renderExistingArtwork();
        this.renderArtworkPreview();
        this.renderPositionAssignments();
        this.renderLogoAssignments();
      }

      normalizeArtworkUrl(value) {
        const normalized = String(value || '').trim();
        if (!normalized) return '';
        if (/^\d+$/.test(normalized)) {
          return '';
        }
        if (/^https?:\/\/shopify\/(?:MediaImage|GenericFile|Video|Model3d)\//i.test(normalized)) {
          return '';
        }
        if (/^shopify\/(?:MediaImage|GenericFile|Video|Model3d)\//i.test(normalized)) {
          return '';
        }
        if (normalized.startsWith('//')) {
          return `${window.location.protocol}${normalized}`;
        }
        if (/^cdn\/shop\/files\//i.test(normalized)) {
          return `/${normalized}`;
        }
        if (/^files\//i.test(normalized)) {
          return `/cdn/shop/${normalized}`;
        }
        if (/^[^/]+\.(jpe?g|png|gif|webp|svg|avif|bmp|tiff?)(\?.*)?$/i.test(normalized)) {
          return `/cdn/shop/files/${normalized}`;
        }
        return normalized;
      }

      // Cart properties are read by two runtimes: the theme, where a
      // /cdn/shop/files/... path resolves fine, and the checkout extension,
      // where it does not resolve at all. normalizeArtworkUrl happily returns
      // root-relative paths for saved customer-metafield logos, so absolutise
      // before anything is written to the line.
      toAbsoluteArtworkUrl(value) {
        const normalized = this.normalizeArtworkUrl(value);
        if (!normalized) return '';
        if (/^https?:\/\//i.test(normalized)) return normalized;
        try {
          return new URL(normalized, window.location.origin).href;
        } catch (error) {
          return normalized;
        }
      }

      getArtworkDisplayName(urlValue, fallbackName) {
        const fallback = String(fallbackName || '').trim();
        if (fallback) return fallback;
        const normalized = this.normalizeArtworkUrl(urlValue);
        if (!normalized) return 'Selected artwork';
        const clean = normalized.split('?')[0].split('#')[0];
        const base = clean.split('/').pop() || '';
        if (!base) return 'Selected artwork';
        try {
          return decodeURIComponent(base);
        } catch (error) {
          return base;
        }
      }

      syncSavedArtworkSelectionUI() {
        if (!this.savedArtworkElements.length) return;
        const activeArtworkSet = new Set(
          (Array.isArray(this.existingLogoArtworks) ? this.existingLogoArtworks : [])
            .map((artwork) => this.normalizeArtworkUrl(artwork?.url || ''))
            .filter(Boolean)
        );
        if (!activeArtworkSet.size) {
          const singleUrl = this.normalizeArtworkUrl(this.existingLogoArtworkUrl);
          if (singleUrl) activeArtworkSet.add(singleUrl);
        }
        this.savedArtworkElements.forEach((element) => {
          const candidate = this.normalizeArtworkUrl(element.dataset.logoSavedArtworkUrl || '');
          const isSelected = Boolean(candidate) && activeArtworkSet.has(candidate);
          element.classList.toggle('is-selected', isSelected);
          element.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }

      handleArtworkPreviewRemoveClick(event) {
        const trigger = event.target?.closest?.('[data-logo-artwork-remove]');
        if (!trigger || !this.contains(trigger)) return;

        event.preventDefault();
        this.clearError();

        const index = Number.parseInt(trigger.dataset.logoArtworkIndex || '', 10);
        const kind = String(trigger.dataset.logoArtworkKind || '').trim().toLowerCase();
        if (!Number.isFinite(index) || index < 0) return;

        if (kind === 'file') {
          const files = this.getSelectedLogoFiles();
          if (!files.length) return;
          files.splice(index, 1);
          this.setLogoFiles(files);
          if (!files.length) this.cleanupEmbroideryObjectUrl();
        } else {
          const existing = Array.isArray(this.existingLogoArtworks) ? [...this.existingLogoArtworks] : [];
          if (!existing.length || index >= existing.length) return;
          existing.splice(index, 1);
          this.setExistingLogoArtworks(existing, { showError: false });
          this.syncSavedArtworkSelectionUI();
        }

        this.renderExistingArtwork();
        this.updateTypeVisibility();
        this.updateSelectionSummary();
      }

      handleAssignmentChoiceClick(event) {
        const logoDropdownTrigger = event.target?.closest?.('[data-logo-image-select-trigger]');
        if (logoDropdownTrigger && this.contains(logoDropdownTrigger)) {
          event.preventDefault();
          this.toggleLogoImageDropdown(logoDropdownTrigger);
          return;
        }

        const logoDropdownOption = event.target?.closest?.('[data-logo-image-select-option]');
        if (logoDropdownOption && this.contains(logoDropdownOption)) {
          event.preventDefault();
          this.handleAssignmentFieldChange(logoDropdownOption);
          this.closeAllLogoImageDropdowns();
          return;
        }

        const previewPositionTrigger = event.target?.closest?.('[data-logo-assignment-preview-position]');
        if (previewPositionTrigger && this.contains(previewPositionTrigger)) {
          event.preventDefault();
          const nextPosition = this.resolvePositionLabel(
            previewPositionTrigger.dataset.logoAssignmentPreviewPosition || ''
          );
          if (nextPosition && nextPosition !== this.assignmentPreviewPositionLabel) {
            this.assignmentPreviewPositionLabel = nextPosition;
            this.renderPositionAssignments();
            this.renderLogoAssignments();
          }
          return;
        }

        const assignmentPositionTrigger = event.target?.closest?.('[data-logo-assignment-position-trigger]');
        if (assignmentPositionTrigger && this.contains(assignmentPositionTrigger)) {
          event.preventDefault();
          const nextPosition = this.resolvePositionLabel(
            assignmentPositionTrigger.dataset.logoAssignmentPositionTrigger || ''
          );
          if (nextPosition && nextPosition !== this.assignmentPreviewPositionLabel) {
            this.assignmentPreviewPositionLabel = nextPosition;
            this.renderPositionAssignments();
            this.renderLogoAssignments();
          }
          return;
        }

        if (!event.target?.closest?.('[data-logo-image-select]')) {
          this.closeAllLogoImageDropdowns();
        }

        const closeTrigger = event.target?.closest?.('[data-logo-assignment-picker-close]');
        if (closeTrigger && this.contains(closeTrigger)) {
          event.preventDefault();
          this.closeAssignmentPicker();
          return;
        }

        const openTrigger = event.target?.closest?.('[data-logo-assignment-trigger]');
        if (openTrigger && this.contains(openTrigger)) {
          event.preventDefault();
          this.openAssignmentPicker(openTrigger);
          return;
        }

        const pickerBackdrop = event.target?.closest?.('[data-logo-assignment-picker]');
        if (
          pickerBackdrop &&
          this.contains(pickerBackdrop) &&
          !event.target.closest('[data-logo-assignment-picker-panel]')
        ) {
          event.preventDefault();
          this.closeAssignmentPicker();
          return;
        }

        const trigger = event.target?.closest?.('[data-logo-assignment-button]');
        if (!trigger || !this.contains(trigger)) return;
        event.preventDefault();
        this.handleAssignmentFieldChange(trigger);
        if (trigger.hasAttribute('data-logo-assignment-picker-option')) {
          this.closeAssignmentPicker();
        }
      }

      handleAssignmentTabsWheel(event) {
        const tabs = event.target?.closest?.('.logo-customiser__assignment-visual-tabs');
        if (!tabs || !this.contains(tabs)) return;
        if (tabs.scrollWidth <= tabs.clientWidth + 1) return;
        const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
        if (!delta) return;
        tabs.scrollLeft += delta;
        event.preventDefault();
      }

      handleAssignmentPickerKeydown(event) {
        if (String(event?.key || '').toLowerCase() === 'escape') {
          this.closeAllLogoImageDropdowns();
        }
        if (!this.assignmentPickerElement || this.assignmentPickerElement.hidden) return;
        if (String(event?.key || '').toLowerCase() !== 'escape') return;
        event.preventDefault();
        this.closeAssignmentPicker();
      }

      closeAllLogoImageDropdowns(exceptElement = null) {
        const dropdowns = Array.from(this.querySelectorAll('[data-logo-image-select]'));
        dropdowns.forEach((dropdown) => {
          if (exceptElement && dropdown === exceptElement) return;
          dropdown.classList.remove('is-open');
          const trigger = dropdown.querySelector('[data-logo-image-select-trigger]');
          const menu = dropdown.querySelector('[data-logo-image-select-menu]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (menu) menu.hidden = true;
        });
      }

      toggleLogoImageDropdown(trigger) {
        const dropdown = trigger?.closest?.('[data-logo-image-select]');
        if (!dropdown) return;
        const menu = dropdown.querySelector('[data-logo-image-select-menu]');
        if (!menu) return;
        const isOpen = dropdown.classList.contains('is-open');
        this.closeAllLogoImageDropdowns(dropdown);
        if (isOpen) {
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
          return;
        }
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }

      ensureAssignmentPicker() {
        if (this.assignmentPickerElement && this.contains(this.assignmentPickerElement)) {
          return this.assignmentPickerElement;
        }

        const picker = document.createElement('div');
        picker.className = 'logo-customiser__assignment-picker';
        picker.setAttribute('data-logo-assignment-picker', '');
        picker.hidden = true;

        const panel = document.createElement('div');
        panel.className = 'logo-customiser__assignment-picker-panel';
        panel.setAttribute('data-logo-assignment-picker-panel', '');

        const header = document.createElement('div');
        header.className = 'logo-customiser__assignment-picker-header';

        const title = document.createElement('p');
        title.className = 'logo-customiser__assignment-picker-title';
        title.textContent = 'Choose option';

        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'logo-customiser__assignment-picker-close';
        close.setAttribute('data-logo-assignment-picker-close', '');
        close.setAttribute('aria-label', 'Close selection');
        close.textContent = '×';

        header.appendChild(title);
        header.appendChild(close);

        const options = document.createElement('div');
        options.className = 'logo-customiser__assignment-picker-options';

        panel.appendChild(header);
        panel.appendChild(options);
        picker.appendChild(panel);
        this.appendChild(picker);

        this.assignmentPickerElement = picker;
        this.assignmentPickerPanelElement = panel;
        this.assignmentPickerTitleElement = title;
        this.assignmentPickerOptionsElement = options;

        return picker;
      }

      getAssignmentByPosition(positionLabel) {
        const normalizedPosition = this.resolvePositionLabel(positionLabel);
        if (!normalizedPosition) return null;
        const assignments = this.getCurrentAssignments();
        return assignments.find((entry) => entry.positionLabel === normalizedPosition) || null;
      }

      getAssignmentPickerOptions(field, assignment) {
        if (!assignment) return [];
        if (field === 'logo') {
          const logoChoices = this.getSelectedLogoChoices();
          return logoChoices.map((choice) => ({
            field,
            value: choice.id,
            selected: choice.id === assignment.logoId,
            logoChoice: choice,
          }));
        }
        if (field === 'method') {
          const methods = this.getAvailableMethodsForPosition(assignment.positionLabel);
          return methods.map((methodKey) => ({
            field,
            value: methodKey,
            selected: this.normalizeChoiceKey(methodKey) === this.normalizeChoiceKey(assignment.methodKey),
            label: this.humanizeChoiceKey(methodKey),
            iconMarkup: this.getApplicationMethodIconMarkup(methodKey),
          }));
        }
        if (field === 'size') {
          const sizes = this.getAvailableSizesForSelection(
            [assignment.positionLabel],
            this.normalizeChoiceKey(assignment.methodKey)
          );
          return sizes.map((sizeKey) => ({
            field,
            value: sizeKey,
            selected: this.normalizeChoiceKey(sizeKey) === this.normalizeChoiceKey(assignment.sizeKey),
            label: this.humanizeChoiceKey(sizeKey),
            subLabel: this.getSizeDimensionLabel(assignment.methodKey, sizeKey),
          }));
        }
        return [];
      }

      buildAssignmentPickerOption(positionLabel, option) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'logo-customiser__assignment-picker-option';
        button.setAttribute('data-logo-assignment-button', option.field);
        button.setAttribute('data-logo-assignment-field', option.field);
        button.setAttribute('data-logo-assignment-position', positionLabel);
        button.setAttribute('data-logo-assignment-value', option.value);
        button.setAttribute('data-logo-assignment-picker-option', '');
        button.setAttribute('aria-pressed', option.selected ? 'true' : 'false');
        if (option.selected) button.classList.add('is-selected');

        if (option.field === 'logo') {
          button.classList.add('logo-customiser__assignment-picker-option--logo');
          const preview = this.getLogoChoicePreview(option.logoChoice);
          if (preview.previewable && preview.url) {
            const image = document.createElement('img');
            image.className = 'logo-customiser__assignment-picker-logo-image';
            image.src = preview.url;
            image.alt = option.logoChoice?.label || 'Logo';
            image.loading = 'lazy';
            button.appendChild(image);
          } else {
            const text = document.createElement('span');
            text.className = 'logo-customiser__assignment-picker-logo-text';
            text.textContent = option.logoChoice?.label || 'Logo';
            button.appendChild(text);
          }
          return button;
        }

        if (option.iconMarkup) {
          const icon = document.createElement('span');
          icon.className = 'logo-customiser__assignment-picker-option-icon';
          icon.innerHTML = option.iconMarkup;
          button.appendChild(icon);
        }

        const textWrap = document.createElement('span');
        textWrap.className = 'logo-customiser__assignment-picker-option-text';

        const main = document.createElement('span');
        main.className = 'logo-customiser__assignment-picker-option-main';
        main.textContent = option.label || '';
        textWrap.appendChild(main);

        if (option.subLabel) {
          const sub = document.createElement('span');
          sub.className = 'logo-customiser__assignment-picker-option-sub';
          sub.textContent = option.subLabel;
          textWrap.appendChild(sub);
        }

        button.appendChild(textWrap);
        return button;
      }

      openAssignmentPicker(trigger) {
        const field = String(trigger?.dataset?.logoAssignmentField || '').trim().toLowerCase();
        const positionLabel = this.resolvePositionLabel(trigger?.dataset?.logoAssignmentPosition || '');
        if (!field || !positionLabel) return;

        const assignment = this.getAssignmentByPosition(positionLabel);
        if (!assignment) return;

        const options = this.getAssignmentPickerOptions(field, assignment);
        if (!options.length) return;

        this.ensureAssignmentPicker();
        if (!this.assignmentPickerElement || !this.assignmentPickerOptionsElement) return;
        this.assignmentPickerOptionsElement.classList.remove('is-logo-field', 'is-method-field', 'is-size-field');
        if (field === 'logo') this.assignmentPickerOptionsElement.classList.add('is-logo-field');
        if (field === 'method') this.assignmentPickerOptionsElement.classList.add('is-method-field');
        if (field === 'size') this.assignmentPickerOptionsElement.classList.add('is-size-field');

        const fieldLabel =
          field === 'logo' ? 'Logo' : field === 'method' ? 'Method' : field === 'size' ? 'Size' : 'Option';
        if (this.assignmentPickerTitleElement) {
          this.assignmentPickerTitleElement.textContent = `${assignment.positionLabel}: choose ${fieldLabel.toLowerCase()}`;
        }

        this.assignmentPickerOptionsElement.innerHTML = '';
        options.forEach((option) => {
          this.assignmentPickerOptionsElement.appendChild(this.buildAssignmentPickerOption(positionLabel, option));
        });

        this.assignmentPickerState = {
          field,
          positionLabel,
        };
        this.assignmentPickerElement.hidden = false;
        this.assignmentPickerElement.classList.add('is-open');
      }

      closeAssignmentPicker(options = {}) {
        if (!this.assignmentPickerElement) return;
        this.assignmentPickerElement.hidden = true;
        this.assignmentPickerElement.classList.remove('is-open');
        if (this.assignmentPickerOptionsElement) {
          this.assignmentPickerOptionsElement.innerHTML = '';
          this.assignmentPickerOptionsElement.classList.remove('is-logo-field', 'is-method-field', 'is-size-field');
        }
        if (options?.clearState !== false) {
          this.assignmentPickerState = null;
        }
      }

      handleSavedArtworkClick(event) {
        const trigger = event.target?.closest?.('[data-logo-saved-artwork]');
        if (!trigger || !this.contains(trigger)) return;

        event.preventDefault();
        this.clearError();

        const artworkUrl = this.normalizeArtworkUrl(trigger.dataset.logoSavedArtworkUrl || '');
        if (!artworkUrl) return;
        const artworkName = String(trigger.dataset.logoSavedArtworkName || '').trim() || this.getArtworkDisplayName(artworkUrl, '');
        const existing = Array.isArray(this.existingLogoArtworks) ? [...this.existingLogoArtworks] : [];
        const existingIndex = existing.findIndex((artwork) => this.normalizeArtworkUrl(artwork?.url || '') === artworkUrl);
        if (existingIndex >= 0) {
          existing.splice(existingIndex, 1);
        } else {
          const limit = this.getLogoArtworkLimit();
          const uploadedCount = this.getSelectedLogoFiles().length;
          const availableSlots = Math.max(0, limit - uploadedCount);
          if (existing.length >= availableSlots) {
            this.showError(`You can select up to ${limit} logo${limit === 1 ? '' : 's'} for the chosen position(s).`);
            return;
          }
          existing.push({ url: artworkUrl, name: artworkName });
        }

        this.cleanupEmbroideryObjectUrl();
        this.setExistingLogoArtworks(existing, { showError: false });
        this.setLogoFiles([]);
        this.syncSavedArtworkSelectionUI();
        this.renderExistingArtwork();
        this.updateTypeVisibility();
        this.updateSelectionSummary();
      }

      renderExistingArtwork() {
        if (!this.logoArtworkExistingElement) return;
        const artworks = this.getSelectedLogoArtworks();
        const artworkCount = artworks.length;
        if (!artworkCount) {
          this.logoArtworkExistingElement.hidden = true;
          this.logoArtworkExistingElement.textContent = '';
          return;
        }

        const savedCount = artworks.filter((artwork) => artwork.kind === 'url' && artwork.fromCustomerMetafield).length;
        if (savedCount && savedCount === artworkCount) {
          this.logoArtworkExistingElement.textContent = `${artworkCount} saved logo${artworkCount === 1 ? '' : 's'} selected`;
        } else {
          this.logoArtworkExistingElement.textContent = `${artworkCount} file${artworkCount === 1 ? '' : 's'} uploaded`;
        }
        this.logoArtworkExistingElement.hidden = false;
      }

      isCustomerMetafieldArtworkUrl(urlValue) {
        const normalized = this.normalizeArtworkUrl(urlValue);
        if (!normalized) return false;
        if (!Array.isArray(this.savedArtworkElements) || !this.savedArtworkElements.length) return false;
        return this.savedArtworkElements.some((element) => {
          const candidate = this.normalizeArtworkUrl(element?.dataset?.logoSavedArtworkUrl || '');
          return Boolean(candidate) && candidate === normalized;
        });
      }

      isSelectedArtworkFromCustomerMetafield() {
        const artworks = this.getSelectedLogoArtworks();
        if (!artworks.length) return false;
        return artworks.every((artwork) => artwork.fromCustomerMetafield);
      }

      applySetupFeeRule() {
        if (!this.setupRequiredInput) return;

        const assignments = this.getCurrentAssignments();
        const hasSetupConfig = assignments.some(
          (assignment) => this.normaliseMetafieldPriceCents(assignment?.option?.setupFeeCents || 0) > 0
        );

        if (!hasSetupConfig) {
          this.setupRequiredInput.disabled = false;
          this.setupRequiredInput.checked = false;
          this.setupRequiredWrap?.classList.remove('is-auto');
          return;
        }

        const logoChoices = this.getSelectedLogoChoices();
        if (!logoChoices.length) {
          this.setupRequiredInput.disabled = false;
          this.setupRequiredInput.checked = true;
          this.setupRequiredWrap?.classList.remove('is-auto');
          return;
        }

        const setupUnits = this.getSetupUnitsForAssignments(assignments);
        if (setupUnits <= 0) {
          this.setupRequiredInput.disabled = true;
          this.setupRequiredInput.checked = false;
          this.setupRequiredWrap?.classList.remove('is-auto');
          return;
        }

        this.setupRequiredInput.checked = true;
        this.setupRequiredInput.disabled = true;
        this.setupRequiredWrap?.classList.add('is-auto');
      }

      cleanupEmbroideryObjectUrl() {
        if (this.embroideryObjectUrl) {
          URL.revokeObjectURL(this.embroideryObjectUrl);
          this.embroideryObjectUrl = '';
        }
        this.embroideryFileSignature = '';
      }

      cleanupArtworkPreviewObjectUrl() {
        if (this.artworkPreviewObjectUrl) {
          URL.revokeObjectURL(this.artworkPreviewObjectUrl);
          this.artworkPreviewObjectUrl = '';
        }
        if (Array.isArray(this.artworkPreviewObjectUrls) && this.artworkPreviewObjectUrls.length) {
          this.artworkPreviewObjectUrls.forEach((url) => {
            try {
              URL.revokeObjectURL(url);
            } catch (error) {
              // ignore
            }
          });
          this.artworkPreviewObjectUrls = [];
        }
        this.artworkPreviewFileSignature = '';
      }

      cleanupAssignmentPreviewObjectUrls() {
        if (!Array.isArray(this.assignmentPreviewObjectUrls) || !this.assignmentPreviewObjectUrls.length) return;
        this.assignmentPreviewObjectUrls.forEach((url) => {
          try {
            URL.revokeObjectURL(url);
          } catch (error) {
            // ignore
          }
        });
        this.assignmentPreviewObjectUrls = [];
      }

      cleanupPositionVisualObjectUrls() {
        if (!Array.isArray(this.positionVisualObjectUrls) || !this.positionVisualObjectUrls.length) return;
        this.positionVisualObjectUrls.forEach((url) => {
          try {
            URL.revokeObjectURL(url);
          } catch (error) {
            // ignore
          }
        });
        this.positionVisualObjectUrls = [];
      }

      /**
       * Revokes every object URL the previews hold. Named for the old Fabric.js
       * embroidery preview that has since been removed, but the three calls
       * below back the live position and assignment previews, so this still
       * runs on disconnect.
       */
      cleanupEmbroideryPreview() {
        this.cleanupEmbroideryObjectUrl();
        this.cleanupArtworkPreviewObjectUrl();
        this.cleanupAssignmentPreviewObjectUrls();
        this.cleanupPositionVisualObjectUrls();
      }

      /**
       * A content hash so the same artwork is recognised as one logo however
       * many times it is uploaded.
       *
       * Digitisation is charged per logo, but each upload gets its own CDN url
       * and each customiser session its own token, so configuring two variants
       * separately with the same file used to bill the setup fee twice.
       * Hashing the bytes gives an identity that survives both.
       */
      async computeArtworkHash(file) {
        const signature = this.getFileSignature(file);
        if (!signature) return '';
        if (this.artworkHashBySignature?.has(signature)) {
          return this.artworkHashBySignature.get(signature);
        }
        if (!window.crypto?.subtle || typeof file.arrayBuffer !== 'function') return '';

        try {
          const buffer = await file.arrayBuffer();
          const digest = await window.crypto.subtle.digest('SHA-256', buffer);
          const hash = Array.from(new Uint8Array(digest))
            .map((byte) => byte.toString(16).padStart(2, '0'))
            .join('')
            .slice(0, 32);
          this.artworkHashBySignature = this.artworkHashBySignature || new Map();
          this.artworkHashBySignature.set(signature, hash);
          return hash;
        } catch (error) {
          console.error(error);
          return '';
        }
      }

      /** Warms the hash cache so buildProperties can stay synchronous. */
      cacheArtworkHashes() {
        this.artworkHashBySignature = this.artworkHashBySignature || new Map();
        const files = this.getSelectedLogoFiles();
        return Promise.all(files.map((file) => this.computeArtworkHash(file))).catch(() => []);
      }

      /**
       * Stable per-logo identity used to group the setup fee across lines.
       * Falls back through file signature and url so a missing hash never
       * collapses two different logos into one.
       */
      resolveArtworkSetupIdentity(artwork, index) {
        if (!artwork) return '';

        // `_logo_setup_hashes` is a pipe-joined list, and getFileSignature
        // itself contains pipes, so an unescaped identity would split into
        // three and be counted as three separate logos.
        const safe = (value) => String(value || '').replace(/\|/g, '~');

        if (artwork.kind === 'file' && artwork.file) {
          const signature = this.getFileSignature(artwork.file);
          const hash = this.artworkHashBySignature?.get(signature);
          return hash ? `sha:${safe(hash)}` : `sig:${safe(signature)}`;
        }
        const preservedIndex = Number.isFinite(artwork?.sourceIndex) ? artwork.sourceIndex : index;
        const preserved = (this.existingSetupHashes || [])[preservedIndex];
        if (preserved) return safe(preserved);
        const url = this.normalizeArtworkUrl(artwork.url);
        return url ? `url:${safe(url.trim().toLowerCase())}` : '';
      }

      /**
       * Custom dropdown built over a hidden native select.
       *
       * Browsers render a native select's popup with the OS, and most ignore
       * font-family on <option> — so a font list could not show each face in
       * itself. This keeps the select as the value store (so form semantics and
       * getTextFont/getTextColour are untouched) and draws the list ourselves.
       *
       * @param {HTMLSelectElement} select
       * @param {(option: HTMLOptionElement) => object} decorate
       */
      buildCustomPicker(select, decorate) {
        if (!select || select.dataset.pickerReady === 'true') return;
        select.dataset.pickerReady = 'true';
        select.hidden = true;

        const root = document.createElement('div');
        root.className = 'logo-picker';

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'logo-picker__trigger';
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');

        const list = document.createElement('div');
        list.className = 'logo-picker__list';
        list.setAttribute('role', 'listbox');
        list.hidden = true;

        const paintTrigger = () => {
          const option = select.selectedOptions?.[0];
          const meta = option ? decorate(option) : {};
          trigger.innerHTML = '';
          if (meta.swatch) {
            const dot = document.createElement('span');
            dot.className = 'logo-picker__dot';
            dot.style.background = meta.swatch;
            trigger.appendChild(dot);
          }
          const label = document.createElement('span');
          label.className = 'logo-picker__label';
          label.textContent = option ? option.textContent : '';
          if (meta.fontStack) label.style.fontFamily = meta.fontStack;
          trigger.appendChild(label);
        };

        const close = () => {
          list.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        };

        const open = () => {
          list.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          list.querySelector('[aria-selected="true"]')?.focus();
        };

        Array.from(select.options).forEach((option) => {
          const meta = decorate(option);
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'logo-picker__option';
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
          item.dataset.value = option.value;

          if (meta.swatch) {
            const dot = document.createElement('span');
            dot.className = 'logo-picker__dot';
            dot.style.background = meta.swatch;
            item.appendChild(dot);
          }
          const label = document.createElement('span');
          label.textContent = option.textContent;
          if (meta.fontStack) label.style.fontFamily = meta.fontStack;
          item.appendChild(label);

          item.addEventListener('click', () => {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            list.querySelectorAll('[role="option"]').forEach((el) => el.setAttribute('aria-selected', 'false'));
            item.setAttribute('aria-selected', 'true');
            paintTrigger();
            close();
            trigger.focus();
          });

          list.appendChild(item);
        });

        trigger.addEventListener('click', () => (list.hidden ? open() : close()));
        root.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !list.hidden) {
            event.preventDefault();
            close();
            trigger.focus();
          }
        });
        document.addEventListener('click', (event) => {
          if (!root.contains(event.target)) close();
        });

        root.appendChild(trigger);
        root.appendChild(list);
        select.parentElement.insertBefore(root, select.nextSibling);
        paintTrigger();
        select.pickerRepaint = paintTrigger;
      }

      /**
       * True when the browser really has one of the faces in the stack.
       *
       * Measures the text against a deliberately distinct fallback: if the
       * widths match, nothing in the stack resolved and the browser silently
       * substituted. Offering such a font would show the customer one thing and
       * embroider another.
       */
      isFontAvailable(stack) {
        if (!stack) return false;
        const canvas = (this.fontProbeCanvas = this.fontProbeCanvas || document.createElement('canvas'));
        const context = canvas.getContext('2d');
        if (!context) return true;

        const sample = 'MWamil0O—Wg';
        const measure = (family) => {
          context.font = `40px ${family}`;
          return context.measureText(sample).width;
        };

        const monospace = measure('monospace');
        const serif = measure('serif');
        return measure(`${stack}, monospace`) !== monospace || measure(`${stack}, serif`) !== serif;
      }

      /** Drops fonts this device cannot render, so the preview stays honest. */
      pruneUnavailableFonts() {
        if (!this.textFontSelect) return;
        const dropped = [];
        Array.from(this.textFontSelect.options).forEach((option) => {
          const stack = String(option.dataset.fontStack || '').trim();
          if (!stack || this.isFontAvailable(stack)) return;
          dropped.push(option.textContent.trim());
          option.remove();
        });
        if (dropped.length) {
          console.info('Logo customiser: fonts unavailable on this device, hidden from the picker:', dropped);
        }
        if (this.textFontSelect.options.length && !this.textFontSelect.value) {
          this.textFontSelect.selectedIndex = 0;
        }
      }

      initTextPickers() {
        this.pruneUnavailableFonts();
        this.buildCustomPicker(this.textFontSelect, (option) => ({
          fontStack: String(option.dataset.fontStack || '').trim(),
        }));
        (this.textColourSelects || []).forEach((select) => {
          this.buildCustomPicker(select, (option) => ({
            swatch: String(option.dataset.colourHex || '#111111').trim(),
          }));
        });
      }

      /** 'logo' or 'text'. Text is priced like a logo but carries no setup fee. */
      getCustomisationType() {
        const checked = this.querySelector('input[name="logo_customisation_type"]:checked');
        const value = String(checked?.value || '').trim();
        return COMPOSITIONS.has(value) ? value : 'logo';
      }

      isTextMode() {
        return this.getCustomisationType() === 'text';
      }

      /**
       * Named predicates for the two halves. They are simply the two sides of
       * isTextMode(), which reads better at the call sites that care about one
       * half rather than about "which mode is this".
       */
      hasText() {
        return this.isTextMode();
      }

      hasArtwork() {
        return !this.isTextMode();
      }

      getSizeFieldLabel() {
        return this.isTextMode() ? 'Text size' : 'Logo size';
      }

      /**
       * Lines as typed, preserving an intentionally blank line between two
       * filled ones. Only trailing blanks are dropped — filtering every empty
       * silently promoted line 2 to line 1.
       */
      getTextLines() {
        const raw = (this.textLineInputs || []).map((input) => String(input.value || '').trim());
        while (raw.length && !raw[raw.length - 1]) raw.pop();
        return raw;
      }

      /** Only the lines with content, for validation and summaries. */
      getFilledTextLines() {
        return this.getTextLines().filter(Boolean);
      }

      getTextFont() {
        const select = this.textFontSelect;
        if (!select) return { value: '', label: '', stack: '' };
        const option = select.selectedOptions?.[0];
        return {
          value: String(select.value || '').trim(),
          label: String(option?.textContent || '').trim(),
          stack: String(option?.dataset?.fontStack || '').trim(),
        };
      }

      getTextColour(index = 0) {
        const selects = Array.isArray(this.textColourSelects) ? this.textColourSelects : [];
        const select = selects[index] || this.textColourSelect;
        const option = select?.selectedOptions?.[0];
        if (!option) return { value: '', label: '', hex: '#111111' };
        return {
          value: String(select.value || '').trim(),
          label: String(option.dataset.colourLabel || '').trim(),
          hex: String(option.dataset.colourHex || '#111111').trim(),
        };
      }

      /** One colour per typed line, aligned with getTextLines(). */
      getTextColours() {
        return this.getTextLines().map((_, index) => this.getTextColour(index));
      }

      /** Swaps the upload fields for the text fields and repaints the preview. */
      /**
       * Hides whichever half of step 2 is not in play.
       *
       * Re-applied at the end of updateTypeVisibility because renderArtworkPreview
       * un-hides the artwork elements on its own, which brought the upload field
       * back while text mode was active.
       */
      applyTextModeVisibility() {
        // Two independent halves now: a combined composition shows both panels.
        const showText = this.hasText();
        const showArtwork = this.hasArtwork();
        const isText = !showArtwork;
        if (this.textPanelElement) this.textPanelElement.hidden = !showText;
        if (this.uploadFieldElement) this.uploadFieldElement.hidden = !showArtwork;

        // Static upload chrome follows the mode in both directions. Hiding only
        // one way left the saved-logos prompt stuck hidden after a trip through
        // text mode, showing an empty box under the file input.
        this.querySelectorAll(
          '.logo-customiser__format-row, [data-logo-upload-limit-hint], .logo-customiser__saved-logos, .logo-customiser__saved-logos-signin, [data-logo-artwork-only]'
        ).forEach((el) => {
          el.hidden = !showArtwork;
        });

        this.querySelectorAll('[data-logo-text-only]').forEach((el) => {
          el.hidden = !showText;
        });

        // Every line is available in text mode; the panel as a whole is what
        // hides in logo mode, so nothing here needs clearing.
        (this.textLineInputs || []).forEach((input) => {
          const field = input.closest('[data-logo-text-field]');
          if (field) field.hidden = false;
        });

        // These two own their own visibility (they hide when there is nothing to
        // show), so only force them off in text mode and otherwise leave them be.
        if (isText) {
          this.querySelectorAll('[data-logo-artwork-existing], [data-logo-artwork-preview]').forEach((el) => {
            el.hidden = true;
          });
        }
      }

      updateCustomisationTypeUI() {
        this.applyTextModeVisibility();

        this.querySelectorAll('.logo-customiser__type').forEach((label) => {
          const input = label.querySelector('input');
          label.classList.toggle('is-selected', Boolean(input?.checked));
        });

        this.renderTextPreview();
      }

      /** Live preview of the typed lines in the chosen font and colour. */
      /**
       * Renders each option in its own face so the list is a specimen sheet,
       * and mirrors the choice onto the closed select. Option-level font-family
       * is honoured on desktop browsers; where it is ignored the select itself
       * still previews the current pick.
       */
      styleFontAndColourControls() {
        const font = this.getTextFont();
        const colour = this.getTextColour();

        if (this.textFontSelect) {
          Array.from(this.textFontSelect.options).forEach((option) => {
            const stack = String(option.dataset.fontStack || '').trim();
            if (stack) option.style.fontFamily = stack;
          });
          this.textFontSelect.style.fontFamily = font.stack || 'inherit';
        }

        (this.textColourDots || []).forEach((dot, index) => {
          dot.style.background = this.getTextColour(index).hex || '#111111';
        });

        // Restoring a saved line sets select.value directly, so the custom
        // triggers need telling.
        this.textFontSelect?.pickerRepaint?.();
        (this.textColourSelects || []).forEach((select) => select?.pickerRepaint?.());
      }

      /**
       * Single entry point for everything that draws the wording: the preview
       * panel, the step 1 cards and the step 3 thumbnails.
       *
       * These were repainted from three separate places — typing, change events
       * and restore — and each new path kept missing one, which is where the
       * "colour changes on step 3 but not step 1" class of bug came from.
       */
      repaintTextPreviews() {
        this.renderTextPreview();
        this.renderPositionChoices(this.getSelectedPositions());
        this.renderPositionAssignments();
      }

      renderTextPreview() {
        this.styleFontAndColourControls();
        if (!this.textPreviewStage) return;
        const lines = this.getTextLines();
        const font = this.getTextFont();
        const colour = this.getTextColour();

        if (!lines.length) {
          this.textPreviewStage.innerHTML =
            '<span class="logo-customiser__text-preview-empty">Type a line to see it here</span>';
          return;
        }

        this.textPreviewStage.innerHTML = lines
          .map((line, index) => {
            const lineHex = this.getTextColour(index).hex || '#111111';
            const safeLine = line.replace(/[&<>"']/g, (c) => ({
              '&': '&amp;',
              '<': '&lt;',
              '>': '&gt;',
              '"': '&quot;',
              "'": '&#39;',
            })[c]);
            return `<span class="logo-customiser__text-preview-line" style="color:${lineHex.replace(/["'<>]/g, '')}">${safeLine}</span>`;
          })
          .join('');
        this.textPreviewStage.style.fontFamily = font.stack || 'inherit';
        this.textPreviewStage.style.color = colour.hex || '#111111';
      }

      getFileSignature(file) {
        if (!file) return '';
        const name = String(file.name || '').trim();
        const size = Number.parseInt(file.size, 10) || 0;
        const modified = Number.parseInt(file.lastModified, 10) || 0;
        return `${name}|${size}|${modified}`;
      }

      getLogoArtworkPreviewSource() {
        const file = this.getSelectedLogoFiles()[0] || null;
        if (file) {
          const signature = this.getFileSignature(file);
          if (!this.embroideryObjectUrl || this.embroideryFileSignature !== signature) {
            this.cleanupEmbroideryObjectUrl();
            this.embroideryObjectUrl = URL.createObjectURL(file);
            this.embroideryFileSignature = signature;
          }
          return {
            url: this.embroideryObjectUrl,
            name: file.name || this.getArtworkDisplayName(this.embroideryObjectUrl, ''),
          };
        }

        this.cleanupEmbroideryObjectUrl();
        const existingArtwork = (Array.isArray(this.existingLogoArtworks) ? this.existingLogoArtworks : []).find((artwork) =>
          this.normalizeArtworkUrl(artwork?.url || '')
        );
        const url = this.normalizeArtworkUrl(existingArtwork?.url || this.existingLogoArtworkUrl);
        if (!url) return null;
        return {
          url,
          name: this.getArtworkDisplayName(url, existingArtwork?.name || this.existingLogoArtworkName),
        };
      }

      isImageArtworkFile(file) {
        if (!file) return false;
        const mimeType = String(file.type || '').toLowerCase();
        if (mimeType.startsWith('image/')) return true;
        return /\.(png|jpe?g|gif|webp|avif|bmp|svg)$/i.test(String(file.name || '').trim());
      }

      isImageArtworkUrl(url) {
        const normalized = this.normalizeArtworkUrl(url);
        if (!normalized) return false;
        if (/\.(png|jpe?g|gif|webp|avif|bmp|svg)(\?.*)?$/i.test(normalized)) return true;
        if (/cdn\.shopify\.com/i.test(normalized)) return true;
        return false;
      }

      getSelectedArtworkPreviewSource() {
        const file = this.getSelectedLogoFiles()[0] || null;
        if (file) {
          if (!this.isImageArtworkFile(file)) {
            this.cleanupArtworkPreviewObjectUrl();
            return {
              url: '',
              name: file.name || 'Selected artwork',
              previewable: false,
            };
          }
          const signature = this.getFileSignature(file);
          if (!this.artworkPreviewObjectUrl || this.artworkPreviewFileSignature !== signature) {
            this.cleanupArtworkPreviewObjectUrl();
            this.artworkPreviewObjectUrl = URL.createObjectURL(file);
            this.artworkPreviewFileSignature = signature;
          }
          return {
            url: this.artworkPreviewObjectUrl,
            name: file.name || 'Selected artwork',
            previewable: true,
          };
        }

        this.cleanupArtworkPreviewObjectUrl();
        const artworkUrl = this.normalizeArtworkUrl(this.existingLogoArtworkUrl);
        if (!artworkUrl) return null;
        return {
          url: artworkUrl,
          name: this.getArtworkDisplayName(artworkUrl, this.existingLogoArtworkName),
          previewable: this.isImageArtworkUrl(artworkUrl),
        };
      }

      renderArtworkPreview() {
        if (!this.logoArtworkPreviewElement || !this.logoArtworkPreviewFallbackElement) {
          return;
        }

        const artworks = this.getSelectedLogoArtworks().slice(0, this.getLogoArtworkLimit());
        if (!artworks.length) {
          this.logoArtworkPreviewElement.hidden = true;
          if (this.logoArtworkPreviewListElement) {
            this.logoArtworkPreviewListElement.innerHTML = '';
            this.logoArtworkPreviewListElement.hidden = true;
          }
          if (this.logoArtworkPreviewImageElement) {
            this.logoArtworkPreviewImageElement.hidden = true;
            this.logoArtworkPreviewImageElement.removeAttribute('src');
          }
          this.logoArtworkPreviewFallbackElement.hidden = true;
          this.cleanupArtworkPreviewObjectUrl();
          return;
        }

        this.logoArtworkPreviewElement.hidden = false;
        this.cleanupArtworkPreviewObjectUrl();

        const hasList = Boolean(this.logoArtworkPreviewListElement);
        if (hasList) {
          this.logoArtworkPreviewListElement.innerHTML = '';
          this.logoArtworkPreviewListElement.hidden = false;
        }
        if (this.logoArtworkPreviewImageElement) {
          this.logoArtworkPreviewImageElement.hidden = true;
          this.logoArtworkPreviewImageElement.removeAttribute('src');
        }

        let hasRenderablePreview = false;
        const appendTile = (url, label, previewable, artworkKind, artworkIndex) => {
          if (!this.logoArtworkPreviewListElement) return;
          const tile = document.createElement('div');
          tile.className = 'logo-customiser__artwork-preview-tile';
          if (previewable && url) {
            const image = document.createElement('img');
            image.className = 'logo-customiser__artwork-preview-image';
            image.src = url;
            image.alt = label || 'Artwork preview';
            image.loading = 'lazy';
            tile.appendChild(image);
          } else {
            const fallback = document.createElement('span');
            fallback.className = 'logo-customiser__artwork-preview-tile-fallback';
            fallback.textContent = label || 'File';
            tile.appendChild(fallback);
          }
          const removeButton = document.createElement('button');
          removeButton.type = 'button';
          removeButton.className = 'logo-customiser__artwork-preview-remove';
          removeButton.setAttribute('data-logo-artwork-remove', 'true');
          removeButton.setAttribute('data-logo-artwork-kind', artworkKind || 'url');
          removeButton.setAttribute('data-logo-artwork-index', String(artworkIndex));
          removeButton.setAttribute('aria-label', `Remove ${label || `logo ${artworkIndex + 1}`}`);
          removeButton.textContent = '×';
          tile.appendChild(removeButton);
          this.logoArtworkPreviewListElement.appendChild(tile);
        };

        artworks.forEach((artwork, index) => {
          const removalIndex = Number.isFinite(Number(artwork?.sourceIndex))
            ? Number.parseInt(artwork.sourceIndex, 10)
            : index;
          if (artwork.kind === 'file') {
            const file = artwork.file;
            const previewable = this.isImageArtworkFile(file);
            const label = String(file?.name || '').trim() || `File ${index + 1}`;
            if (previewable) {
              const objectUrl = URL.createObjectURL(file);
              this.artworkPreviewObjectUrls.push(objectUrl);
              hasRenderablePreview = true;
              appendTile(objectUrl, label, true, 'file', removalIndex);
            } else {
              const extension = label.split('.').pop() || 'FILE';
              appendTile('', extension.toUpperCase(), false, 'file', removalIndex);
            }
            return;
          }

          const artworkUrl = this.normalizeArtworkUrl(artwork.url);
          const previewable = this.isImageArtworkUrl(artworkUrl);
          if (previewable) {
            hasRenderablePreview = true;
            appendTile(artworkUrl, artwork.name || `Logo ${index + 1}`, true, 'url', removalIndex);
          } else {
            appendTile('', 'FILE', false, 'url', removalIndex);
          }
        });

        if (!hasList && hasRenderablePreview) {
          const firstPreviewUrl = this.artworkPreviewObjectUrls[0] || this.normalizeArtworkUrl(artworks[0]?.url || '');
          if (this.logoArtworkPreviewImageElement && firstPreviewUrl) {
            this.logoArtworkPreviewImageElement.src = firstPreviewUrl;
            this.logoArtworkPreviewImageElement.alt = artworks[0]?.name || 'Selected artwork preview';
            this.logoArtworkPreviewImageElement.hidden = false;
          }
        }

        if (hasRenderablePreview) {
          this.logoArtworkPreviewFallbackElement.hidden = true;
        } else {
          this.logoArtworkPreviewFallbackElement.textContent = 'Preview unavailable for selected file type.';
          this.logoArtworkPreviewFallbackElement.hidden = false;
        }
      }

      getProductPreviewSource() {
        const productUrl = this.normalizeArtworkUrl(this.productPreviewImageUrl || this.imageElement?.src || '');
        if (!productUrl) return null;
        return { url: productUrl };
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      loadFabricImage(url, onSuccess, onError) {
        const fabricRef = window.fabric;
        if (!fabricRef?.Image?.fromURL || !url) {
          if (typeof onError === 'function') onError();
          return;
        }
        const normalizedUrl = this.normalizeArtworkUrl(url);
        const isRemoteUrl = /^https?:\/\//i.test(normalizedUrl);
        const tryLoad = (options, allowRetry) => {
          fabricRef.Image.fromURL(
            normalizedUrl,
            (image, isError) => {
              if (isError || !image || !image.width || !image.height) {
                if (allowRetry) {
                  tryLoad({}, false);
                  return;
                }
                if (typeof onError === 'function') onError();
                return;
              }
              if (typeof onSuccess === 'function') onSuccess(image);
            },
            options
          );
        };
        if (isRemoteUrl) {
          tryLoad({ crossOrigin: 'anonymous' }, true);
        } else {
          tryLoad({}, false);
        }
      }

      loadFabricImageAsync(url) {
        return new Promise((resolve, reject) => {
          this.loadFabricImage(url, resolve, reject);
        });
      }

      getMaxStep() {
        if (!this.stepElements.length) return 1;
        return this.stepElements.reduce((maxStep, element) => {
          const parsed = Number.parseInt(element.dataset.logoStep || '', 10);
          if (!Number.isFinite(parsed)) return maxStep;
          return Math.max(maxStep, parsed);
        }, 1);
      }

      handleStepBack(event) {
        event.preventDefault();
        this.clearError();
        this.currentStep = Math.max(1, this.currentStep - 1);
        this.updateStepUI();
      }

      handleStepNext(event) {
        event.preventDefault();
        if (!this.validateCurrentStep()) return;
        this.clearError();
        this.currentStep = Math.min(this.maxStep, this.currentStep + 1);
        this.updateStepUI();
      }

      handleStepperItemClick(event) {
        if (!this.canJumpToSteps || this.isSubmitting) return;
        const step = Number.parseInt(event?.currentTarget?.dataset?.stepperStep || '', 10);
        if (!Number.isFinite(step) || step < 1 || step > this.maxStep || step === this.currentStep) return;
        this.clearError();
        this.currentStep = step;
        this.updateStepUI();
      }

      handleStepperItemKeydown(event) {
        const key = String(event?.key || '').toLowerCase();
        if (key !== 'enter' && key !== ' ') return;
        event.preventDefault();
        this.handleStepperItemClick(event);
      }

      validateCurrentStep() {
        if (this.currentStep === 1 && !this.getSelectedPositions().length) {
          this.showError('Select at least one logo position.');
          return false;
        }

        // Step 2 collects the artwork. Text needs typed lines, not files, so
        // the artwork checks are skipped entirely in that mode.
        // Step 2 collects the artwork. Text needs typed lines, not files, so
        // the artwork checks are skipped entirely in that mode.
        if (this.currentStep === 2 && this.isTextMode()) {
          if (!this.getFilledTextLines().length) {
            this.showError('Enter at least one line of text.');
            return false;
          }
          return true;
        }

        if (this.currentStep === 2) {
          const selectedFiles = this.getSelectedLogoFiles();
          const artworkLimit = this.getLogoArtworkLimit();
          const selectedArtworks = this.getSelectedLogoArtworks();
          if (selectedFiles.length > artworkLimit) {
            this.showError(`You can upload up to ${artworkLimit} artwork file${artworkLimit === 1 ? '' : 's'} for the selected position(s).`);
            return false;
          }
          if (selectedArtworks.length > artworkLimit) {
            this.showError(`You can use up to ${artworkLimit} logos for the selected position(s).`);
            return false;
          }
          if (selectedFiles.some((file) => !this.isAllowedLogoArtworkFile(file))) {
            this.showError('Please upload PDF, JPG, JPEG, or PNG files only.');
            return false;
          }
          if (!selectedArtworks.length) {
            this.showError('Upload a logo file before continuing.');
            return false;
          }
        }

        // Step 3 settles method and size, and — once more than one logo is in
        // play — which logo goes on which position. The artwork is already in
        // hand by this point, which is why the logo picker lives here.
        if (this.currentStep === 3) {
          const assignments = this.getCurrentAssignments();
          if (!assignments.length || assignments.length !== this.getSelectedPositions().length) {
            this.showError('Choose a method and size for each selected position.');
            return false;
          }
          if (assignments.some((assignment) => !assignment.methodKey)) {
            this.showError('Choose an application method for each selected position.');
            return false;
          }
          if (assignments.some((assignment) => !assignment.sizeKey || !assignment.option)) {
            this.showError('Choose a valid size for each selected position.');
            return false;
          }
          if (this.hasArtwork() && assignments.some((assignment) => !assignment.logoId)) {
            this.showError('Choose which logo goes on each position.');
            return false;
          }
        }

        return true;
      }

      updateStepUI() {
        const isSubmitting = Boolean(this.isSubmitting);
        // The assignment picker lives on the method/size step, now step 3.
        if (this.currentStep !== 3) {
          this.closeAssignmentPicker({ clearState: false });
        }

        this.stepElements.forEach((element) => {
          const step = Number.parseInt(element.dataset.logoStep || '', 10);
          const shouldShow = step === this.currentStep;
          const wasHidden = element.hidden;
          element.hidden = !shouldShow;
          element.classList.toggle('hidden', !shouldShow);

          // Replay the enter animation only when a step actually appears, so
          // unrelated re-renders of the current step do not re-trigger it.
          if (shouldShow && wasHidden) {
            element.classList.remove('is-entering');
            // Force a reflow so removing and re-adding the class restarts it.
            void element.offsetWidth;
            element.classList.add('is-entering');
            // Drop the class once it has played. A filling animation on a
            // transform leaves the card as its own stacking context, which
            // trapped the font dropdown behind the sticky actions row.
            element.addEventListener(
              'animationend',
              () => element.classList.remove('is-entering'),
              { once: true }
            );
          }
        });

        if (this.stepBackButton) {
          this.stepBackButton.hidden = this.currentStep <= 1;
          this.stepBackButton.classList.toggle('hidden', this.currentStep <= 1);
          this.stepBackButton.toggleAttribute('disabled', isSubmitting || this.currentStep <= 1);
        }

        if (this.stepNextButton) {
          const isLastStep = this.currentStep >= this.maxStep;
          this.stepNextButton.hidden = isLastStep;
          this.stepNextButton.classList.toggle('hidden', isLastStep);
          this.stepNextButton.toggleAttribute('disabled', isSubmitting || isLastStep);
        }

        if (this.submitButton) {
          const isLastStep = this.currentStep >= this.maxStep;
          this.submitButton.hidden = !isLastStep;
          this.submitButton.classList.toggle('hidden', !isLastStep);
          this.submitButton.toggleAttribute('disabled', isSubmitting);
        }

        if (this.actionsRow) {
          this.actionsRow.classList.toggle('is-first-step', this.currentStep === 1);
        }

        this.updateStepperUI();
        this.updateAsideAlignment();
      }

      updateStepperUI() {
        if (!this.stepperItems.length) return;
        this.stepperItems.forEach((item) => {
          const step = Number.parseInt(item.dataset.stepperStep || '', 10);
          if (!Number.isFinite(step)) return;
          const canJump = this.canJumpToSteps && !this.isSubmitting;
          const isActive = step === this.currentStep;
          const isComplete = step < this.currentStep;
          item.classList.toggle('is-active', isActive);
          item.classList.toggle('is-complete', isComplete);
          item.classList.toggle('is-jumpable', canJump);
          item.tabIndex = canJump ? 0 : -1;
          item.setAttribute('aria-disabled', canJump ? 'false' : 'true');
          if (canJump) {
            item.setAttribute('role', 'button');
          } else {
            item.removeAttribute('role');
          }
          if (isActive) {
            item.setAttribute('aria-current', 'step');
          } else {
            item.removeAttribute('aria-current');
          }

          // Painted here rather than in CSS. Three stylesheets style this
          // component and something unreadable was winning the background,
          // leaving the completed step looking current and the current one
          // flat. Setting it on the element ends the argument.
          const STEP_STYLES = {
            active: { bg: '#1d349a', fg: '#ffffff', dotBg: '#ffffff', dotFg: '#1d349a' },
            complete: { bg: 'rgba(29, 52, 154, 0.1)', fg: '#1d349a', dotBg: '#1d349a', dotFg: '#ffffff' },
            upcoming: { bg: '#f4f5f7', fg: '#6b7280', dotBg: 'rgba(15, 23, 42, 0.12)', dotFg: '#0f172a' },
          };
          const tone = STEP_STYLES[isActive ? 'active' : isComplete ? 'complete' : 'upcoming'];
          item.style.setProperty('background', tone.bg, 'important');
          item.style.setProperty('color', tone.fg, 'important');
          item.style.setProperty('box-shadow', isActive ? '0 0.2rem 0.6rem rgba(29, 52, 154, 0.28)' : 'none', 'important');

          const text = item.querySelector('.logo-customiser__stepper-text');
          if (text) text.style.setProperty('color', tone.fg, 'important');

          const dot = item.querySelector('.logo-customiser__stepper-dot');
          if (dot) {
            dot.style.setProperty('background', tone.dotBg, 'important');
            dot.style.setProperty('color', tone.dotFg, 'important');
          }
        });
      }

      handleInputChange(event) {
        const name = String(event?.target?.name || '');
        if (name === 'logo_customisation_type') {
          this.updateCustomisationTypeUI();
          this.updateTypeVisibility();
          this.updateSelectionSummary();
          return;
        }
        if (name.startsWith('logo_text_')) {
          this.repaintTextPreviews();
          this.clearError();
          return;
        }
        if (event?.target && event.target === this.logoFileInput) {
          // Hash as soon as files are picked so buildProperties finds them
          // cached and can stay synchronous.
          this.cacheArtworkHashes().then(() => this.updateSelectionSummary());
        }
        if (event?.target?.dataset?.logoAssignmentField) {
          this.handleAssignmentFieldChange(event.target);
          return;
        }
        const targetName = String(event?.target?.name || '');
        const artworkLimit = this.getLogoArtworkLimit();
        if (targetName === 'logo_method') {
          this.preferredMethodKey = this.normalizeChoiceKey(event?.target?.value || this.getSelectedMethod());
        }
        if (event?.target === this.logoFileInput) {
          const existingCount = (Array.isArray(this.existingLogoArtworks) ? this.existingLogoArtworks : []).length;
          const availableSlots = Math.max(0, artworkLimit - existingCount);
          let selectedFiles = this.getSelectedLogoFiles();
          if (!availableSlots && selectedFiles.length) {
            this.setLogoFiles([]);
            this.showError(
              artworkLimit === 1
                ? 'This position allows only 1 logo. Remove the current logo before uploading another.'
                : `You already have ${artworkLimit} logos selected. Remove one before uploading another.`
            );
            this.renderArtworkPreview();
            return;
          }
          if (selectedFiles.length > availableSlots) {
            this.setLogoFiles(selectedFiles.slice(0, availableSlots));
            selectedFiles = this.getSelectedLogoFiles();
            this.showError(
              `You can upload ${availableSlots} more file${availableSlots === 1 ? '' : 's'} for the selected position(s).`
            );
            this.renderArtworkPreview();
          }
          if (selectedFiles.some((file) => !this.isAllowedLogoArtworkFile(file))) {
            this.setLogoFiles([]);
            this.showError('Please upload PDF, JPG, JPEG, or PNG files only.');
            this.renderArtworkPreview();
            return;
          }
          if (!selectedFiles.length) {
            this.cleanupEmbroideryObjectUrl();
          }
          this.renderExistingArtwork();
        }
        if (targetName === 'logo_positions' || targetName === 'logo_method') {
          this.refreshDynamicChoiceOptions({
            preferredMethod: this.preferredMethodKey || this.getSelectedMethod(),
          });
        }
        if (targetName === 'logo_positions') {
          const changedPosition = this.resolvePositionLabel(event?.target?.value || '');
          if (changedPosition) {
            if (event?.target?.checked) {
              this.assignmentPreviewPositionLabel = changedPosition;
            } else if (this.assignmentPreviewPositionLabel === changedPosition) {
              const remaining = this.getSelectedPositions();
              this.assignmentPreviewPositionLabel = remaining[0] || '';
            }
          }
          this.enforceArtworkLimit();
        }
        if (
          targetName === 'logo_method' ||
          targetName === 'logo_positions'
        ) {
          this.renderGroupTargetSelector();
        }
        this.updateTypeVisibility();
        this.updateSelectionSummary();
        this.updateStepUI();
      }

      updateTypeVisibility() {
        const positions = this.getSelectedPositions();
        this.updateArtworkLimitHint(positions);
        this.updateLogoFileInputAvailability(positions);
        const assignments = this.getCurrentAssignments();
        // Text carries no digitisation charge, so the whole setup panel is
        // irrelevant there. It was still showing — with the box ticked — which
        // read as if an £18 fee were being applied, while the summary
        // correctly excluded it.
        const shouldShowSetup =
          this.hasArtwork() &&
          assignments.some(
            (assignment) => this.normaliseMetafieldPriceCents(assignment?.option?.setupFeeCents || 0) > 0
          );
        if (this.setupPanelElement) {
          this.setupPanelElement.hidden = !shouldShowSetup;
          this.setupPanelElement.classList.toggle('hidden', !shouldShowSetup);
        }
        if (this.setupNoteElement) {
          this.setupNoteElement.hidden = !shouldShowSetup;
          this.setupNoteElement.classList.toggle('hidden', !shouldShowSetup);
        }
        if (this.setupHintElement) {
          this.setupHintElement.hidden = !shouldShowSetup;
          this.setupHintElement.classList.toggle('hidden', !shouldShowSetup);
        }
        if (this.setupRequiredWrap) {
          this.setupRequiredWrap.hidden = !shouldShowSetup;
          this.setupRequiredWrap.classList.toggle('hidden', !shouldShowSetup);
          if (!shouldShowSetup && this.setupRequiredInput) {
            this.setupRequiredInput.disabled = false;
            this.setupRequiredInput.checked = false;
            this.setupRequiredWrap.classList.remove('is-auto');
          }
        }
        this.applySetupFeeRule();
        this.renderArtworkPreview();
        this.renderPositionAssignments();
        this.renderLogoAssignments();
        this.renderPositionChoices(this.getSelectedPositions());
        this.applyTextModeVisibility();
        this.updateSetupNoteTitle();
      }

      updateSetupNoteTitle() {
        const assignments = this.getCurrentAssignments();
        const setupUnits = this.getSetupUnitsForAssignments(assignments);
        const feeCents = assignments.reduce(
          (maxFee, assignment) =>
            Math.max(maxFee, Number(assignment?.option?.setupFeeCents) > 0 ? this.digitisationFeeUnitCents : 0),
          0
        );
        const totalFeeCents = feeCents > 0 && setupUnits > 0 ? feeCents * setupUnits : 0;
        const canShowWithinStep = !this.setupPanelElement || !this.setupPanelElement.hidden;
        const shouldShowNote = canShowWithinStep && totalFeeCents > 0;
        if (this.setupNoteElement) {
          this.setupNoteElement.hidden = !shouldShowNote;
          this.setupNoteElement.classList.toggle('hidden', !shouldShowNote);
        }
        if (!this.setupNoteTitleElement) return;
        if (totalFeeCents > 0) {
          if (setupUnits > 1) {
            this.setupNoteTitleElement.textContent = `${this.formatCents(totalFeeCents)} one-time setup cost (${setupUnits} logos)`;
          } else {
            this.setupNoteTitleElement.textContent = `${this.formatCents(totalFeeCents)} one-time setup cost`;
          }
        } else {
          this.setupNoteTitleElement.textContent = '';
        }
      }

      getSelectedPositions() {
        return Array.from(this.querySelectorAll('input[name="logo_positions"]:checked')).map((input) => input.value);
      }

      getSelectedMethod() {
        const selected = this.querySelector('input[name="logo_method"]:checked')?.value || '';
        if (selected) return selected;
        const fallback = this.normalizeChoiceKey(this.preferredMethodKey || '');
        return fallback || null;
      }

      getSelectedSizeTier() {
        return this.querySelector('input[name="logo_size_tier"]:checked')?.value || null;
      }

      formatLogoChoiceLabel(rawLabel, index = 0) {
        const fallback = `Logo ${index + 1}`;
        let label = String(rawLabel || '').trim();
        if (!label) return fallback;

        label = label.split('?')[0].split('#')[0];
        label = label.split('/').pop() || label;
        try {
          label = decodeURIComponent(label);
        } catch (error) {
          // keep raw label
        }
        label = label.replace(/\.(pdf|jpe?g|png|svg|webp|gif|ai|eps)$/i, '').trim();
        if (!label) return fallback;

        const isHashLike = /^[a-f0-9]{6,40}$/i.test(label);
        if (isHashLike) return fallback;

        if (label.length > 28) {
          return `${label.slice(0, 27).trim()}…`;
        }
        return label;
      }

      getSelectedLogoChoices() {
        const artworks = this.getSelectedLogoArtworks().slice(0, this.getLogoArtworkLimit());
        return artworks.map((artwork, index) => {
          const fallbackId = `logo_${index + 1}`;
          const identity = String(artwork?.identity || '').trim();
          return {
            id: identity || fallbackId,
            label: this.formatLogoChoiceLabel(artwork?.name || '', index),
            isImage:
              artwork?.kind === 'file'
                ? this.isImageArtworkFile(artwork.file)
                : this.isImageArtworkUrl(artwork?.url || ''),
            artwork,
          };
        });
      }

      resolvePositionLabel(candidate) {
        const normalized = String(candidate || '').trim().toLowerCase();
        if (!normalized) return '';
        const positions = this.getUniquePositionLabels();
        const directMatch = positions.find((label) => String(label || '').trim().toLowerCase() === normalized);
        return directMatch || '';
      }

      parseStoredAssignments(rawValue) {
        const raw = String(rawValue || '').trim();
        if (!raw) return [];
        try {
          const parsed = JSON.parse(raw);
          if (!Array.isArray(parsed)) return [];
          return parsed;
        } catch (error) {
          return [];
        }
      }

      syncPositionAssignments() {
        const selectedPositions = this.getSelectedPositions();
        const preferredGlobalMethod = this.normalizeChoiceKey(this.preferredMethodKey || this.getSelectedMethod());
        const logoChoices = this.getSelectedLogoChoices();
        const firstLogoId = logoChoices[0]?.id || '';
        const allowedLogoIds = new Set(logoChoices.map((choice) => choice.id));
        const normalizedAssignments = {};

        selectedPositions.forEach((positionLabel) => {
          const existing = this.positionAssignments?.[positionLabel] || {};
          const existingLogoId = String(existing.logoId || '').trim();
          const existingLogoSlot = Number.parseInt(existing.logoSlot || 0, 10);
          let logoId = firstLogoId;
          if (allowedLogoIds.has(existingLogoId)) {
            logoId = existingLogoId;
          } else if (Number.isFinite(existingLogoSlot) && existingLogoSlot > 0 && logoChoices[existingLogoSlot - 1]) {
            logoId = String(logoChoices[existingLogoSlot - 1].id || firstLogoId);
          }
          const logoSlot = Math.max(
            0,
            logoChoices.findIndex((choice) => String(choice.id || '') === String(logoId || '')) + 1
          );
          const availableMethods = this.getAvailableMethodsForPosition(positionLabel);
          const preferredMethod = this.normalizeChoiceKey(existing.methodKey || preferredGlobalMethod || '');
          const methodKey = availableMethods.includes(preferredMethod) ? preferredMethod : availableMethods[0] || '';
          const availableSizes = methodKey ? this.getAvailableSizesForSelection([positionLabel], methodKey) : [];
          const preferredSize = this.normalizeChoiceKey(existing.sizeKey || this.legacySizeTier || '');
          const sizeKey = availableSizes.includes(preferredSize) ? preferredSize : availableSizes[0] || '';

          normalizedAssignments[positionLabel] = {
            positionLabel,
            logoId,
            logoSlot,
            methodKey,
            sizeKey,
          };
        });

        this.positionAssignments = normalizedAssignments;
      }

      getCurrentAssignments() {
        this.syncPositionAssignments();
        const selectedPositions = this.getSelectedPositions();
        return selectedPositions.map((positionLabel) => {
          const assignment = this.positionAssignments[positionLabel] || {};
          const methodKey = this.normalizeChoiceKey(assignment.methodKey || '');
          const assignmentSizeKey = this.normalizeChoiceKey(assignment.sizeKey || this.legacySizeTier || '');
          const logoId = String(assignment.logoId || '').trim();
          const option = methodKey && assignmentSizeKey
            ? this.getOptionForPosition(positionLabel, methodKey, assignmentSizeKey)
            : null;
          const logoSlot = Number.parseInt(assignment.logoSlot || 0, 10);
          return {
            positionLabel,
            logoId,
            logoSlot: Number.isFinite(logoSlot) && logoSlot > 0 ? logoSlot : 0,
            methodKey,
            sizeKey: assignmentSizeKey,
            option,
            unitPriceCents: this.normaliseMetafieldPriceCents(option?.unitPriceCents || 0),
            setupFeeCents: Number(option?.setupFeeCents) > 0 ? this.digitisationFeeUnitCents : 0,
          };
        });
      }

      getLogoChoicePreview(choice) {
        if (!choice || !choice.artwork) {
          return { url: '', previewable: false };
        }
        const artwork = choice.artwork;
        if (artwork.kind === 'file') {
          const file = artwork.file;
          if (!file || !this.isImageArtworkFile(file)) return { url: '', previewable: false };
          const objectUrl = URL.createObjectURL(file);
          this.assignmentPreviewObjectUrls.push(objectUrl);
          return { url: objectUrl, previewable: true };
        }

        const artworkUrl = this.normalizeArtworkUrl(artwork.url || '');
        if (!artworkUrl || !this.isImageArtworkUrl(artworkUrl)) return { url: '', previewable: false };
        return { url: artworkUrl, previewable: true };
      }

      getPositionLogoVisualPreview(choice) {
        if (!choice || !choice.artwork) return { url: '', previewable: false };
        const artwork = choice.artwork;
        if (artwork.kind === 'file') {
          const file = artwork.file;
          if (!file || !this.isImageArtworkFile(file)) return { url: '', previewable: false };
          const objectUrl = URL.createObjectURL(file);
          this.positionVisualObjectUrls.push(objectUrl);
          return { url: objectUrl, previewable: true };
        }
        const artworkUrl = this.normalizeArtworkUrl(artwork.url || '');
        if (!artworkUrl || !this.isImageArtworkUrl(artworkUrl)) return { url: '', previewable: false };
        return { url: artworkUrl, previewable: true };
      }

      getPositionVisualScale(methodKey, sizeKey) {
        const size = this.normalizeChoiceKey(sizeKey || '');

        if (size === 'large') {
          return 0.32;
        }
        if (size === 'small') {
          return 0.2;
        }
        return 0.2;
      }

      getSetupUnitsForAssignments(assignments) {
        const logoChoices = this.getSelectedLogoChoices();
        const logoChoiceById = new Map(logoChoices.map((choice) => [choice.id, choice.artwork]));
        const usedArtworks = [];
        const seenLogos = new Set();
        (assignments || []).forEach((assignment) => {
          const logoId = String(assignment?.logoId || '').trim();
          if (!logoId || seenLogos.has(logoId)) return;
          seenLogos.add(logoId);
          const artwork = logoChoiceById.get(logoId);
          if (artwork) usedArtworks.push(artwork);
        });
        return this.getNonCustomerUniqueArtworkCount(usedArtworks);
      }

      createAssignmentTriggerButton(field, positionLabel, optionCount = 0) {
        const normalizedCount = Number.parseInt(optionCount, 10) || 0;
        if (normalizedCount <= 1) return null;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'logo-customiser__assignment-trigger';
        button.setAttribute('data-logo-assignment-trigger', '');
        button.setAttribute('data-logo-assignment-field', field);
        button.setAttribute('data-logo-assignment-position', positionLabel);
        button.setAttribute('aria-label', `Change ${field} for ${positionLabel}`);
        button.innerHTML =
          '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 3.2v9.6M3.2 8h9.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
        return button;
      }

      buildAssignmentSelectedLogoElement(assignment, logoChoices) {
        const selectedChoice = logoChoices.find((choice) => choice.id === assignment.logoId) || logoChoices[0] || null;
        const selectedWrap = document.createElement('span');
        selectedWrap.className = 'logo-customiser__assignment-selected logo-customiser__assignment-selected--logo';

        if (!selectedChoice) {
          selectedWrap.textContent = 'No logo';
          return selectedWrap;
        }

        const preview = this.getLogoChoicePreview(selectedChoice);
        if (preview.previewable && preview.url) {
          const image = document.createElement('img');
          image.className = 'logo-customiser__assignment-selected-logo-image';
          image.src = preview.url;
          image.alt = selectedChoice.label || 'Logo';
          image.loading = 'lazy';
          selectedWrap.appendChild(image);
        } else {
          const text = document.createElement('span');
          text.className = 'logo-customiser__assignment-selected-logo-text';
          text.textContent = selectedChoice.label || 'Logo';
          selectedWrap.appendChild(text);
        }
        return selectedWrap;
      }

      buildAssignmentSelectedMethodElement(assignment) {
        const methodKey = this.normalizeChoiceKey(assignment?.methodKey || '');
        const selectedWrap = document.createElement('span');
        selectedWrap.className = 'logo-customiser__assignment-selected logo-customiser__assignment-selected--method';

        if (!methodKey) {
          selectedWrap.textContent = 'Select method';
          return selectedWrap;
        }

        const iconMarkup = this.getApplicationMethodIconMarkup(methodKey);
        if (iconMarkup) {
          const icon = document.createElement('span');
          icon.className = 'logo-customiser__assignment-selected-method-icon';
          icon.innerHTML = iconMarkup;
          selectedWrap.appendChild(icon);
        }

        const label = document.createElement('span');
        label.className = 'logo-customiser__assignment-selected-method-label';
        label.textContent = this.humanizeChoiceKey(methodKey);
        selectedWrap.appendChild(label);
        return selectedWrap;
      }

      buildAssignmentSelectedSizeElement(assignment) {
        const sizeKey = this.normalizeChoiceKey(assignment?.sizeKey || '');
        const selectedWrap = document.createElement('span');
        selectedWrap.className = 'logo-customiser__assignment-selected logo-customiser__assignment-selected--size';

        if (!sizeKey) {
          selectedWrap.textContent = 'Select size';
          return selectedWrap;
        }

        const main = document.createElement('span');
        main.className = 'logo-customiser__assignment-selected-size-main';
        main.textContent = this.humanizeChoiceKey(sizeKey);
        selectedWrap.appendChild(main);

        const sizeSubLabel = this.getSizeDimensionLabel(assignment?.methodKey || '', sizeKey);
        if (sizeSubLabel) {
          const sub = document.createElement('span');
          sub.className = 'logo-customiser__assignment-selected-size-sub';
          sub.textContent = sizeSubLabel;
          selectedWrap.appendChild(sub);
        }

        return selectedWrap;
      }

      buildLogoDropdownPreview(choice, classNames = {}) {
        const wrap = document.createElement('span');
        wrap.className = classNames.wrap || '';
        if (!choice) {
          const fallback = document.createElement('span');
          fallback.className = classNames.text || '';
          fallback.textContent = 'Logo';
          wrap.appendChild(fallback);
          return wrap;
        }

        const preview = this.getLogoChoicePreview(choice);
        if (preview.previewable && preview.url) {
          const image = document.createElement('img');
          image.className = classNames.image || '';
          image.src = preview.url;
          image.alt = choice.label || 'Logo';
          image.loading = 'lazy';
          wrap.appendChild(image);
          return wrap;
        }

        const text = document.createElement('span');
        text.className = classNames.text || '';
        text.textContent = 'Logo';
        wrap.appendChild(text);
        return wrap;
      }

      createLogoImageDropdownControl(positionLabel, logoChoices, selectedLogoId) {
        const root = document.createElement('span');
        root.className = 'logo-customiser__assignment-logo-dropdown';
        root.setAttribute('data-logo-image-select', '');

        const selectedChoice =
          logoChoices.find((choice) => String(choice.id) === String(selectedLogoId || '')) || logoChoices[0] || null;

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'logo-customiser__assignment-logo-dropdown-trigger';
        trigger.setAttribute('data-logo-image-select-trigger', '');
        trigger.setAttribute('data-logo-assignment-position', positionLabel);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-label', `Choose logo for ${positionLabel}`);

        const current = document.createElement('span');
        current.className = 'logo-customiser__assignment-logo-dropdown-current';
        current.appendChild(
          this.buildLogoDropdownPreview(selectedChoice, {
            wrap: 'logo-customiser__assignment-logo-dropdown-current-thumb',
            image: 'logo-customiser__assignment-logo-dropdown-current-image',
            text: 'logo-customiser__assignment-logo-dropdown-current-text',
          })
        );

        const caret = document.createElement('span');
        caret.className = 'logo-customiser__assignment-logo-dropdown-caret';
        caret.setAttribute('aria-hidden', 'true');

        trigger.appendChild(current);
        trigger.appendChild(caret);

        if (!Array.isArray(logoChoices) || logoChoices.length <= 1) {
          trigger.disabled = true;
          root.classList.add('is-fixed');
          root.appendChild(trigger);
          return root;
        }

        const menu = document.createElement('div');
        menu.className = 'logo-customiser__assignment-logo-dropdown-menu';
        menu.setAttribute('data-logo-image-select-menu', '');
        menu.hidden = true;

        logoChoices.forEach((choice, optionIndex) => {
          const option = document.createElement('button');
          option.type = 'button';
          option.className = 'logo-customiser__assignment-logo-dropdown-option';
          option.setAttribute('data-logo-image-select-option', '');
          option.setAttribute('data-logo-assignment-button', 'logo');
          option.setAttribute('data-logo-assignment-field', 'logo');
          option.setAttribute('data-logo-assignment-position', positionLabel);
          option.setAttribute('data-logo-assignment-value', choice.id);
          option.setAttribute('aria-label', `Use logo ${optionIndex + 1} for ${positionLabel}`);
          option.setAttribute('aria-pressed', choice.id === selectedChoice?.id ? 'true' : 'false');
          if (choice.id === selectedChoice?.id) option.classList.add('is-selected');

          const previewNode = this.buildLogoDropdownPreview(choice, {
            wrap: 'logo-customiser__assignment-logo-dropdown-option-thumb',
            image: 'logo-customiser__assignment-logo-dropdown-option-image',
            text: 'logo-customiser__assignment-logo-dropdown-option-text',
          });
          option.appendChild(previewNode);
          menu.appendChild(option);
        });

        root.appendChild(trigger);
        root.appendChild(menu);
        return root;
      }

      createAssignmentSelectControl(field, positionLabel, options, selectedValue) {
        const wrap = document.createElement('span');
        wrap.className = 'logo-customiser__assignment-select-wrap';

        const select = document.createElement('select');
        select.className = 'logo-customiser__assignment-select';
        select.setAttribute('data-logo-assignment-field', field);
        select.setAttribute('data-logo-assignment-position', positionLabel);
        select.setAttribute('aria-label', `Choose ${field} for ${positionLabel}`);

        const normalizedOptions = (Array.isArray(options) ? options : [])
          .map((option) => {
            if (!option || typeof option !== 'object') return null;
            const value = String(option.value || '').trim();
            const label = String(option.label || '').trim();
            if (!value || !label) return null;
            return { value, label };
          })
          .filter(Boolean);

        if (!normalizedOptions.length) {
          const unavailable = document.createElement('option');
          unavailable.value = '';
          unavailable.textContent = 'Unavailable';
          select.appendChild(unavailable);
          select.disabled = true;
          wrap.classList.add('is-fixed');
          wrap.appendChild(select);
          return wrap;
        }

        normalizedOptions.forEach((option) => {
          const el = document.createElement('option');
          el.value = option.value;
          el.textContent = option.label;
          select.appendChild(el);
        });

        const normalizedSelected = String(selectedValue || '').trim();
        const fallbackValue = normalizedOptions[0]?.value || '';
        const finalValue = normalizedOptions.some((option) => option.value === normalizedSelected)
          ? normalizedSelected
          : fallbackValue;
        select.value = finalValue;

        const isFixed = normalizedOptions.length <= 1;
        if (isFixed) {
          select.disabled = true;
          wrap.classList.add('is-fixed');
        } else {
          wrap.classList.add('is-changeable');
        }

        wrap.appendChild(select);
        return wrap;
      }

      renderPositionAssignments() {
        if (!this.assignmentWrapElement || !this.assignmentGridElement) return;
        this.closeAllLogoImageDropdowns();
        this.closeAssignmentPicker({ clearState: false });
        this.cleanupAssignmentPreviewObjectUrls();
        const positions = this.getSelectedPositions();
        if (!positions.length) {
          this.assignmentWrapElement.hidden = true;
          this.assignmentGridElement.innerHTML = '';
          return;
        }

        const logoChoices = this.getSelectedLogoChoices();
        const assignments = this.getCurrentAssignments();
        this.assignmentGridElement.innerHTML = '';
        this.assignmentWrapElement.hidden = false;

        // One self-contained card per position. A single shared preview pane
        // left a large void whenever only one or two positions were chosen, so
        // each row now carries its own garment preview instead.
        const table = document.createElement('div');
        table.className = 'logo-customiser__assignment-table';

        assignments.forEach((assignment) => {
          const row = document.createElement('div');
          row.className = 'logo-customiser__assignment-row';

          row.appendChild(this.buildAssignmentRowPreview(assignment, logoChoices));

          const main = document.createElement('div');
          main.className = 'logo-customiser__assignment-main';

          const positionTitle = document.createElement('span');
          positionTitle.className = 'logo-customiser__assignment-position-title';
          positionTitle.textContent = assignment.positionLabel;
          main.appendChild(positionTitle);

          const controls = document.createElement('div');
          controls.className = 'logo-customiser__assignment-controls';

          const availableMethods = this.getAvailableMethodsForPosition(assignment.positionLabel);
          const methodOptions = availableMethods.map((methodKey) => ({
            value: methodKey,
            label: this.humanizeChoiceKey(methodKey),
          }));
          controls.appendChild(
            this.buildAssignmentField(
              'Method',
              'method',
              assignment.positionLabel,
              methodOptions,
              assignment.methodKey
            )
          );

          const availableSizes = this.getAvailableSizesForSelection(
            [assignment.positionLabel],
            this.normalizeChoiceKey(assignment.methodKey)
          );
          const sizeOptions = availableSizes.map((sizeKey) => {
            const base = this.humanizeChoiceKey(sizeKey);
            const dimension = this.getSizeDimensionLabel(assignment.methodKey, sizeKey);
            return {
              value: sizeKey,
              label: dimension ? `${base} ${dimension}` : base,
            };
          });
          controls.appendChild(
            this.buildAssignmentField(
              this.getSizeFieldLabel(),
              'size',
              assignment.positionLabel,
              sizeOptions,
              assignment.sizeKey
            )
          );

          // Which logo goes on this position, as a third control on the row
          // rather than a separate list underneath. Only earns its place when
          // there is more than one logo to choose between.
          if (this.hasArtwork() && logoChoices.length > 1) {
            const logoField = document.createElement('div');
            logoField.className =
              'logo-customiser__assignment-field logo-customiser__assignment-field--logo';

            const logoLabel = document.createElement('span');
            logoLabel.className = 'logo-customiser__assignment-field-label';
            logoLabel.textContent = 'Logo';
            logoField.appendChild(logoLabel);

            const selected =
              logoChoices.find((choice) => choice.id === assignment.logoId) || logoChoices[0] || null;
            logoField.appendChild(
              this.createLogoImageDropdownControl(
                assignment.positionLabel,
                logoChoices,
                assignment.logoId || selected?.id || ''
              )
            );
            controls.appendChild(logoField);
          }

          main.appendChild(controls);
          row.appendChild(main);

          const priceWrap = document.createElement('div');
          priceWrap.className = 'logo-customiser__assignment-price-wrap';
          const priceLabel = document.createElement('span');
          priceLabel.className = 'logo-customiser__assignment-price-label';
          priceLabel.textContent = 'Per garment';
          const price = document.createElement('span');
          price.className = 'logo-customiser__assignment-price';
          price.textContent = Number.isFinite(assignment.unitPriceCents)
            ? this.formatCents(assignment.unitPriceCents)
            : 'Unavailable';
          priceWrap.appendChild(priceLabel);
          priceWrap.appendChild(price);
          row.appendChild(priceWrap);

          table.appendChild(row);
        });

        this.assignmentGridElement.appendChild(table);
      }

      /** A labelled select, so each control reads on its own without a header row. */
      buildAssignmentField(labelText, field, positionLabel, options, selectedValue) {
        const wrap = document.createElement('div');
        wrap.className = `logo-customiser__assignment-field logo-customiser__assignment-field--${field}`;
        if (options.length <= 1) wrap.classList.add('is-fixed');

        const label = document.createElement('span');
        label.className = 'logo-customiser__assignment-field-label';
        label.textContent = labelText;
        wrap.appendChild(label);

        wrap.appendChild(this.createAssignmentSelectControl(field, positionLabel, options, selectedValue));
        return wrap;
      }

      /**
       * Per-row garment preview. Shows the artwork once it exists; before that,
       * a box scaled to the chosen size so the size decision is still visible.
       */
      buildAssignmentRowPreview(assignment, logoChoices) {
        const wrap = document.createElement('span');
        wrap.className = 'logo-customiser__assignment-thumb';

        const imageUrl = this.getPositionImageUrl(assignment.positionLabel);
        if (!imageUrl) {
          wrap.classList.add('is-empty');
          return wrap;
        }

        // The overlay is positioned in percentages of the artwork, so it has to
        // sit in a frame that matches the rendered image exactly. Letterboxing
        // the image inside a fixed box would shift the focal point off target.
        const frame = document.createElement('span');
        frame.className = 'logo-customiser__assignment-thumb-frame';

        const image = document.createElement('img');
        image.className = 'logo-customiser__assignment-thumb-image';
        image.src = imageUrl;
        image.alt = assignment.positionLabel;
        image.loading = 'lazy';
        frame.appendChild(image);
        wrap.appendChild(frame);

        const focalPoint = this.getPositionImageFocalPoint(assignment.positionLabel) || { x: 50, y: 50 };
        const scale = String(this.getPositionVisualScale(assignment.methodKey, assignment.sizeKey));
        const selectedChoice =
          (logoChoices || []).find((choice) => choice.id === assignment.logoId) || (logoChoices || [])[0] || null;
        const logoPreview = this.getLogoChoicePreview(selectedChoice);

        const overlay = document.createElement('span');
        overlay.style.left = `${focalPoint.x}%`;
        overlay.style.top = `${focalPoint.y}%`;
        overlay.style.setProperty('--logo-visual-scale', scale);

        // In text mode the garment preview shows the typed lines in the chosen
        // font and colour, at the same focal point a logo would occupy.
        if (this.isTextMode()) {
          const lines = this.getTextLines();
          if (lines.length) {
            overlay.className = 'logo-customiser__assignment-thumb-text';
            overlay.style.fontFamily = this.getTextFont().stack || 'inherit';
            // Match the logo path: Small and Large should not look identical.
            overlay.style.setProperty(
              '--logo-visual-scale',
              String(this.getPositionVisualScale(assignment.methodKey, assignment.sizeKey))
            );
            lines.forEach((line, lineIndex) => {
              const row = document.createElement('span');
              row.textContent = line;
              row.style.color = this.getTextColour(lineIndex).hex || '#111111';
              overlay.appendChild(row);
            });
          } else {
            overlay.className = 'logo-customiser__assignment-thumb-box';
            overlay.setAttribute('aria-hidden', 'true');
          }
          frame.appendChild(overlay);
          return wrap;
        }

        if (logoPreview.previewable && logoPreview.url && assignment.sizeKey) {
          overlay.className = 'logo-customiser__assignment-thumb-logo';
          const logoImage = document.createElement('img');
          logoImage.className = 'logo-customiser__assignment-thumb-logo-image';
          logoImage.src = logoPreview.url;
          logoImage.alt = selectedChoice?.label || 'Logo preview';
          logoImage.loading = 'lazy';
          overlay.appendChild(logoImage);
        } else {
          overlay.className = 'logo-customiser__assignment-thumb-box';
          overlay.setAttribute('aria-hidden', 'true');
        }

        frame.appendChild(overlay);
        return wrap;
      }

      /**
       * Step 3 companion to the method/size table: maps each position to one of
       * the uploaded logos. Hidden entirely for the common single-logo order,
       * where there is nothing to decide.
       */
      /**
       * Superseded by the per-row Logo control on the method/size table, which
       * puts the choice next to the method and size it belongs with. Kept as a
       * no-op because seven call sites still invoke it; it only has to make
       * sure the old standalone list stays out of the way.
       */
      renderLogoAssignments() {
        if (!this.logoAssignmentWrapElement || !this.logoAssignmentListElement) return;
        this.logoAssignmentWrapElement.hidden = true;
        this.logoAssignmentListElement.innerHTML = '';
      }

      handleAssignmentFieldChange(target) {
        const field = String(target?.dataset?.logoAssignmentField || '').trim().toLowerCase();
        const positionLabel = this.resolvePositionLabel(target?.dataset?.logoAssignmentPosition || '');
        if (!field || !positionLabel) return;

        // Keep the left preview synced to the row the customer is actively editing.
        this.assignmentPreviewPositionLabel = positionLabel;

        if (!this.positionAssignments[positionLabel]) {
          this.positionAssignments[positionLabel] = {
            positionLabel,
            logoId: '',
            logoSlot: 0,
            methodKey: '',
            sizeKey: '',
          };
        }

        const nextValue = String(target?.dataset?.logoAssignmentValue || target?.value || '').trim();
        if (field === 'logo') {
          this.positionAssignments[positionLabel].logoId = nextValue;
          const logoChoices = this.getSelectedLogoChoices();
          const selectedIndex = logoChoices.findIndex((choice) => String(choice.id || '') === nextValue);
          this.positionAssignments[positionLabel].logoSlot = selectedIndex >= 0 ? selectedIndex + 1 : 0;
        } else if (field === 'method') {
          const nextMethod = this.normalizeChoiceKey(nextValue);
          this.positionAssignments[positionLabel].methodKey = nextMethod;
          const availableSizes = nextMethod ? this.getAvailableSizesForSelection([positionLabel], nextMethod) : [];
          const currentSize = this.normalizeChoiceKey(this.positionAssignments[positionLabel].sizeKey || '');
          this.positionAssignments[positionLabel].sizeKey = availableSizes.includes(currentSize) ? currentSize : availableSizes[0] || '';
        } else if (field === 'size') {
          this.positionAssignments[positionLabel].sizeKey = this.normalizeChoiceKey(nextValue);
        }

        this.syncPositionAssignments();
        this.renderPositionAssignments();
        this.renderLogoAssignments();
        this.renderPositionChoices(this.getSelectedPositions());
        this.updateTypeVisibility();
        this.updateSelectionSummary();
        this.updateStepUI();
      }

      updateSizeLabels() {
        this.refreshDynamicChoiceOptions();
      }

      updateSelectionSummary() {
        const positions = this.getSelectedPositions();
        const assignments = this.getCurrentAssignments();
        const methodValues = Array.from(new Set(assignments.map((assignment) => this.normalizeChoiceKey(assignment.methodKey)).filter(Boolean)));
        const method = methodValues.length > 1 ? 'mixed' : methodValues[0] || '';
        const sizeValues = Array.from(new Set(assignments.map((assignment) => assignment.sizeKey).filter(Boolean)));
        const sizeTier = sizeValues.length === 1 ? sizeValues[0] : '';
        const setupRequired = this.querySelector('[name="logo_setup_required"]')?.checked || false;
        const qty = this.getTargetQuantityTotal();

        if (this.statusElement) {
          const defaultLabel =
            this.statusElement.getAttribute('data-logo-status-default') ||
            this.statusElement.dataset.logoStatusDefault ||
            'Choose position(s)';
          this.statusElement.textContent = positions.length
            ? `${positions.length} position(s) selected`
            : defaultLabel;
        }

        if (this.summarySelectionElement) {
          const methodLabel =
            methodValues.length > 1
              ? methodValues.map((value) => this.humanizeChoiceKey(value)).join(' + ')
              : methodValues.length === 1
              ? this.humanizeChoiceKey(methodValues[0])
              : 'Not selected';
          // "Mixed" tells the shopper nothing about what they picked. List the
          // actual values instead — there are only ever a handful.
          const sizeLabel =
            sizeValues.length > 1
              ? sizeValues.map((value) => this.humanizeChoiceKey(value)).join(' + ')
              : sizeTier
              ? this.humanizeChoiceKey(sizeTier)
              : 'Not selected';
          const selectionRows = [
            {
              label: 'Positions',
              value: `${positions.length} selected`,
            },
            {
              label: 'Method',
              value: methodLabel,
            },
            {
              label: this.getSizeFieldLabel(),
              value: sizeLabel,
            },
          ];
          this.summarySelectionElement.innerHTML = `<span class="logo-customiser__summary-breakdown">${selectionRows
            .map(
              (row) =>
                `<span class="logo-customiser__summary-breakdown-row"><span class="logo-customiser__summary-breakdown-label">${row.label}</span><span class="logo-customiser__summary-breakdown-value">${row.value}</span></span>`
            )
            .join('')}</span>`;
        }

        if (!this.summaryChargeElement && !this.summarySetupElement) return;

        const canPriceExactly =
          positions.length &&
          method &&
          assignments.length &&
          assignments.every((assignment) => assignment.sizeKey) &&
          assignments.every((assignment) => assignment.option) &&
          qty;

        if (!canPriceExactly) {
          // Rather than a dead "Select options", show what the chosen positions
          // cost at their cheapest so the shopper can price up as they go.
          const estimate = positions.length
            ? this.getEstimateForPositions(positions)
            : { perItemCents: 0, setupMinCents: 0, setupMaxCents: 0, setupVaries: false };
          const setupLabel =
            estimate.setupMaxCents <= 0
              ? ''
              : estimate.setupVaries
              ? `up to ${this.formatCents(estimate.setupMaxCents)}`
              : this.formatCents(estimate.setupMaxCents);

          if (this.summaryChargeElement) {
            if (!positions.length || estimate.perItemCents <= 0) {
              this.summaryChargeElement.innerHTML =
                '<span class="logo-customiser__summary-muted">Choose a position to see pricing</span>';
            } else {
              const rows = [
                {
                  label: 'Per garment',
                  value: `from ${this.formatCents(estimate.perItemCents)}`,
                },
              ];
              if (qty) {
                rows.push({ label: 'Qty', value: String(qty) });
                rows.push({
                  label: 'Items total',
                  value: `from ${this.formatCents(Math.round(estimate.perItemCents * qty))}`,
                });
              }
              if (setupLabel) {
                rows.push({ label: 'One-off setup, per new logo', value: setupLabel });
              }

              this.summaryChargeElement.innerHTML = `<span class="logo-customiser__summary-breakdown">${rows
                .map(
                  (row) =>
                    `<span class="logo-customiser__summary-breakdown-row"><span class="logo-customiser__summary-breakdown-label">${row.label}</span><span class="logo-customiser__summary-breakdown-value">${row.value}</span></span>`
                )
                .join('')}<span class="logo-customiser__summary-estimate-note">Estimate — confirm method and size for the exact price.</span></span>`;
            }
          }

          if (this.summarySetupElement) {
            this.summarySetupElement.innerHTML = setupLabel
              ? `<span class="logo-customiser__summary-muted">${setupLabel}</span>`
              : '<span class="logo-customiser__summary-muted">Not required</span>';
          }
          return;
        }

        const pricing = this.buildPricingDetails(
          {
            positions,
            method,
            sizeTier,
            assignments,
            setupRequired,
            setupUnits: this.getSetupUnitsForAssignments(assignments),
          },
          qty
        );
        const perItemCents = Math.max(0, Number(pricing.extraPerItemCents) || 0);
        const lineItemsCents = Math.max(0, Math.round(perItemCents * qty));
        const setupCents = Math.max(0, Number(pricing.setupFeeCents) || 0);
        const setupUnits = Math.max(0, Number.parseInt(pricing.setupUnits, 10) || 0);
        const totalExtraCents = lineItemsCents + setupCents;

        if (this.summaryChargeElement) {
          const rows = [
            {
              label: 'Per garment',
              value: this.formatCents(perItemCents),
            },
            {
              label: 'Qty',
              value: String(qty),
            },
            {
              label: 'Items total',
              value: this.formatCents(lineItemsCents),
            },
          ];
          if (setupCents > 0) {
            rows.push({
              // Named per new logo so the charge does not read as a flat
              // basket fee. It is billed once per logo we have to digitise,
              // however many garments carry it.
              label:
                setupUnits > 1
                  ? `One-off setup (${setupUnits} new logos)`
                  : 'One-off setup (1 new logo)',
              value: this.formatCents(setupCents),
            });
          }
          rows.push({
            label: 'Total extra',
            value: this.formatCents(totalExtraCents),
            isTotal: true,
          });

          // Spell out the basis: these figures follow the storefront toggle,
          // while checkout always settles in tax-inclusive money.
          const basisNote = `<span class="logo-customiser__summary-basis">Shown ${this.vatBasisLabel()}${
            this.vatDisplayIncludesTax ? '' : ' \u00b7 VAT added at checkout'
          }</span>`;

          this.summaryChargeElement.innerHTML = `<span class="logo-customiser__summary-breakdown">${rows
            .map(
              (row) =>
                `<span class="logo-customiser__summary-breakdown-row${
                  row.isTotal ? ' logo-customiser__summary-breakdown-row--total' : ''
                }"><span class="logo-customiser__summary-breakdown-label">${row.label}</span><span class="logo-customiser__summary-breakdown-value">${row.value}</span></span>`
            )
            .join('')}${basisNote}</span>`;
        }
        if (this.summarySetupElement) {
          if (setupCents > 0) {
            this.summarySetupElement.innerHTML = `<span class="logo-customiser__summary-price">£${(
              setupCents / 100
            ).toFixed(2)}</span> <span class="logo-customiser__summary-unit">one-time${
              setupUnits > 1 ? ` (${setupUnits} logos)` : ''
            }</span>`;
          } else {
            this.summarySetupElement.innerHTML = '<span class="logo-customiser__summary-muted">Not required</span>';
          }
        }
      }

      collectPayload() {
        const positions = this.getSelectedPositions();

        if (!positions.length) {
          this.showError('Select at least one logo position.');
          return null;
        }

        // Text is priced like a logo but has no artwork and no setup fee, so it
        // takes its own short path rather than threading nulls through the rest.
        if (this.isTextMode()) {
          const textLines = this.getTextLines();
          if (!this.getFilledTextLines().length) {
            this.showError('Enter at least one line of text.');
            return null;
          }
          const textAssignments = this.getCurrentAssignments();
          if (
            !textAssignments.length ||
            textAssignments.some((a) => !this.normalizeChoiceKey(a.methodKey) || !a.sizeKey || !a.option)
          ) {
            this.showError('Choose a method and size for each selected position.');
            return null;
          }
          const textMethods = Array.from(
            new Set(textAssignments.map((a) => this.normalizeChoiceKey(a.methodKey)).filter(Boolean))
          );
          const textSizes = Array.from(new Set(textAssignments.map((a) => a.sizeKey).filter(Boolean)));

          return {
            customisationType: 'text',
            positions,
            method: textMethods.length === 1 ? textMethods[0] : textMethods.length > 1 ? 'mixed' : '',
            sizeTier: textSizes.length === 1 ? textSizes[0] : textSizes.length > 1 ? 'mixed' : '',
            assignments: textAssignments.map((a) => ({
              positionLabel: a.positionLabel,
              logoId: 'text',
              logoSlot: 0,
              methodKey: this.normalizeChoiceKey(a.methodKey),
              sizeKey: a.sizeKey,
            })),
            textLines,
            textFont: this.getTextFont(),
            textColour: this.getTextColour(),
            textColours: this.getTextColours(),
            logoFiles: [],
            logoArtworks: [],
            logoArtworkUrls: [],
            logoArtworkNames: [],
            notes: (this.querySelector('[name="logo_notes"]')?.value || '').trim(),
            setupRequired: false,
            setupUnits: 0,
          };
        }

        const artworkLimit = this.getLogoArtworkLimit(positions);
        const logoArtworks = this.getSelectedLogoArtworks().slice(0, artworkLimit);
        const logoFiles = logoArtworks
          .filter((artwork) => artwork?.kind === 'file' && artwork.file)
          .map((artwork) => artwork.file);
        const logoArtworkUrls = logoArtworks
          .filter((artwork) => artwork?.kind === 'url')
          .map((artwork) => this.normalizeArtworkUrl(artwork.url))
          .filter(Boolean);
        const logoArtworkNames = logoArtworks.map((artwork, index) => {
          if (artwork?.name) return String(artwork.name || '').trim();
          if (artwork?.kind === 'url') return this.getArtworkDisplayName(artwork.url, `Logo ${index + 1}`);
          if (artwork?.kind === 'file') return String(artwork.file?.name || '').trim() || `Logo ${index + 1}`;
          return `Logo ${index + 1}`;
        });
        const logoArtworkUrl = logoArtworkUrls[0] || '';
        const logoArtworkName = logoArtworkNames[0] || '';
        const assignments = this.getCurrentAssignments();
        const methodValues = Array.from(new Set(assignments.map((assignment) => this.normalizeChoiceKey(assignment.methodKey)).filter(Boolean)));
        const method = methodValues.length === 1 ? methodValues[0] : methodValues.length > 1 ? 'mixed' : '';
        const sizeValues = Array.from(new Set(assignments.map((assignment) => assignment.sizeKey).filter(Boolean)));
        const sizeTier = sizeValues.length === 1 ? sizeValues[0] : sizeValues.length > 1 ? 'mixed' : '';
        const setupUnits = this.getSetupUnitsForAssignments(assignments);
        const choiceOrderById = new Map(
          this.getSelectedLogoChoices().map((choice, index) => [String(choice.id || ''), index + 1])
        );

        if (logoArtworks.length > artworkLimit) {
          this.showError(`You can upload up to ${artworkLimit} artwork file${artworkLimit === 1 ? '' : 's'} for the selected position(s).`);
          return null;
        }

        if (logoFiles.some((file) => !this.isAllowedLogoArtworkFile(file))) {
          this.showError('Please upload PDF, JPG, JPEG, or PNG files only.');
          return null;
        }

        if (!logoArtworks.length) {
          this.showError('Upload a logo file before saving.');
          return null;
        }

        if (!assignments.length || assignments.length !== positions.length) {
          this.showError('Assign a logo to each selected position.');
          return null;
        }

        if (assignments.some((assignment) => !assignment.logoId)) {
          this.showError('Select a logo for each position.');
          return null;
        }

        if (assignments.some((assignment) => !this.normalizeChoiceKey(assignment.methodKey))) {
          this.showError('Select a method for each position.');
          return null;
        }

        if (assignments.some((assignment) => !assignment.sizeKey || !assignment.option)) {
          this.showError('Select a valid size for each position.');
          return null;
        }

        const notes = (this.querySelector('[name="logo_notes"]')?.value || '').trim();
        const setupRequired = setupUnits > 0;

        // Only the logos actually placed on a position travel with the order.
        // Uploading three files and assigning two left the spare one in the
        // saved artwork, so the cart and checkout showed three thumbnails for a
        // two-logo job. Validation above still runs against everything the
        // shopper uploaded, so an empty upload is still caught.
        const assignedLogoIds = new Set(
          assignments.map((assignment) => String(assignment?.logoId || '').trim().toLowerCase()).filter(Boolean)
        );
        const usedArtworks = assignedLogoIds.size
          ? logoArtworks.filter((artwork) => {
              const identity = String(artwork?.identity || '').trim().toLowerCase();
              // An artwork with no identity cannot be matched, so it is kept
              // rather than silently dropped.
              return !identity || assignedLogoIds.has(identity);
            })
          : logoArtworks;
        const usedFiles = usedArtworks
          .filter((artwork) => artwork?.kind === 'file' && artwork.file)
          .map((artwork) => artwork.file);
        const usedArtworkUrls = usedArtworks
          .filter((artwork) => artwork?.kind === 'url')
          .map((artwork) => this.normalizeArtworkUrl(artwork.url))
          .filter(Boolean);
        const usedArtworkNames = usedArtworks.map((artwork, index) => {
          if (artwork?.name) return String(artwork.name || '').trim();
          if (artwork?.kind === 'url') return this.getArtworkDisplayName(artwork.url, `Logo ${index + 1}`);
          if (artwork?.kind === 'file') return String(artwork.file?.name || '').trim() || `Logo ${index + 1}`;
          return `Logo ${index + 1}`;
        });
        // Slots renumber over what is kept, so they stay 1..n with no gap where
        // a dropped logo used to sit.
        // Lower-cased to match how assignedLogoIds compares identities above;
        // an exact-case key silently missed and fell back to the stale slot.
        const usedSlotById = new Map(
          usedArtworks.map((artwork, index) => [String(artwork?.identity || '').trim().toLowerCase(), index + 1])
        );

        return {
          customisationType: 'logo',
          positions,
          method,
          sizeTier,
          assignments: assignments.map((assignment) => {
            const usedSlot = Number.parseInt(usedSlotById.get(String(assignment.logoId || '').trim().toLowerCase()) || 0, 10);
            const derivedSlot = Number.parseInt(choiceOrderById.get(String(assignment.logoId || '')) || 0, 10);
            const explicitSlot = Number.parseInt(assignment?.logoSlot || 0, 10);
            const logoSlot = Number.isFinite(usedSlot) && usedSlot > 0
              ? usedSlot
              : Number.isFinite(explicitSlot) && explicitSlot > 0
              ? explicitSlot
              : Math.max(0, derivedSlot || 0);
            return {
              positionLabel: assignment.positionLabel,
              logoId: assignment.logoId,
              logoSlot,
              methodKey: this.normalizeChoiceKey(assignment.methodKey),
              sizeKey: assignment.sizeKey,
            };
          }),
          logoFiles: usedFiles,
          logoArtworks: usedArtworks,
          logoArtworkUrl: usedArtworkUrls[0] || '',
          logoArtworkUrls: usedArtworkUrls,
          logoArtworkName: usedArtworkNames[0] || '',
          logoArtworkNames: usedArtworkNames,
          notes,
          setupRequired,
          setupUnits,
        };
      }

      buildProperties(existingProperties, payload, pricing, customiserToken) {
        const nextProperties = {};

        Object.entries(existingProperties || {}).forEach(([key, value]) => {
          if (value === '' || value === null || typeof value === 'undefined') return;
          if (key.startsWith('_logo_')) return;
          nextProperties[key] = value;
        });
        [
          'Logo Added',
          'Logo Positions',
          'Logo Method',
          'Logo Size',
          'Logo Type',
          'Logo Setup Required',
          'Logo Artwork',
          'Logo Artwork Source',
          'Logo Artwork Filename',
          'Logo Text Line 1',
          'Logo Text Line 2',
          'Logo Text Line 3',
          'Logo Text Font',
          'Logo Text Colour',
          'Logo Notes',
          'Logo Group',
          'Logo Placement',
          'Logo Assignments',
        ].forEach((key) => {
          delete nextProperties[key];
        });

        nextProperties._logo_added = 'yes';
        nextProperties._logo_positions = payload.positions.join('|');
        nextProperties._logo_method = String(payload.method || '');
        nextProperties._logo_size_tier = String(payload.sizeTier || '');
        nextProperties._logo_assignments_json = JSON.stringify(
          Array.isArray(payload.assignments) ? payload.assignments : []
        );
        nextProperties._logo_type = payload.customisationType === 'text' ? 'text' : 'logo';
        nextProperties._logo_price_unit_cents = String(pricing.unitCents || 0);
        nextProperties._logo_positions_count = String(pricing.positionsCount || 0);
        nextProperties._logo_setup_units = String(pricing.setupUnits || 0);
        nextProperties._logo_setup_fee_unit_cents = String(pricing.setupFeeUnitCents || 0);
        nextProperties._logo_setup_fee_cents = String(pricing.setupFeeCents || 0);
        nextProperties._logo_setup_group_fee_cents = String(pricing.setupGroupFeeCents || pricing.setupFeeCents || 0);
        nextProperties._logo_extra_per_item_cents = String(pricing.extraPerItemCents || 0);
        nextProperties._logo_extra_per_item_gross_cents = String(pricing.extraPerItemGrossCents || 0);
        nextProperties._logo_price_basis = 'exclusive';

        // No customer-facing property: every logo field is `_logo_*`, so none of
        // it renders at checkout. Deleted rather than simply not written, so
        // re-saving a line that was configured while the visible property
        // existed clears it too.
        delete nextProperties[CUSTOMISATION_COST_PROPERTY];

        // Text customisation. Cleared first so switching a line back to a logo
        // does not leave stale text behind on the cart line.
        delete nextProperties._logo_text_line_1;
        delete nextProperties._logo_text_line_2;
        delete nextProperties._logo_text_line_3;
        delete nextProperties._logo_text_lines;
        delete nextProperties._logo_text_font;
        delete nextProperties._logo_text_font_label;
        delete nextProperties._logo_text_colour;
        delete nextProperties._logo_text_colour_label;
        delete nextProperties._logo_text_colours;
        delete nextProperties._logo_text_colour_labels;
        [1, 2, 3].forEach((slot) => {
          delete nextProperties[`_logo_text_colour_${slot}`];
          delete nextProperties[`_logo_text_colour_label_${slot}`];
        });

        if (payload.customisationType === 'text') {
          nextProperties._logo_type = 'text';
          (payload.textLines || []).slice(0, 3).forEach((line, index) => {
            nextProperties[`_logo_text_line_${index + 1}`] = line;
          });
          nextProperties._logo_text_lines = (payload.textLines || []).join('|');
          nextProperties._logo_text_font = payload.textFont?.value || '';
          nextProperties._logo_text_font_label = payload.textFont?.label || '';
          // One colour per line. The unsuffixed keys stay as line one so
          // anything reading the original single-colour property still works.
          const textColours = Array.isArray(payload.textColours) && payload.textColours.length
            ? payload.textColours
            : [payload.textColour].filter(Boolean);
          textColours.slice(0, 3).forEach((entry, index) => {
            nextProperties[`_logo_text_colour_${index + 1}`] = entry?.value || '';
            nextProperties[`_logo_text_colour_label_${index + 1}`] = entry?.label || '';
          });
          nextProperties._logo_text_colours = textColours.map((entry) => entry?.value || '').join('|');
          nextProperties._logo_text_colour_labels = textColours.map((entry) => entry?.label || '').join('|');
          nextProperties._logo_text_colour = textColours[0]?.value || payload.textColour?.value || '';
          nextProperties._logo_text_colour_label =
            textColours[0]?.label || payload.textColour?.label || '';
        }
        const artworkLimit = this.getLogoArtworkLimit(payload.positions);
        const logoArtworks = (Array.isArray(payload.logoArtworks) ? payload.logoArtworks : []).slice(0, artworkLimit);
        const normalizedArtworks = logoArtworks
          .map((artwork, index) => {
            if (!artwork || typeof artwork !== 'object') return null;
            if (artwork.kind === 'file' && artwork.file) {
              const fileName = String(artwork.file?.name || '').trim();
              return {
                kind: 'file',
                file: artwork.file,
                name: fileName || `Logo ${index + 1}`,
                fromCustomerMetafield: false,
              };
            }
            const url = this.normalizeArtworkUrl(artwork.url);
            if (!url) return null;
            return {
              kind: 'url',
              url,
              name: this.getArtworkDisplayName(url, artwork.name || `Logo ${index + 1}`),
              fromCustomerMetafield: this.isCustomerMetafieldArtworkUrl(url),
            };
          })
          .filter(Boolean);

        delete nextProperties._logo_artwork;
        delete nextProperties._logo_artwork_2;
        delete nextProperties._logo_artwork_3;
        delete nextProperties._logo_artwork_url;
        delete nextProperties._logo_artwork_urls;

        if (normalizedArtworks.length) {
          const artworkDisplayNames = normalizedArtworks.map((artwork) => String(artwork.name || '').trim()).filter(Boolean);
          const artworkUrls = normalizedArtworks
            .filter((artwork) => artwork.kind === 'url')
            .map((artwork) => this.toAbsoluteArtworkUrl(artwork.url))
            .filter(Boolean);
          normalizedArtworks.forEach((artwork, index) => {
            if (artwork.kind !== 'url') return;
            const key = index === 0 ? '_logo_artwork' : `_logo_artwork_${index + 1}`;
            nextProperties[key] = this.toAbsoluteArtworkUrl(artwork.url);
          });
          nextProperties._logo_artwork_url = artworkUrls[0] || '';
          nextProperties._logo_artwork_urls = artworkUrls.join('|');
          nextProperties._logo_artwork_filename = artworkDisplayNames[0] || '';
          nextProperties._logo_artwork_filenames = artworkDisplayNames.join('|');
          nextProperties._logo_artwork_count = String(normalizedArtworks.length);
          const hasUploadArtwork = normalizedArtworks.some((artwork) => artwork.kind === 'file');
          const allFromCustomerMetafield =
            !hasUploadArtwork &&
            normalizedArtworks.length > 0 &&
            normalizedArtworks.every((artwork) => artwork.kind === 'url' && artwork.fromCustomerMetafield);
          nextProperties._logo_artwork_source = hasUploadArtwork
            ? 'upload'
            : allFromCustomerMetafield
            ? 'customer_metafield'
            : 'url';
        } else {
          delete nextProperties._logo_artwork_filename;
          delete nextProperties._logo_artwork_filenames;
          delete nextProperties._logo_artwork_count;
          delete nextProperties._logo_artwork_source;
        }
        // One entry per logo that carries a setup fee. new-logo-cart-pricing.js
        // unions these across every line, so the same artwork configured in two
        // separate sessions is billed once.
        //
        // Only logos actually assigned to a position are digitised, so only
        // those are hashed. An uploaded file left unassigned was still being
        // listed here, and the fee line counts hashes while _logo_setup_units
        // counts assigned logos — so three uploads with two of them placed
        // billed three digitisations against a line that declared two.
        const assignedLogoIds = new Set(
          (Array.isArray(payload.assignments) ? payload.assignments : [])
            .map((assignment) => String(assignment?.logoId || '').trim().toLowerCase())
            .filter(Boolean)
        );
        const setupIdentities = [];
        normalizedArtworks.forEach((artwork, index) => {
          if (artwork.fromCustomerMetafield) return;
          const source = logoArtworks[index] || artwork;
          const artworkIdentity = String(source?.identity || '').trim().toLowerCase();
          // No assignments recorded (or an artwork with no identity) keeps the
          // old behaviour rather than silently dropping the fee.
          if (assignedLogoIds.size && artworkIdentity && !assignedLogoIds.has(artworkIdentity)) return;
          const identity = this.resolveArtworkSetupIdentity(
            artwork.kind === 'file' ? artwork : source,
            index
          );
          if (identity && !setupIdentities.includes(identity)) setupIdentities.push(identity);
        });
        if (setupIdentities.length) {
          nextProperties._logo_setup_hashes = setupIdentities.join('|');
        } else {
          delete nextProperties._logo_setup_hashes;
        }

        nextProperties._logo_setup_required = payload.setupRequired ? 'yes' : 'no';

        if (payload.notes) {
          nextProperties._logo_notes = payload.notes;
        } else {
          delete nextProperties._logo_notes;
        }

        if (this.customisationGroup) {
          nextProperties._logo_customisation_group = this.customisationGroup;
        }

        const resolvedCustomiserToken = String(customiserToken || existingProperties?._logo_customiser_token || '').trim();
        if (resolvedCustomiserToken) {
          nextProperties._logo_customiser_token = resolvedCustomiserToken;
        } else {
          delete nextProperties._logo_customiser_token;
        }

        return nextProperties;
      }

      async removeLegacyChargeLines(cart) {
        const chargeLines = (cart.items || []).filter(
          (item) =>
            item.properties &&
            (item.properties._logo_charge_type != null || item.properties._logo_parent_key != null)
        );

        for (const chargeLine of chargeLines) {
          await this.changeLineItem(chargeLine.key, 0);
        }
      }


      buildPricingDetails(payload, quantity) {
        const positions = payload.positions || [];
        const assignmentList = Array.isArray(payload.assignments) ? payload.assignments : [];
        const positionsCount = assignmentList.length || positions.length;
        const pricingRows = assignmentList.length
          ? assignmentList.map((assignment) =>
              this.getOptionForPosition(
                assignment.positionLabel,
                this.normalizeChoiceKey(assignment.methodKey || payload.method || ''),
                this.normalizeChoiceKey(assignment.sizeKey || '')
              )
            )
          : this.getPricingRows(positions, payload.method, payload.sizeTier);
        if (pricingRows.length !== positionsCount || pricingRows.some((row) => !row)) {
          return {
            unitCents: 0,
            positionsCount,
            setupFeeUnitCents: 0,
            setupUnits: 0,
            setupFeeCents: 0,
            extraPerItemCents: 0,
            extraPerItemGrossCents: 0,
          };
        }
        const extraPerItemCents = pricingRows.reduce(
          (sum, row) => sum + this.normaliseMetafieldPriceCents(row.unitPriceCents || 0),
          0
        );
        // Carried alongside the exclusive amount for the cart transform function,
        // which has to add tax-inclusive money to a tax-inclusive line price.
        const extraPerItemGrossCents = pricingRows.reduce(
          (sum, row) => sum + this.grossMetafieldPriceCents(row.unitPriceCents || 0),
          0
        );
        const unitCents = positionsCount > 0 ? Math.round(extraPerItemCents / positionsCount) : 0;
        const setupFeeUnitCents = payload.setupRequired
          ? pricingRows.reduce(
              (maxFee, row) => Math.max(maxFee, Number(row?.setupFeeCents) > 0 ? this.digitisationFeeUnitCents : 0),
              0
            )
          : 0;
        const setupUnits = Math.max(
          0,
          Number.parseInt(payload.setupUnits, 10) ||
            (assignmentList.length
              ? this.getSetupUnitsForAssignments(assignmentList)
              : this.getNonCustomerUniqueArtworkCount(payload.logoArtworks || this.getSelectedLogoArtworks()))
        );
        const setupFeeCents = setupFeeUnitCents > 0 ? setupFeeUnitCents * setupUnits : 0;

        return {
          unitCents,
          positionsCount,
          setupFeeUnitCents,
          setupUnits,
          setupFeeCents,
          extraPerItemCents,
          extraPerItemGrossCents,
        };
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.isSubmitting) return;

        this.clearError();
        const payload = this.collectPayload();
        if (!payload) return;

        this.isSubmitting = true;
        this.setLoading(true);

        try {
          const cartBefore = await this.fetchCart();
          const { items: targetItems } = this.resolveTargetItems(cartBefore);

          if (!targetItems.length) {
            throw new Error('This cart line no longer exists. Please return to cart and try again.');
          }

          await this.removeLegacyChargeLines(cartBefore);

          let changedCart = null;
          const submitTokenSeed = `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
          const sharedToken =
            targetItems.length > 1
              ? String(targetItems[0]?.properties?._logo_customiser_token || '').trim() || submitTokenSeed
              : '';
          const sharedSetupPricing = this.buildPricingDetails(payload, targetItems[0]?.quantity || 0);
          const sharedSetupFeeCents = payload.setupRequired ? Number(sharedSetupPricing.setupFeeCents) || 0 : 0;
          for (let index = 0; index < targetItems.length; index += 1) {
            const targetItem = targetItems[index];
            const payloadForTarget = index === 0 ? payload : { ...payload, setupRequired: false };
            const pricing = this.buildPricingDetails(payloadForTarget, targetItem.quantity);
            const lineToken =
              sharedToken ||
              String(targetItem?.properties?._logo_customiser_token || '').trim() ||
              `${submitTokenSeed}-${index}`;
            const properties = this.buildProperties(targetItem.properties || {}, payloadForTarget, pricing, lineToken);
            properties._logo_setup_group_fee_cents = String(sharedSetupFeeCents || 0);
            const hasUploadArtwork =
              Array.isArray(payload.logoArtworks) &&
              payload.logoArtworks.some((artwork) => artwork?.kind === 'file' && artwork.file);
            changedCart =
              hasUploadArtwork
                ? await this.changeLineItemWithFile(
                    targetItem.key,
                    targetItem.quantity,
                    properties,
                    Array.isArray(payload.logoArtworks) ? payload.logoArtworks : []
                  )
                : await this.changeLineItem(targetItem.key, targetItem.quantity, properties);
          }

          if (!changedCart) {
            throw new Error('Could not update the selected cart item. Please try again.');
          }
          const latestCart = await this.getFreshCartPayload(changedCart);

          if (this.isModalMode) {
            this.publishCartUpdate(latestCart);
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: {
                  cart: latestCart,
                  source: 'logo-customiser',
                },
              })
            );
            window.dispatchEvent(
              new CustomEvent('logo-customiser:saved', {
                detail: {
                  modalId: this.modalId || null,
                  cart: latestCart,
                },
              })
            );
            return;
          }

          if (window.self !== window.top) {
            window.parent.postMessage(
              {
                type: 'logo-customiser:saved',
                modalId: this.modalId || null,
              },
              window.location.origin
            );
            return;
          }

          window.location.href = '/cart';
        } catch (error) {
          console.error(error);
          this.showError(error.message || 'Unable to save your customisation right now. Please try again.');
        } finally {
          this.isSubmitting = false;
          this.setLoading(false);
        }
      }

      async fetchCart() {
        const baseCartUrl = String(this.routes.cart || '/cart.js');
        const cacheBypass = `_=${Date.now()}`;
        const cartUrl = `${baseCartUrl}${baseCartUrl.includes('?') ? '&' : '?'}${cacheBypass}`;
        const response = await fetch(cartUrl, {
          cache: 'no-store',
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to load cart.');
        }

        return response.json();
      }

      async getFreshCartPayload(changeResponseCart) {
        const freshCart = await this.fetchCart();
        if (changeResponseCart && typeof changeResponseCart === 'object') {
          if (changeResponseCart.sections && typeof changeResponseCart.sections === 'object') {
            freshCart.sections = changeResponseCart.sections;
          }
        }
        return freshCart;
      }

      getSectionsToBundle() {
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        return sectionsToBundle;
      }

      publishCartUpdate(cartPayload) {
        if (!cartPayload || typeof cartPayload !== 'object') return;
        if (!cartPayload.sections || typeof cartPayload.sections !== 'object') return;
        if (
          !window.FoxTheme ||
          !window.FoxTheme.pubsub ||
          !window.FoxTheme.pubsub.publish ||
          !window.FoxTheme.pubsub.PUB_SUB_EVENTS ||
          !window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate
        ) {
          return;
        }

        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: cartPayload,
        });
      }

      /**
       * Cart writes retried with backoff. Shopify throttles the cart endpoints
       * and answers 429 under a burst of saves, which reads to the shopper as
       * "too many attempts" and fails the save outright. change.js sets the
       * line's absolute state, so replaying the same request is safe.
       */
      async cartWrite(url, options, attempts = 3) {
        let response = null;
        for (let attempt = 0; attempt < attempts; attempt += 1) {
          response = await fetch(url, options);
          if (response.ok) return response;
          const worthRetrying = response.status === 429 || response.status >= 500;
          if (!worthRetrying || attempt === attempts - 1) return response;
          const after = Number.parseFloat(response.headers.get('Retry-After') || '');
          const waitMs = Number.isFinite(after) && after > 0
            ? Math.min(after * 1000, 8000)
            : Math.min(700 * 2 ** attempt, 5000);
          await new Promise((resolve) => setTimeout(resolve, waitMs));
        }
        return response;
      }

      async changeLineItem(id, quantity, properties) {
        const payload = { id, quantity };
        if (properties) {
          payload.properties = properties;
        }
        const sectionsToBundle = this.getSectionsToBundle();
        if (sectionsToBundle.length) {
          payload.sections = sectionsToBundle;
          payload.sections_url = window.location.pathname;
        }

        const response = await this.cartWrite(this.routes.change, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error('Failed to update cart item.');
        }

        return response.json();
      }

      async changeLineItemWithFile(id, quantity, properties, artworks) {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('quantity', String(quantity));
        const sectionsToBundle = this.getSectionsToBundle();
        if (sectionsToBundle.length) {
          formData.append('sections', sectionsToBundle.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        const slotKeys = new Set(['_logo_artwork', '_logo_artwork_2', '_logo_artwork_3']);
        Object.entries(properties || {}).forEach(([key, value]) => {
          if (value === '' || value === null || typeof value === 'undefined') return;
          if (slotKeys.has(key)) return;
          formData.append(`properties[${key}]`, String(value));
        });

        const artworkSlots = (Array.isArray(artworks) ? artworks : [])
          .map((artwork) => {
            if (!artwork || typeof artwork !== 'object') return null;
            if (artwork.kind === 'file' && artwork.file) {
              return { kind: 'file', file: artwork.file };
            }
            const url = this.toAbsoluteArtworkUrl(artwork.url);
            if (!url) return null;
            return { kind: 'url', url };
          })
          .filter(Boolean)
          .slice(0, 3);

        artworkSlots.forEach((artwork, index) => {
          const key = index === 0 ? '_logo_artwork' : `_logo_artwork_${index + 1}`;
          if (artwork.kind === 'file') {
            formData.append(`properties[${key}]`, artwork.file);
          } else {
            formData.append(`properties[${key}]`, artwork.url);
          }
        });

        const response = await this.cartWrite(this.routes.change, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        });

        if (!response.ok) {
          let message = 'Failed to upload logo and update cart item.';
          try {
            const errorJson = await response.json();
            if (errorJson?.description) message = errorJson.description;
          } catch (error) {
            console.error(error);
          }
          throw new Error(message);
        }

        return response.json();
      }

      setLoading(isLoading) {
        if (this.submitButton) {
          this.submitButton.classList.toggle('btn--loading', isLoading);
          if (!isLoading && !this.isSubmitting) {
            this.submitButton.removeAttribute('disabled');
          }
        }

        // Saving rewrites the cart line and re-renders sections, which can take
        // a moment. Cover the panel so the shopper can see it is working rather
        // than staring at an unchanged form.
        const savingOverlay = this.querySelector('[data-logo-saving]');
        if (savingOverlay) savingOverlay.hidden = !isLoading;
        this.classList.toggle('is-saving', Boolean(isLoading));
        this.setAttribute('aria-busy', isLoading ? 'true' : 'false');

        this.updateStepUI();
      }

      showError(message) {
        if (!this.errorElement) return;
        this.errorElement.hidden = !message;
        this.errorElement.textContent = message || '';
      }

      clearError() {
        this.showError('');
      }
    }
  );
}
